/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://cihost.uberflip.com/ecovadis-multi-v1/master/build/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 50);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  generateHeaderMenuLinks: function generateHeaderMenuLinks(arr) {
    return arr.map(function (link) {
      return '<a href="' + link.href + '">' + link.label + '</a>';
    }).join('');
  },
  createElem: function createElem(elemType, elemOptions, elemText) {
    var newElement = document.createElement(elemType);
    if (elemOptions !== undefined) {
      Object.keys(elemOptions).forEach(function (attr) {
        newElement.setAttribute(attr, elemOptions[attr]);
      });
    }
    if (elemText !== undefined) {
      newElement.innerText = elemText;
    }
    return newElement;
  }
};

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getParameterByName = getParameterByName;
exports.loadTiles = loadTiles;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var Sidebar = __webpack_require__(18);

// Uberflip Outsource OB-10258 start here
var updateSelectedLabel = function updateSelectedLabel() {
    var ulItems = document.querySelectorAll('.onBrand__filter--dropdown');

    if (ulItems) {
        ulItems.forEach(function (item) {
            var selectedCount = item.querySelectorAll('input[type="checkbox"]:checked').length;
            var selectedTitle = item.parentElement.querySelector('#onbrand__filter--select #filter-title');
            if (selectedCount && selectedTitle) {
                selectedTitle.innerHTML = selectedCount + ' selected';
            } else {
                var title = item.parentElement.querySelector('.onbrand__filter--title');
                if (title) {
                    var updatedLabel = title.innerHTML.replace("Browse by ", "").replace(":", "");
                    selectedTitle.innerHTML = 'Select: ' + updatedLabel;
                } else {
                    selectedTitle.innerHTML = 'Select';
                }
            }
        });
    }
};
// Uberflip Outsource OB-10258 end here

function isTagMatch(filters, tags) {
    updateSelectedLabel(); // Uberflip Outsource OB-10258
    var noFilterApplied = filters.length === 0;

    if (noFilterApplied) {
        return true;
    } else if (!noFilterApplied && !tags) {
        return false;
    }

    return filters.every(function (filter) {
        return tags.split(',').map(function (str) {
            return str.trim().toLowerCase();
        }) // Normalize tags
        .includes(filter.toLowerCase().trim());
    } // Compare normalized tag with normalized filter
    );
}

function getParameterByName(name) {
    var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location.href;

    var results = url.split(name);
    if (!results) {
        return null;
    }
    if (!results[1]) {
        return '';
    }

    return decodeURIComponent(results[1].replace(/-/g, ' '));
}

function addSelectedFilterToParam(selectedFilters) {

    var filterstring = selectedFilters.join('&');
    var replacedFilter = filterstring.split(' ').join('-');
    replacedFilter = replacedFilter.trim();
    var newURL = window.location.protocol + "//" + window.location.host + window.location.pathname + '?filterParams=' + encodeURIComponent(replacedFilter);
    window.history.pushState({ path: newURL }, '', newURL);
}

function tilesToDisplay(queryparamFilter) {

    var tiles = [].concat(_toConsumableArray(document.querySelectorAll('#collection-items .tile')));
    tiles.forEach(function (tile) {
        var tags = tile.dataset.tags;
        var tagMatch = isTagMatch(queryparamFilter, tags);
        var isCTA = tile.classList.contains('cta');
        if (!isCTA && tagMatch) {
            tile.classList.remove('hide');
            tile.style.setProperty('display', 'block', 'important');
            tile.style.setProperty('opacity', '1', 'important');
        } else if (isCTA || !tagMatch) {
            tile.classList.add('hide');
            tile.style.setProperty('display', 'none', 'important');
            tile.style.setProperty('opacity', '0', 'important');
        }
    });
}

function loadTiles() {

    var body = document.querySelector('body');
    var queryParamExists = getParameterByName('filterParams=');
    var queryparamFilter = [];
    if (queryParamExists) {
        if (queryParamExists.indexOf("&") !== -1) {
            queryparamFilter = queryParamExists.split("&");
        } else {
            queryparamFilter[0] = queryParamExists;
        }
        if (queryparamFilter.length > 0) {
            for (var i = 0; i < queryparamFilter.length; i++) {
                var checkValue = queryparamFilter[i];
                $('input:checkbox[value="' + checkValue + '"]').prop('checked', true);
            }

            tilesToDisplay(queryparamFilter);
        }
    }
    if (!queryparamFilter.length) {
        body.classList.remove('onBrand__filter--active');
    } else {
        body.classList.add('onBrand__filter--active');
    }
}

function handleCheckboxChange() {

    var body = document.querySelector('body');
    updateSelectedLabel(); // Uberflip Outsource OB-10258
    var selectedFilters = [].concat(_toConsumableArray(document.querySelectorAll('#onBrand__filter--form input[type=checkbox]:checked'))).map(function (el) {
        return el.value;
    });

    if (selectedFilters.length > 0) {

        //Function call to append the selected filter value to QuerySting
        addSelectedFilterToParam(selectedFilters);

        // Function call to get the Queryparam value
        var namestr = getParameterByName('filterParams=');
        var queryparamFilter = [];

        if (namestr) {
            if (namestr.indexOf("&") !== -1) {
                queryparamFilter = namestr.split("&");
            } else {
                queryparamFilter[0] = namestr;
            }
        }
        if (queryparamFilter.length > 0) {
            tilesToDisplay(queryparamFilter);
        }
    } else {
        var newURL = window.location.protocol + "//" + window.location.host + window.location.pathname;
        window.history.pushState({ path: newURL }, '', newURL);

        // No checkbox selected load all tiles
        var tiles = [].concat(_toConsumableArray(document.querySelectorAll('#collection-items .tile')));
        tiles.forEach(function (tile) {
            if (tile) {
                tile.style.setProperty('display', 'block', 'important');
                tile.style.setProperty('opacity', '1', 'important');
            }
        });
    }

    if (!selectedFilters.length) {
        body.classList.remove('onBrand__filter--active');
    } else {
        body.classList.add('onBrand__filter--active');
    }
}

function checkFilterPermissions() {

    // Check for the data our filter relies on, if it doesn't exist return immediately
    if (!window.filterConfig) {
        return;
    }

    var filterConfig = window.filterConfig;
    var filteredStreams = Object.keys(filterConfig);

    // checking if the stream ID for filtering exists on the body's datset tag
    // const currentStreamId = document.querySelector('body').dataset.streamId;
    var currentStreamId = document.querySelector('#page-type-identifier').dataset.collectionId;

    /* eslint-disable-next-line consistent-return */
    return filteredStreams.includes(currentStreamId) ? filterConfig[currentStreamId] : null;
}

function handleFilterInit() {

    (function init() {
        if (document.querySelector('body').classList.contains('listing-page') || document.querySelector('body').classList.contains('hub-page')) {

            var filterData = checkFilterPermissions();
            if (filterData) {
                $('#collection-items .collection-items-container').css('display', 'none');
                var filterSidebar = new Sidebar(filterData);
                filterSidebar.init().attatchEvents(handleCheckboxChange);
            }
        }
    })();
}

exports.handleFilterInit = handleFilterInit;
exports.handleCheckboxChange = handleCheckboxChange;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var alignItemLevel = exports.alignItemLevel = function alignItemLevel() {
    if (!window.obData || !window.obData.alignItems) {
        return;
    }
    var itemPageID = document.getElementById('page-type-identifier').dataset.itemId;
    if (window.obData && window.obData.alignItems) {
        var ccBlockObject = window.obData.alignItems;
        if (ccBlockObject) {
            var itemid = Object.keys(ccBlockObject);
            // if item ID is present and mentioned in the code block
            if (itemid.includes(itemPageID)) {
                var title = document.querySelector('article.entry-wrapper h1');
                if (title) {
                    title.style = 'text-align: ' + ccBlockObject[itemPageID];
                }
            }
        }
    }
};

//GWL Code OB-7749 starts here
function scrollcta() {
    var item = document.querySelector('.single-page');
    if (item) {
        if (window.outerWidth >= 1351) {
            var cta = document.querySelector('.cta-item-container .tile.single.cta');
            if (cta) {
                if (window.scrollY === 0 || window.scrollY < 150) {
                    cta.classList.remove('scrolled');
                } else {
                    cta.classList.add('scrolled');
                }
                var footer = document.querySelector('.related-items-container') ? document.querySelector('.related-items-container') : document.getElementById("injected-footer");
                if (footer && cta) {
                    var top = document.querySelector('.entry-wrapper') ? document.querySelector('.entry-wrapper').clientHeight - 150 : 50;
                    top = Math.sign(top) > 0 ? top : 0;
                    if (window.scrollY > top) {
                        cta.classList.remove('scrolled');
                    }
                }
            }
        } else {
            var mobileCta = document.querySelector('.cta-item-container .tile.single.cta');
            if (mobileCta) {
                mobileCta.classList.remove('scrolled');
            }
        }
    }
}
//GWL Code OB-7749 end here
function CTAshift() {
    var embedDOM = document.querySelector('.single-embed-wrapper');
    var entryWrapper = document.querySelector('article.entry-wrapper');
    if (embedDOM && entryWrapper) {
        entryWrapper.insertAdjacentElement('beforebegin', embedDOM);
        if (embedDOM.querySelector('block-cta')) {
            entryWrapper.classList.add('gated-cta');
        }
    }
}

function ctaResize() {
    var ctaContainer = document.querySelector('.cta-item-container');
    var itemContainer = document.querySelector('.item-level.with-cta .item-data');
    if (ctaContainer && itemContainer) {
        itemContainer.insertAdjacentElement('afterend', ctaContainer);
    }
}
exports.scrollcta = scrollcta;
exports.CTAshift = CTAshift;
exports.ctaResize = ctaResize;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (module) {
	if (!module.webpackPolyfill) {
		module.deprecate = function () {};
		module.paths = [];
		// module.parent = undefined by default
		if (!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function get() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function get() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var _require = __webpack_require__(1),
    getParameterByName = _require.getParameterByName,
    loadTiles = _require.loadTiles;
/**
 * The stored value from our ajax call (so we only ever need to make one)
 */


var memoizedValue = null;

/**
 * Convert the html returned by the server to a jquery object for filtering later
 * @param {string} tileHtml 
 */
var parseHtmlString = function parseHtmlString(tileHtml) {
    return $(tileHtml).filter('.tile');
};

/**
 * A memoized function that will return a jquery object of tiles from the server for the given stream
 */
var getTiles = function getTiles() {
    if (memoizedValue) {
        return Promise.resolve(memoizedValue.clone());
    }

    return new Promise(function (resolve, reject) {
        var collectionId = $('#page-type-identifier').attr('data-collection-id');
        var hubUrl = '';

        var hubId = document.querySelector('meta[name="uberflip:hub_id"]').content;

        if (hubId === '118316') {
            hubUrl = '/it';
        }
        if (hubId === '118319') {
            hubUrl = '/es';
        }
        if (hubId === '118322') {
            hubUrl = '/de';
        }
        if (hubId === '100549') {
            hubUrl = '/fr';
        }
        if (hubId === '132028') {
            hubUrl = '/ja';
        }

        $.get(hubUrl + '/hubsFront/ajax_loadAdditionalItems/?collectionId=' + collectionId + '&currentPage=-1&limit=0&featuredItemCount=0&embedded=0&excludeCTAs=true').success(function (data) {
            var parsedTiles = parseHtmlString(data);
            memoizedValue = parsedTiles.clone();
            var tileContainer = document.querySelector('#collection-items .collection-items-container');
            // in this sample request, the function will remove any tiles in the
            // stream's tileContainer and replace it with data from our fetch call

            var tiles = [].concat(_toConsumableArray(document.querySelectorAll('#collection-items .tile')));
            if (tiles) {
                // - Iterate over each tile
                tiles.forEach(function (tile) {
                    tile.remove();
                });
            }
            tileContainer.insertAdjacentHTML('beforeend', data);

            $('#collection-items .collection-items-container').css('display', 'block');
            $('#onBrand__filter-wrapper #onBrand__filter--form').css('display', 'flex'); // Uberflip Outsource OB-10258
            // document.querySelector('#onBrand__filter-wrapper .onBrand__filter--form').style.display = 'flex';
            var moveToTopBtn = document.getElementById('load-more');
            var liTags = document.querySelectorAll('li.tile:not(.cta)');
            if (liTags) {
                liTags.forEach(function (tags) {
                    tags.style.setProperty('display', 'block', 'important');
                    tags.style.setProperty('opacity', '1', 'important');
                });
            }
            if (moveToTopBtn) {
                moveToTopBtn.style.display = 'none';
            }
            resolve(parsedTiles.clone());
            if (getParameterByName('filterParams=')) {
                loadTiles();
            }
        }).fail(reject);
    });
};

module.exports = getTiles;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var handleFooter = function handleFooter() {
    function footerMenuToggle() {
        if (window.innerWidth <= 767) {
            var footerLinks = document.querySelectorAll('#footer-main-menu > .menu-item');
            if (footerLinks) {
                footerLinks.forEach(function (footerLink) {
                    footerLink.addEventListener('click', function (e) {
                        e.stopImmediatePropagation();
                        $(footerLink).find('.dropdown-menu').slideToggle();
                    });
                });
            }
        }
    }

    function init() {
        footerMenuToggle();
    }

    init();
};

function footerPlacement() {
    // setTimeout(function() {
    //     const footer = document.querySelectorAll('.injected-footer');
    //     const hubFooter = document.querySelector('#injected-footer');
    //     if (footer && hubFooter) {
    //         footer.forEach((hubs) => {
    //             hubFooter.insertAdjacentElement('afterbegin', hubs);
    //         });
    //     }
    // }, 50);
}

module.exports = { handleFooter: handleFooter, footerPlacement: footerPlacement };

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var handlePortugueseHeader = function handlePortugueseHeader() {
    if (!window.obData || !window.obData.portugueseHeaderStream) {
        return;
    }

    var streampage = document.querySelector('.listing-page');
    var itempage = document.querySelector('.single-page');
    if (streampage || itempage) {
        var streamPageID = document.getElementById('page-type-identifier').dataset.collectionId;
        if (streamPageID) {
            var config = window.obData.portugueseHeaderStream;
            if (config.includes(streamPageID)) {
                document.body.classList.add('ptheader');
                var enHeader = document.querySelector('.injected-header.en');
                var ptHeader = document.querySelector('.injected-header.pt');
                var enFooter = document.querySelector('.injected-footer.en');
                var ptFooter = document.querySelector('.injected-footer.pt');
                if (enHeader && ptHeader) {
                    enHeader.style.display = 'none';
                    ptHeader.style.display = 'block';
                }
                if (enFooter && ptFooter) {
                    enFooter.style.display = 'none';
                    ptFooter.style.display = 'block';
                }
            }
        }
    }
};

function mobileViewPTheader() {
    if (document.body.classList.contains('ptheader')) {
        var hamburgermenu = document.querySelector('.injected-header.pt .menu-toggle');
        if (hamburgermenu) {
            hamburgermenu.addEventListener('click', function () {
                document.querySelector('.injected-header.pt').classList.toggle('open');
                hamburgermenu.classList.toggle('open');
                document.querySelector('.injected-header.pt .menu-wrapper').classList.toggle('open');
            });
        }
        var level1menu = document.querySelectorAll('.injected-header.pt > .menu-item-has-children');
        if (level1menu) {
            level1menu.forEach(function (element) {
                element.addEventListener('click', function (e) {
                    if (!this.parentElement.classList.contains('open')) {
                        element.parentElement.classList.add('open');
                        element.nextElementSibling.classList.add('open');
                    } else {
                        element.parentElement.classList.remove('open');
                        element.nextElementSibling.classList.remove('open');
                    }
                });
            });
        }
    }
}
/* Uberflip GWL OB-9016 start here */
function handlescrollptheader() {
    if (document.body.classList.contains('ptheader')) {
        var header = document.querySelector('.injected-header.pt');
        if (header) {
            var scrollheader = window.scrollY;
            if (scrollheader > 1) {
                header.classList.add('scrolled');
            } else {
                header.classList.remove('scrolled');
            }
        }
    }
}
/* Uberflip GWL OB-9016 end here */

module.exports = { handlePortugueseHeader: handlePortugueseHeader, mobileViewPTheader: mobileViewPTheader, handlescrollptheader: handlescrollptheader };

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// -- Imports -- //
__webpack_require__(8); // use all the things!
var onbrandUtilityFunctions = __webpack_require__(9);
var devOptions = __webpack_require__(10); //Development options
var onbrandScss = __webpack_require__(11); //Onbrand styles
var clientScss = __webpack_require__(12); //client styles

var _require = __webpack_require__(13),
    loopTiles = _require.loopTiles;

var _require2 = __webpack_require__(14),
    addHyperLinkToFormCtas = _require2.addHyperLinkToFormCtas;

var _require3 = __webpack_require__(5),
    handleFooter = _require3.handleFooter;

var _require4 = __webpack_require__(15),
    stickyHeader = _require4.stickyHeader;

var _require5 = __webpack_require__(16),
    initSectionHeaderTiles = _require5.initSectionHeaderTiles;

var flipbook = __webpack_require__(17);

var _require6 = __webpack_require__(1),
    handleFilterInit = _require6.handleFilterInit; // OB-6702 filter functionality


var _require7 = __webpack_require__(19),
    filterTileAnim = _require7.filterTileAnim; // Uberflip GWL OB-6702


var _require8 = __webpack_require__(2),
    alignItemLevel = _require8.alignItemLevel,
    CTAshift = _require8.CTAshift;

var _require9 = __webpack_require__(20),
    languageSelector = _require9.languageSelector;

var _require10 = __webpack_require__(21),
    languageLabelUpdates = _require10.languageLabelUpdates;

var _require11 = __webpack_require__(2),
    scrollcta = _require11.scrollcta;

var _require12 = __webpack_require__(22),
    handlehubnav = _require12.handlehubnav,
    localselector = _require12.localselector,
    hubnavClose = _require12.hubnavClose,
    hideNav = _require12.hideNav;

var _require13 = __webpack_require__(6),
    handlePortugueseHeader = _require13.handlePortugueseHeader,
    mobileViewPTheader = _require13.mobileViewPTheader;

var _require14 = __webpack_require__(23),
    hideHeaderMenu = _require14.hideHeaderMenu;

var _require15 = __webpack_require__(24),
    changeText = _require15.changeText;

var _require16 = __webpack_require__(25),
    changeDateTime = _require16.changeDateTime;

var _require17 = __webpack_require__(26),
    handleFilterChange = _require17.handleFilterChange;

var _require18 = __webpack_require__(27),
    handleDescriptionPositioning = _require18.handleDescriptionPositioning;

module.exports = {
  initOnbrand: function initOnbrand(translations, production) {
    // -- Startup -- //
    production ? null : onbrandUtilityFunctions.devMode(devOptions);
    window.onbrandCustomLoaded = false;

    // old time embed error throw "fix" (TODO: make this better)
    onbrandUtilityFunctions.legacyEmbedTileFix();
    // Remove the "touch" class on touchscreen laptops
    onbrandUtilityFunctions.removeTouchForLaptops();
    // Remove the hub function updateOverlaySize
    onbrandUtilityFunctions.overrideHubFuctions();
    // Adds body classes for content type (blogPost, youtube, sales-stream etc)
    onbrandUtilityFunctions.helpfulClasses();
    // Rebuild the share widget for the top-nav
    onbrandUtilityFunctions.fixShareWidgetImproved();
    // warns you if your query string is missing.
    onbrandUtilityFunctions.noQueryStringSafeguard();
    // makes the reco engine sticky to the target / top of screen
    onbrandUtilityFunctions.recoEnginePositioning('.top-nav');

    // -- Hub Events -- //
    Hubs.Events.on('load', function () {
      if (!window.onbrandCustomLoaded) {
        // Add your onloads here...
        onbrandUtilityFunctions.blockCtaFix();
        onbrandUtilityFunctions.fadeOutItem();
        handlePortugueseHeader();
        handleFooter();
        loopTiles();
        flipbook();
        initSectionHeaderTiles();
        handleFilterInit(); // OB-6702 filter functionality
        setInterval(function () {
          filterTileAnim(); // Uberflip GWL OB-6702
        }, 500);
        alignItemLevel();
        CTAshift();
        languageSelector();
        languageLabelUpdates();
        // end your onloads before here...
        scrollcta();
        handlehubnav();
        hubnavClose();
        hideNav();
        localselector(); //OB-7749 to remove double click
        mobileViewPTheader();
        hideHeaderMenu(translations);
        changeText();
        changeDateTime();
        handleFilterChange(); //Uberflip Outsource OB-10258
        handleDescriptionPositioning(); // Uberflip Outsource OB-10330
        // end your onloads before here...
        window.onbrandCustomLoaded = true;
      }
    }).on('itemsLoaded', function (itemIds, selectors) {
      loopTiles();
      initSectionHeaderTiles();
      filterTileAnim(); // Uberflip GWL OB-6702
    }) //eslint-disable-line no-unused-vars
    .on('resize', function () {
      scrollcta();
      // adjust side cta or addThis by passing a number into the function
      // eg onbrandUtilityFunctions.sideCtaFix(150); will push the side cta down by 150px, do the same for on scroll
      onbrandUtilityFunctions.sideCtaFix();
      onbrandUtilityFunctions.addThisFix();

      handlePortugueseHeader();
      handleFooter();
    }).on('scroll', function () {
      scrollcta();
      onbrandUtilityFunctions.sideCtaFix();
      onbrandUtilityFunctions.addThisFix();
      onbrandUtilityFunctions.blockCtaFix();
      onbrandUtilityFunctions.fadeOutItem();

      stickyHeader();

      handlehubnav();
    }).on('ctaActivate', function (ctaId) {
      addHyperLinkToFormCtas(ctaId, window.obData.formCtaPrivacyPolicy);
    }) //eslint-disable-line no-unused-vars
    .on('ctaFormSubmitSuccess', function (ctaId, mappedData, ctaName) {}); //eslint-disable-line no-unused-vars

    // The new hub events can trigger before cihost scripts are loaded.
    // This will ensure your scripts fire no matter what, but not more than once for 'load'.
    if (!window.onbrandLoaded) {
      Hubs.Events.trigger('load');
    }
  }
};

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!function (t, n) {
  "object" == ( false ? "undefined" : _typeof(exports)) && "object" == ( false ? "undefined" : _typeof(module)) ? module.exports = n() :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (n),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports["conditional-babel-polyfill"] = n() : t["conditional-babel-polyfill"] = n();
}(window, function () {
  return function (t) {
    var n = {};function r(e) {
      if (n[e]) return n[e].exports;var i = n[e] = { i: e, l: !1, exports: {} };return t[e].call(i.exports, i, i.exports, r), i.l = !0, i.exports;
    }return r.m = t, r.c = n, r.d = function (t, n, e) {
      r.o(t, n) || Object.defineProperty(t, n, { configurable: !1, enumerable: !0, get: e });
    }, r.r = function (t) {
      Object.defineProperty(t, "__esModule", { value: !0 });
    }, r.n = function (t) {
      var n = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };return r.d(n, "a", n), n;
    }, r.o = function (t, n) {
      return Object.prototype.hasOwnProperty.call(t, n);
    }, r.p = "", r(r.s = 328);
  }([function (t, n, r) {
    "use strict";
    var e = r(2),
        i = r(26),
        o = r(13),
        u = r(12),
        c = r(20),
        s = function t(n, r, s) {
      var f,
          a,
          l,
          h,
          v = n & t.F,
          p = n & t.G,
          y = n & t.P,
          d = n & t.B,
          g = p ? e : n & t.S ? e[r] || (e[r] = {}) : (e[r] || {}).prototype,
          b = p ? i : i[r] || (i[r] = {}),
          m = b.prototype || (b.prototype = {});for (f in p && (s = r), s) {
        l = ((a = !v && g && void 0 !== g[f]) ? g : s)[f], h = d && a ? c(l, e) : y && "function" == typeof l ? c(Function.call, l) : l, g && u(g, f, l, n & t.U), b[f] != l && o(b, f, h), y && m[f] != l && (m[f] = l);
      }
    };e.core = i, s.F = 1, s.G = 2, s.S = 4, s.P = 8, s.B = 16, s.W = 32, s.U = 64, s.R = 128, t.exports = s;
  }, function (t, n, r) {
    "use strict";
    var e = r(4);t.exports = function (t) {
      if (!e(t)) throw TypeError(t + " is not an object!");return t;
    };
  }, function (t, n, r) {
    "use strict";
    var e = t.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();"number" == typeof __g && (__g = e);
  }, function (t, n, r) {
    "use strict";
    t.exports = function (t) {
      try {
        return !!t();
      } catch (t) {
        return !0;
      }
    };
  }, function (t, n, r) {
    "use strict";
    var e = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (t) {
      return typeof t === "undefined" ? "undefined" : _typeof(t);
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : _typeof(t);
    };t.exports = function (t) {
      return "object" === (void 0 === t ? "undefined" : e(t)) ? null !== t : "function" == typeof t;
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(62)("wks"),
        i = r(40),
        o = r(2).Symbol,
        u = "function" == typeof o;(t.exports = function (t) {
      return e[t] || (e[t] = u && o[t] || (u ? o : i)("Symbol." + t));
    }).store = e;
  }, function (t, n, r) {
    "use strict";
    var e = r(23),
        i = Math.min;t.exports = function (t) {
      return t > 0 ? i(e(t), 9007199254740991) : 0;
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(1),
        i = r(124),
        o = r(25),
        u = Object.defineProperty;n.f = r(8) ? Object.defineProperty : function (t, n, r) {
      if (e(t), n = o(n, !0), e(r), i) try {
        return u(t, n, r);
      } catch (t) {}if ("get" in r || "set" in r) throw TypeError("Accessors not supported!");return "value" in r && (t[n] = r.value), t;
    };
  }, function (t, n, r) {
    "use strict";
    t.exports = !r(3)(function () {
      return 7 != Object.defineProperty({}, "a", { get: function get() {
          return 7;
        } }).a;
    });
  }, function (t, n, r) {
    "use strict";
    var e = r(24);t.exports = function (t) {
      return Object(e(t));
    };
  }, function (t, n, r) {
    "use strict";
    t.exports = function (t) {
      if ("function" != typeof t) throw TypeError(t + " is not a function!");return t;
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(3),
        o = r(24),
        u = /"/g,
        c = function c(t, n, r, e) {
      var i = String(o(t)),
          c = "<" + n;return "" !== r && (c += " " + r + '="' + String(e).replace(u, "&quot;") + '"'), c + ">" + i + "</" + n + ">";
    };t.exports = function (t, n) {
      var r = {};r[t] = n(c), e(e.P + e.F * i(function () {
        var n = ""[t]('"');return n !== n.toLowerCase() || n.split('"').length > 3;
      }), "String", r);
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(2),
        i = r(13),
        o = r(17),
        u = r(40)("src"),
        c = Function.toString,
        s = ("" + c).split("toString");r(26).inspectSource = function (t) {
      return c.call(t);
    }, (t.exports = function (t, n, r, c) {
      var f = "function" == typeof r;f && (o(r, "name") || i(r, "name", n)), t[n] !== r && (f && (o(r, u) || i(r, u, t[n] ? "" + t[n] : s.join(String(n)))), t === e ? t[n] = r : c ? t[n] ? t[n] = r : i(t, n, r) : (delete t[n], i(t, n, r)));
    })(Function.prototype, "toString", function () {
      return "function" == typeof this && this[u] || c.call(this);
    });
  }, function (t, n, r) {
    "use strict";
    var e = r(7),
        i = r(41);t.exports = r(8) ? function (t, n, r) {
      return e.f(t, n, i(1, r));
    } : function (t, n, r) {
      return t[n] = r, t;
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(17),
        i = r(9),
        o = r(87)("IE_PROTO"),
        u = Object.prototype;t.exports = Object.getPrototypeOf || function (t) {
      return t = i(t), e(t, o) ? t[o] : "function" == typeof t.constructor && t instanceof t.constructor ? t.constructor.prototype : t instanceof Object ? u : null;
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(47),
        i = r(41),
        o = r(16),
        u = r(25),
        c = r(17),
        s = r(124),
        f = Object.getOwnPropertyDescriptor;n.f = r(8) ? f : function (t, n) {
      if (t = o(t), n = u(n, !0), s) try {
        return f(t, n);
      } catch (t) {}if (c(t, n)) return i(!e.f.call(t, n), t[n]);
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(48),
        i = r(24);t.exports = function (t) {
      return e(i(t));
    };
  }, function (t, n, r) {
    "use strict";
    var e = {}.hasOwnProperty;t.exports = function (t, n) {
      return e.call(t, n);
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(3);t.exports = function (t, n) {
      return !!t && e(function () {
        n ? t.call(null, function () {}, 1) : t.call(null);
      });
    };
  }, function (t, n, r) {
    "use strict";
    var e = {}.toString;t.exports = function (t) {
      return e.call(t).slice(8, -1);
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(10);t.exports = function (t, n, r) {
      if (e(t), void 0 === n) return t;switch (r) {case 1:
          return function (r) {
            return t.call(n, r);
          };case 2:
          return function (r, e) {
            return t.call(n, r, e);
          };case 3:
          return function (r, e, i) {
            return t.call(n, r, e, i);
          };}return function () {
        return t.apply(n, arguments);
      };
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(20),
        i = r(48),
        o = r(9),
        u = r(6),
        c = r(70);t.exports = function (t, n) {
      var r = 1 == t,
          s = 2 == t,
          f = 3 == t,
          a = 4 == t,
          l = 6 == t,
          h = 5 == t || l,
          v = n || c;return function (n, c, p) {
        for (var y, d, g = o(n), b = i(g), m = e(c, p, 3), S = u(b.length), w = 0, x = r ? v(n, S) : s ? v(n, 0) : void 0; S > w; w++) {
          if ((h || w in b) && (d = m(y = b[w], w, g), t)) if (r) x[w] = d;else if (d) switch (t) {case 3:
              return !0;case 5:
              return y;case 6:
              return w;case 2:
              x.push(y);} else if (a) return !1;
        }return l ? -1 : f || a ? a : x;
      };
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(26),
        o = r(3);t.exports = function (t, n) {
      var r = (i.Object || {})[t] || Object[t],
          u = {};u[t] = n(r), e(e.S + e.F * o(function () {
        r(1);
      }), "Object", u);
    };
  }, function (t, n, r) {
    "use strict";
    var e = Math.ceil,
        i = Math.floor;t.exports = function (t) {
      return isNaN(t = +t) ? 0 : (t > 0 ? i : e)(t);
    };
  }, function (t, n, r) {
    "use strict";
    t.exports = function (t) {
      if (void 0 == t) throw TypeError("Can't call method on  " + t);return t;
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(4);t.exports = function (t, n) {
      if (!e(t)) return t;var r, i;if (n && "function" == typeof (r = t.toString) && !e(i = r.call(t))) return i;if ("function" == typeof (r = t.valueOf) && !e(i = r.call(t))) return i;if (!n && "function" == typeof (r = t.toString) && !e(i = r.call(t))) return i;throw TypeError("Can't convert object to primitive value");
    };
  }, function (t, n, r) {
    "use strict";
    var e = t.exports = { version: "2.5.4" };"number" == typeof __e && (__e = e);
  }, function (t, n, r) {
    "use strict";
    var e = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (t) {
      return typeof t === "undefined" ? "undefined" : _typeof(t);
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : _typeof(t);
    },
        i = r(103),
        o = r(0),
        u = r(62)("metadata"),
        c = u.store || (u.store = new (r(100))()),
        s = function s(t, n, r) {
      var e = c.get(t);if (!e) {
        if (!r) return;c.set(t, e = new i());
      }var o = e.get(n);if (!o) {
        if (!r) return;e.set(n, o = new i());
      }return o;
    };t.exports = { store: c, map: s, has: function has(t, n, r) {
        var e = s(n, r, !1);return void 0 !== e && e.has(t);
      }, get: function get(t, n, r) {
        var e = s(n, r, !1);return void 0 === e ? void 0 : e.get(t);
      }, set: function set(t, n, r, e) {
        s(r, e, !0).set(t, n);
      }, keys: function keys(t, n) {
        var r = s(t, n, !1),
            e = [];return r && r.forEach(function (t, n) {
          e.push(n);
        }), e;
      }, key: function key(t) {
        return void 0 === t || "symbol" == (void 0 === t ? "undefined" : e(t)) ? t : String(t);
      }, exp: function exp(t) {
        o(o.S, "Reflect", t);
      } };
  }, function (t, n, r) {
    "use strict";
    var e = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (t) {
      return typeof t === "undefined" ? "undefined" : _typeof(t);
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : _typeof(t);
    };if (r(8)) {
      var i = r(39),
          o = r(2),
          u = r(3),
          c = r(0),
          s = r(52),
          f = r(64),
          a = r(20),
          l = r(33),
          h = r(41),
          v = r(13),
          p = r(31),
          y = r(23),
          d = r(6),
          g = r(98),
          b = r(37),
          m = r(25),
          S = r(17),
          w = r(46),
          x = r(4),
          _ = r(9),
          E = r(73),
          O = r(36),
          M = r(14),
          P = r(35).f,
          F = r(71),
          j = r(40),
          A = r(5),
          N = r(21),
          I = r(61),
          T = r(54),
          k = r(68),
          L = r(43),
          R = r(57),
          D = r(34),
          W = r(69),
          C = r(108),
          G = r(7),
          U = r(15),
          B = G.f,
          V = U.f,
          z = o.RangeError,
          Y = o.TypeError,
          J = o.Uint8Array,
          K = Array.prototype,
          q = f.ArrayBuffer,
          H = f.DataView,
          X = N(0),
          $ = N(2),
          Z = N(3),
          Q = N(4),
          tt = N(5),
          nt = N(6),
          rt = I(!0),
          et = I(!1),
          it = k.values,
          ot = k.keys,
          ut = k.entries,
          ct = K.lastIndexOf,
          st = K.reduce,
          ft = K.reduceRight,
          at = K.join,
          lt = K.sort,
          ht = K.slice,
          vt = K.toString,
          pt = K.toLocaleString,
          yt = A("iterator"),
          dt = A("toStringTag"),
          gt = j("typed_constructor"),
          bt = j("def_constructor"),
          mt = s.CONSTR,
          St = s.TYPED,
          wt = s.VIEW,
          xt = N(1, function (t, n) {
        return Pt(T(t, t[bt]), n);
      }),
          _t = u(function () {
        return 1 === new J(new Uint16Array([1]).buffer)[0];
      }),
          Et = !!J && !!J.prototype.set && u(function () {
        new J(1).set({});
      }),
          Ot = function Ot(t, n) {
        var r = y(t);if (r < 0 || r % n) throw z("Wrong offset!");return r;
      },
          Mt = function Mt(t) {
        if (x(t) && St in t) return t;throw Y(t + " is not a typed array!");
      },
          Pt = function Pt(t, n) {
        if (!(x(t) && gt in t)) throw Y("It is not a typed array constructor!");return new t(n);
      },
          Ft = function Ft(t, n) {
        return jt(T(t, t[bt]), n);
      },
          jt = function jt(t, n) {
        for (var r = 0, e = n.length, i = Pt(t, e); e > r;) {
          i[r] = n[r++];
        }return i;
      },
          At = function At(t, n, r) {
        B(t, n, { get: function get() {
            return this._d[r];
          } });
      },
          Nt = function Nt(t) {
        var n,
            r,
            e,
            i,
            o,
            u,
            c = _(t),
            s = arguments.length,
            f = s > 1 ? arguments[1] : void 0,
            l = void 0 !== f,
            h = F(c);if (void 0 != h && !E(h)) {
          for (u = h.call(c), e = [], n = 0; !(o = u.next()).done; n++) {
            e.push(o.value);
          }c = e;
        }for (l && s > 2 && (f = a(f, arguments[2], 2)), n = 0, r = d(c.length), i = Pt(this, r); r > n; n++) {
          i[n] = l ? f(c[n], n) : c[n];
        }return i;
      },
          It = function It() {
        for (var t = 0, n = arguments.length, r = Pt(this, n); n > t;) {
          r[t] = arguments[t++];
        }return r;
      },
          Tt = !!J && u(function () {
        pt.call(new J(1));
      }),
          kt = function kt() {
        return pt.apply(Tt ? ht.call(Mt(this)) : Mt(this), arguments);
      },
          Lt = { copyWithin: function copyWithin(t, n) {
          return C.call(Mt(this), t, n, arguments.length > 2 ? arguments[2] : void 0);
        }, every: function every(t) {
          return Q(Mt(this), t, arguments.length > 1 ? arguments[1] : void 0);
        }, fill: function fill(t) {
          return W.apply(Mt(this), arguments);
        }, filter: function filter(t) {
          return Ft(this, $(Mt(this), t, arguments.length > 1 ? arguments[1] : void 0));
        }, find: function find(t) {
          return tt(Mt(this), t, arguments.length > 1 ? arguments[1] : void 0);
        }, findIndex: function findIndex(t) {
          return nt(Mt(this), t, arguments.length > 1 ? arguments[1] : void 0);
        }, forEach: function forEach(t) {
          X(Mt(this), t, arguments.length > 1 ? arguments[1] : void 0);
        }, indexOf: function indexOf(t) {
          return et(Mt(this), t, arguments.length > 1 ? arguments[1] : void 0);
        }, includes: function includes(t) {
          return rt(Mt(this), t, arguments.length > 1 ? arguments[1] : void 0);
        }, join: function join(t) {
          return at.apply(Mt(this), arguments);
        }, lastIndexOf: function lastIndexOf(t) {
          return ct.apply(Mt(this), arguments);
        }, map: function map(t) {
          return xt(Mt(this), t, arguments.length > 1 ? arguments[1] : void 0);
        }, reduce: function reduce(t) {
          return st.apply(Mt(this), arguments);
        }, reduceRight: function reduceRight(t) {
          return ft.apply(Mt(this), arguments);
        }, reverse: function reverse() {
          for (var t, n = Mt(this).length, r = Math.floor(n / 2), e = 0; e < r;) {
            t = this[e], this[e++] = this[--n], this[n] = t;
          }return this;
        }, some: function some(t) {
          return Z(Mt(this), t, arguments.length > 1 ? arguments[1] : void 0);
        }, sort: function sort(t) {
          return lt.call(Mt(this), t);
        }, subarray: function subarray(t, n) {
          var r = Mt(this),
              e = r.length,
              i = b(t, e);return new (T(r, r[bt]))(r.buffer, r.byteOffset + i * r.BYTES_PER_ELEMENT, d((void 0 === n ? e : b(n, e)) - i));
        } },
          Rt = function Rt(t, n) {
        return Ft(this, ht.call(Mt(this), t, n));
      },
          Dt = function Dt(t) {
        Mt(this);var n = Ot(arguments[1], 1),
            r = this.length,
            e = _(t),
            i = d(e.length),
            o = 0;if (i + n > r) throw z("Wrong length!");for (; o < i;) {
          this[n + o] = e[o++];
        }
      },
          Wt = { entries: function entries() {
          return ut.call(Mt(this));
        }, keys: function keys() {
          return ot.call(Mt(this));
        }, values: function values() {
          return it.call(Mt(this));
        } },
          Ct = function Ct(t, n) {
        return x(t) && t[St] && "symbol" != (void 0 === n ? "undefined" : e(n)) && n in t && String(+n) == String(n);
      },
          Gt = function Gt(t, n) {
        return Ct(t, n = m(n, !0)) ? h(2, t[n]) : V(t, n);
      },
          Ut = function Ut(t, n, r) {
        return !(Ct(t, n = m(n, !0)) && x(r) && S(r, "value")) || S(r, "get") || S(r, "set") || r.configurable || S(r, "writable") && !r.writable || S(r, "enumerable") && !r.enumerable ? B(t, n, r) : (t[n] = r.value, t);
      };mt || (U.f = Gt, G.f = Ut), c(c.S + c.F * !mt, "Object", { getOwnPropertyDescriptor: Gt, defineProperty: Ut }), u(function () {
        vt.call({});
      }) && (vt = pt = function pt() {
        return at.call(this);
      });var Bt = p({}, Lt);p(Bt, Wt), v(Bt, yt, Wt.values), p(Bt, { slice: Rt, set: Dt, constructor: function constructor() {}, toString: vt, toLocaleString: kt }), At(Bt, "buffer", "b"), At(Bt, "byteOffset", "o"), At(Bt, "byteLength", "l"), At(Bt, "length", "e"), B(Bt, dt, { get: function get() {
          return this[St];
        } }), t.exports = function (t, n, r, e) {
        var f = t + ((e = !!e) ? "Clamped" : "") + "Array",
            a = "get" + t,
            h = "set" + t,
            p = o[f],
            y = p || {},
            b = p && M(p),
            m = !p || !s.ABV,
            S = {},
            _ = p && p.prototype,
            E = function E(t, r) {
          B(t, r, { get: function get() {
              return function (t, r) {
                var e = t._d;return e.v[a](r * n + e.o, _t);
              }(this, r);
            }, set: function set(t) {
              return function (t, r, i) {
                var o = t._d;e && (i = (i = Math.round(i)) < 0 ? 0 : i > 255 ? 255 : 255 & i), o.v[h](r * n + o.o, i, _t);
              }(this, r, t);
            }, enumerable: !0 });
        };m ? (p = r(function (t, r, e, i) {
          l(t, p, f, "_d");var o,
              u,
              c,
              s,
              a = 0,
              h = 0;if (x(r)) {
            if (!(r instanceof q || "ArrayBuffer" == (s = w(r)) || "SharedArrayBuffer" == s)) return St in r ? jt(p, r) : Nt.call(p, r);o = r, h = Ot(e, n);var y = r.byteLength;if (void 0 === i) {
              if (y % n) throw z("Wrong length!");if ((u = y - h) < 0) throw z("Wrong length!");
            } else if ((u = d(i) * n) + h > y) throw z("Wrong length!");c = u / n;
          } else c = g(r), o = new q(u = c * n);for (v(t, "_d", { b: o, o: h, l: u, e: c, v: new H(o) }); a < c;) {
            E(t, a++);
          }
        }), _ = p.prototype = O(Bt), v(_, "constructor", p)) : u(function () {
          p(1);
        }) && u(function () {
          new p(-1);
        }) && R(function (t) {
          new p(), new p(null), new p(1.5), new p(t);
        }, !0) || (p = r(function (t, r, e, i) {
          var o;return l(t, p, f), x(r) ? r instanceof q || "ArrayBuffer" == (o = w(r)) || "SharedArrayBuffer" == o ? void 0 !== i ? new y(r, Ot(e, n), i) : void 0 !== e ? new y(r, Ot(e, n)) : new y(r) : St in r ? jt(p, r) : Nt.call(p, r) : new y(g(r));
        }), X(b !== Function.prototype ? P(y).concat(P(b)) : P(y), function (t) {
          t in p || v(p, t, y[t]);
        }), p.prototype = _, i || (_.constructor = p));var F = _[yt],
            j = !!F && ("values" == F.name || void 0 == F.name),
            A = Wt.values;v(p, gt, !0), v(_, St, f), v(_, wt, !0), v(_, bt, p), (e ? new p(1)[dt] == f : dt in _) || B(_, dt, { get: function get() {
            return f;
          } }), S[f] = p, c(c.G + c.W + c.F * (p != y), S), c(c.S, f, { BYTES_PER_ELEMENT: n }), c(c.S + c.F * u(function () {
          y.of.call(p, 1);
        }), f, { from: Nt, of: It }), "BYTES_PER_ELEMENT" in _ || v(_, "BYTES_PER_ELEMENT", n), c(c.P, f, Lt), D(f), c(c.P + c.F * Et, f, { set: Dt }), c(c.P + c.F * !j, f, Wt), i || _.toString == vt || (_.toString = vt), c(c.P + c.F * u(function () {
          new p(1).slice();
        }), f, { slice: Rt }), c(c.P + c.F * (u(function () {
          return [1, 2].toLocaleString() != new p([1, 2]).toLocaleString();
        }) || !u(function () {
          _.toLocaleString.call([1, 2]);
        })), f, { toLocaleString: kt }), L[f] = j ? F : A, i || j || v(_, yt, A);
      };
    } else t.exports = function () {};
  }, function (t, n, r) {
    "use strict";
    var e = r(5)("unscopables"),
        i = Array.prototype;void 0 == i[e] && r(13)(i, e, {}), t.exports = function (t) {
      i[e][t] = !0;
    };
  }, function (t, n, r) {
    "use strict";
    var e = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (t) {
      return typeof t === "undefined" ? "undefined" : _typeof(t);
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : _typeof(t);
    },
        i = r(40)("meta"),
        o = r(4),
        u = r(17),
        c = r(7).f,
        s = 0,
        f = Object.isExtensible || function () {
      return !0;
    },
        a = !r(3)(function () {
      return f(Object.preventExtensions({}));
    }),
        l = function l(t) {
      c(t, i, { value: { i: "O" + ++s, w: {} } });
    },
        h = t.exports = { KEY: i, NEED: !1, fastKey: function fastKey(t, n) {
        if (!o(t)) return "symbol" == (void 0 === t ? "undefined" : e(t)) ? t : ("string" == typeof t ? "S" : "P") + t;if (!u(t, i)) {
          if (!f(t)) return "F";if (!n) return "E";l(t);
        }return t[i].i;
      }, getWeak: function getWeak(t, n) {
        if (!u(t, i)) {
          if (!f(t)) return !0;if (!n) return !1;l(t);
        }return t[i].w;
      }, onFreeze: function onFreeze(t) {
        return a && h.NEED && f(t) && !u(t, i) && l(t), t;
      } };
  }, function (t, n, r) {
    "use strict";
    var e = r(12);t.exports = function (t, n, r) {
      for (var i in n) {
        e(t, i, n[i], r);
      }return t;
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(20),
        i = r(110),
        o = r(73),
        u = r(1),
        c = r(6),
        s = r(71),
        f = {},
        a = {},
        l = t.exports = function (t, n, r, l, h) {
      var v,
          p,
          y,
          d,
          g = h ? function () {
        return t;
      } : s(t),
          b = e(r, l, n ? 2 : 1),
          m = 0;if ("function" != typeof g) throw TypeError(t + " is not iterable!");if (o(g)) {
        for (v = c(t.length); v > m; m++) {
          if ((d = n ? b(u(p = t[m])[0], p[1]) : b(t[m])) === f || d === a) return d;
        }
      } else for (y = g.call(t); !(p = y.next()).done;) {
        if ((d = i(y, b, p.value, n)) === f || d === a) return d;
      }
    };l.BREAK = f, l.RETURN = a;
  }, function (t, n, r) {
    "use strict";
    t.exports = function (t, n, r, e) {
      if (!(t instanceof n) || void 0 !== e && e in t) throw TypeError(r + ": incorrect invocation!");return t;
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(2),
        i = r(7),
        o = r(8),
        u = r(5)("species");t.exports = function (t) {
      var n = e[t];o && n && !n[u] && i.f(n, u, { configurable: !0, get: function get() {
          return this;
        } });
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(122),
        i = r(86).concat("length", "prototype");n.f = Object.getOwnPropertyNames || function (t) {
      return e(t, i);
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(1),
        i = r(121),
        o = r(86),
        u = r(87)("IE_PROTO"),
        c = function c() {},
        _s = function s() {
      var t,
          n = r(89)("iframe"),
          e = o.length;for (n.style.display = "none", r(85).appendChild(n), n.src = "javascript:", (t = n.contentWindow.document).open(), t.write("<script>document.F=Object<\/script>"), t.close(), _s = t.F; e--;) {
        delete _s.prototype[o[e]];
      }return _s();
    };t.exports = Object.create || function (t, n) {
      var r;return null !== t ? (c.prototype = e(t), r = new c(), c.prototype = null, r[u] = t) : r = _s(), void 0 === n ? r : i(r, n);
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(23),
        i = Math.max,
        o = Math.min;t.exports = function (t, n) {
      return (t = e(t)) < 0 ? i(t + n, 0) : o(t, n);
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(122),
        i = r(86);t.exports = Object.keys || function (t) {
      return e(t, i);
    };
  }, function (t, n, r) {
    "use strict";
    t.exports = !1;
  }, function (t, n, r) {
    "use strict";
    var e = 0,
        i = Math.random();t.exports = function (t) {
      return "Symbol(".concat(void 0 === t ? "" : t, ")_", (++e + i).toString(36));
    };
  }, function (t, n, r) {
    "use strict";
    t.exports = function (t, n) {
      return { enumerable: !(1 & t), configurable: !(2 & t), writable: !(4 & t), value: n };
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(4);t.exports = function (t, n) {
      if (!e(t) || t._t !== n) throw TypeError("Incompatible receiver, " + n + " required!");return t;
    };
  }, function (t, n, r) {
    "use strict";
    t.exports = {};
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(24),
        o = r(3),
        u = r(83),
        c = "[" + u + "]",
        s = RegExp("^" + c + c + "*"),
        f = RegExp(c + c + "*$"),
        a = function a(t, n, r) {
      var i = {},
          c = o(function () {
        return !!u[t]() || "​" != "​"[t]();
      }),
          s = i[t] = c ? n(l) : u[t];r && (i[r] = s), e(e.P + e.F * c, "String", i);
    },
        l = a.trim = function (t, n) {
      return t = String(i(t)), 1 & n && (t = t.replace(s, "")), 2 & n && (t = t.replace(f, "")), t;
    };t.exports = a;
  }, function (t, n, r) {
    "use strict";
    var e = r(7).f,
        i = r(17),
        o = r(5)("toStringTag");t.exports = function (t, n, r) {
      t && !i(t = r ? t : t.prototype, o) && e(t, o, { configurable: !0, value: n });
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(19),
        i = r(5)("toStringTag"),
        o = "Arguments" == e(function () {
      return arguments;
    }());t.exports = function (t) {
      var n, r, u;return void 0 === t ? "Undefined" : null === t ? "Null" : "string" == typeof (r = function (t, n) {
        try {
          return t[n];
        } catch (t) {}
      }(n = Object(t), i)) ? r : o ? e(n) : "Object" == (u = e(n)) && "function" == typeof n.callee ? "Arguments" : u;
    };
  }, function (t, n, r) {
    "use strict";
    n.f = {}.propertyIsEnumerable;
  }, function (t, n, r) {
    "use strict";
    var e = r(19);t.exports = Object("z").propertyIsEnumerable(0) ? Object : function (t) {
      return "String" == e(t) ? t.split("") : Object(t);
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(10),
        o = r(20),
        u = r(32);t.exports = function (t) {
      e(e.S, t, { from: function from(t) {
          var n,
              r,
              e,
              c,
              s = arguments[1];return i(this), (n = void 0 !== s) && i(s), void 0 == t ? new this() : (r = [], n ? (e = 0, c = o(s, arguments[2], 2), u(t, !1, function (t) {
            r.push(c(t, e++));
          })) : u(t, !1, r.push, r), new this(r));
        } });
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(0);t.exports = function (t) {
      e(e.S, t, { of: function of() {
          for (var t = arguments.length, n = new Array(t); t--;) {
            n[t] = arguments[t];
          }return new this(n);
        } });
    };
  }, function (t, n, r) {
    "use strict";
    t.exports = r(39) || !r(3)(function () {
      var t = Math.random();__defineSetter__.call(null, t, function () {}), delete r(2)[t];
    });
  }, function (t, n, r) {
    "use strict";
    for (var e, i = r(2), o = r(13), u = r(40), c = u("typed_array"), s = u("view"), f = !(!i.ArrayBuffer || !i.DataView), a = f, l = 0, h = "Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array".split(","); l < 9;) {
      (e = i[h[l++]]) ? (o(e.prototype, c, !0), o(e.prototype, s, !0)) : a = !1;
    }t.exports = { ABV: f, CONSTR: a, TYPED: c, VIEW: s };
  }, function (t, n, r) {
    "use strict";
    var e = r(2),
        i = r(0),
        o = r(12),
        u = r(31),
        c = r(30),
        s = r(32),
        f = r(33),
        a = r(4),
        l = r(3),
        h = r(57),
        v = r(45),
        p = r(82);t.exports = function (t, n, r, y, d, g) {
      var b = e[t],
          m = b,
          S = d ? "set" : "add",
          w = m && m.prototype,
          x = {},
          _ = function _(t) {
        var n = w[t];o(w, t, "delete" == t ? function (t) {
          return !(g && !a(t)) && n.call(this, 0 === t ? 0 : t);
        } : "has" == t ? function (t) {
          return !(g && !a(t)) && n.call(this, 0 === t ? 0 : t);
        } : "get" == t ? function (t) {
          return g && !a(t) ? void 0 : n.call(this, 0 === t ? 0 : t);
        } : "add" == t ? function (t) {
          return n.call(this, 0 === t ? 0 : t), this;
        } : function (t, r) {
          return n.call(this, 0 === t ? 0 : t, r), this;
        });
      };if ("function" == typeof m && (g || w.forEach && !l(function () {
        new m().entries().next();
      }))) {
        var E = new m(),
            O = E[S](g ? {} : -0, 1) != E,
            M = l(function () {
          E.has(1);
        }),
            P = h(function (t) {
          new m(t);
        }),
            F = !g && l(function () {
          for (var t = new m(), n = 5; n--;) {
            t[S](n, n);
          }return !t.has(-0);
        });P || ((m = n(function (n, r) {
          f(n, m, t);var e = p(new b(), n, m);return void 0 != r && s(r, d, e[S], e), e;
        })).prototype = w, w.constructor = m), (M || F) && (_("delete"), _("has"), d && _("get")), (F || O) && _(S), g && w.clear && delete w.clear;
      } else m = y.getConstructor(n, t, d, S), u(m.prototype, r), c.NEED = !0;return v(m, t), x[t] = m, i(i.G + i.W + i.F * (m != b), x), g || y.setStrong(m, t, d), m;
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(1),
        i = r(10),
        o = r(5)("species");t.exports = function (t, n) {
      var r,
          u = e(t).constructor;return void 0 === u || void 0 == (r = e(u)[o]) ? n : i(r);
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(13),
        i = r(12),
        o = r(3),
        u = r(24),
        c = r(5);t.exports = function (t, n, r) {
      var s = c(t),
          f = r(u, s, ""[t]),
          a = f[0],
          l = f[1];o(function () {
        var n = {};return n[s] = function () {
          return 7;
        }, 7 != ""[t](n);
      }) && (i(String.prototype, t, a), e(RegExp.prototype, s, 2 == n ? function (t, n) {
        return l.call(t, this, n);
      } : function (t) {
        return l.call(t, this);
      }));
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(1);t.exports = function () {
      var t = e(this),
          n = "";return t.global && (n += "g"), t.ignoreCase && (n += "i"), t.multiline && (n += "m"), t.unicode && (n += "u"), t.sticky && (n += "y"), n;
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(5)("iterator"),
        i = !1;try {
      var o = [7][e]();o.return = function () {
        i = !0;
      }, Array.from(o, function () {
        throw 2;
      });
    } catch (t) {}t.exports = function (t, n) {
      if (!n && !i) return !1;var r = !1;try {
        var o = [7],
            u = o[e]();u.next = function () {
          return { done: r = !0 };
        }, o[e] = function () {
          return u;
        }, t(o);
      } catch (t) {}return r;
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(4),
        i = r(19),
        o = r(5)("match");t.exports = function (t) {
      var n;return e(t) && (void 0 !== (n = t[o]) ? !!n : "RegExp" == i(t));
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(19);t.exports = Array.isArray || function (t) {
      return "Array" == e(t);
    };
  }, function (t, n, r) {
    "use strict";
    n.f = Object.getOwnPropertySymbols;
  }, function (t, n, r) {
    "use strict";
    var e = r(16),
        i = r(6),
        o = r(37);t.exports = function (t) {
      return function (n, r, u) {
        var c,
            s = e(n),
            f = i(s.length),
            a = o(u, f);if (t && r != r) {
          for (; f > a;) {
            if ((c = s[a++]) != c) return !0;
          }
        } else for (; f > a; a++) {
          if ((t || a in s) && s[a] === r) return t || a || 0;
        }return !t && -1;
      };
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(2),
        i = e["__core-js_shared__"] || (e["__core-js_shared__"] = {});t.exports = function (t) {
      return i[t] || (i[t] = {});
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(2).navigator;t.exports = e && e.userAgent || "";
  }, function (t, n, r) {
    "use strict";
    var e = r(2),
        i = r(8),
        o = r(39),
        u = r(52),
        c = r(13),
        s = r(31),
        f = r(3),
        a = r(33),
        l = r(23),
        h = r(6),
        v = r(98),
        p = r(35).f,
        y = r(7).f,
        d = r(69),
        g = r(45),
        b = "prototype",
        m = "Wrong index!",
        _S2 = e.ArrayBuffer,
        _w = e.DataView,
        x = e.Math,
        _ = e.RangeError,
        E = e.Infinity,
        O = _S2,
        M = x.abs,
        P = x.pow,
        F = x.floor,
        j = x.log,
        A = x.LN2,
        N = i ? "_b" : "buffer",
        I = i ? "_l" : "byteLength",
        T = i ? "_o" : "byteOffset";function k(t, n, r) {
      var e,
          i,
          o,
          u = new Array(r),
          c = 8 * r - n - 1,
          s = (1 << c) - 1,
          f = s >> 1,
          a = 23 === n ? P(2, -24) - P(2, -77) : 0,
          l = 0,
          h = t < 0 || 0 === t && 1 / t < 0 ? 1 : 0;for ((t = M(t)) != t || t === E ? (i = t != t ? 1 : 0, e = s) : (e = F(j(t) / A), t * (o = P(2, -e)) < 1 && (e--, o *= 2), (t += e + f >= 1 ? a / o : a * P(2, 1 - f)) * o >= 2 && (e++, o /= 2), e + f >= s ? (i = 0, e = s) : e + f >= 1 ? (i = (t * o - 1) * P(2, n), e += f) : (i = t * P(2, f - 1) * P(2, n), e = 0)); n >= 8; u[l++] = 255 & i, i /= 256, n -= 8) {}for (e = e << n | i, c += n; c > 0; u[l++] = 255 & e, e /= 256, c -= 8) {}return u[--l] |= 128 * h, u;
    }function L(t, n, r) {
      var e,
          i = 8 * r - n - 1,
          o = (1 << i) - 1,
          u = o >> 1,
          c = i - 7,
          s = r - 1,
          f = t[s--],
          a = 127 & f;for (f >>= 7; c > 0; a = 256 * a + t[s], s--, c -= 8) {}for (e = a & (1 << -c) - 1, a >>= -c, c += n; c > 0; e = 256 * e + t[s], s--, c -= 8) {}if (0 === a) a = 1 - u;else {
        if (a === o) return e ? NaN : f ? -E : E;e += P(2, n), a -= u;
      }return (f ? -1 : 1) * e * P(2, a - n);
    }function R(t) {
      return t[3] << 24 | t[2] << 16 | t[1] << 8 | t[0];
    }function D(t) {
      return [255 & t];
    }function W(t) {
      return [255 & t, t >> 8 & 255];
    }function C(t) {
      return [255 & t, t >> 8 & 255, t >> 16 & 255, t >> 24 & 255];
    }function G(t) {
      return k(t, 52, 8);
    }function U(t) {
      return k(t, 23, 4);
    }function B(t, n, r) {
      y(t[b], n, { get: function get() {
          return this[r];
        } });
    }function V(t, n, r, e) {
      var i = v(+r);if (i + n > t[I]) throw _(m);var o = t[N]._b,
          u = i + t[T],
          c = o.slice(u, u + n);return e ? c : c.reverse();
    }function z(t, n, r, e, i, o) {
      var u = v(+r);if (u + n > t[I]) throw _(m);for (var c = t[N]._b, s = u + t[T], f = e(+i), a = 0; a < n; a++) {
        c[s + a] = f[o ? a : n - a - 1];
      }
    }if (u.ABV) {
      if (!f(function () {
        _S2(1);
      }) || !f(function () {
        new _S2(-1);
      }) || f(function () {
        return new _S2(), new _S2(1.5), new _S2(NaN), "ArrayBuffer" != _S2.name;
      })) {
        for (var Y, J = (_S2 = function S(t) {
          return a(this, _S2), new O(v(t));
        })[b] = O[b], K = p(O), q = 0; K.length > q;) {
          (Y = K[q++]) in _S2 || c(_S2, Y, O[Y]);
        }o || (J.constructor = _S2);
      }var H = new _w(new _S2(2)),
          X = _w[b].setInt8;H.setInt8(0, 2147483648), H.setInt8(1, 2147483649), !H.getInt8(0) && H.getInt8(1) || s(_w[b], { setInt8: function setInt8(t, n) {
          X.call(this, t, n << 24 >> 24);
        }, setUint8: function setUint8(t, n) {
          X.call(this, t, n << 24 >> 24);
        } }, !0);
    } else _S2 = function _S(t) {
      a(this, _S2, "ArrayBuffer");var n = v(t);this._b = d.call(new Array(n), 0), this[I] = n;
    }, _w = function w(t, n, r) {
      a(this, _w, "DataView"), a(t, _S2, "DataView");var e = t[I],
          i = l(n);if (i < 0 || i > e) throw _("Wrong offset!");if (i + (r = void 0 === r ? e - i : h(r)) > e) throw _("Wrong length!");this[N] = t, this[T] = i, this[I] = r;
    }, i && (B(_S2, "byteLength", "_l"), B(_w, "buffer", "_b"), B(_w, "byteLength", "_l"), B(_w, "byteOffset", "_o")), s(_w[b], { getInt8: function getInt8(t) {
        return V(this, 1, t)[0] << 24 >> 24;
      }, getUint8: function getUint8(t) {
        return V(this, 1, t)[0];
      }, getInt16: function getInt16(t) {
        var n = V(this, 2, t, arguments[1]);return (n[1] << 8 | n[0]) << 16 >> 16;
      }, getUint16: function getUint16(t) {
        var n = V(this, 2, t, arguments[1]);return n[1] << 8 | n[0];
      }, getInt32: function getInt32(t) {
        return R(V(this, 4, t, arguments[1]));
      }, getUint32: function getUint32(t) {
        return R(V(this, 4, t, arguments[1])) >>> 0;
      }, getFloat32: function getFloat32(t) {
        return L(V(this, 4, t, arguments[1]), 23, 4);
      }, getFloat64: function getFloat64(t) {
        return L(V(this, 8, t, arguments[1]), 52, 8);
      }, setInt8: function setInt8(t, n) {
        z(this, 1, t, D, n);
      }, setUint8: function setUint8(t, n) {
        z(this, 1, t, D, n);
      }, setInt16: function setInt16(t, n) {
        z(this, 2, t, W, n, arguments[2]);
      }, setUint16: function setUint16(t, n) {
        z(this, 2, t, W, n, arguments[2]);
      }, setInt32: function setInt32(t, n) {
        z(this, 4, t, C, n, arguments[2]);
      }, setUint32: function setUint32(t, n) {
        z(this, 4, t, C, n, arguments[2]);
      }, setFloat32: function setFloat32(t, n) {
        z(this, 4, t, U, n, arguments[2]);
      }, setFloat64: function setFloat64(t, n) {
        z(this, 8, t, G, n, arguments[2]);
      } });g(_S2, "ArrayBuffer"), g(_w, "DataView"), c(_w[b], u.VIEW, !0), n.ArrayBuffer = _S2, n.DataView = _w;
  }, function (t, n, r) {
    "use strict";
    var e = r(10);t.exports.f = function (t) {
      return new function (t) {
        var n, r;this.promise = new t(function (t, e) {
          if (void 0 !== n || void 0 !== r) throw TypeError("Bad Promise constructor");n = t, r = e;
        }), this.resolve = e(n), this.reject = e(r);
      }(t);
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(2),
        i = r(67).set,
        o = e.MutationObserver || e.WebKitMutationObserver,
        u = e.process,
        c = e.Promise,
        s = "process" == r(19)(u);t.exports = function () {
      var t,
          n,
          r,
          f = function f() {
        var e, i;for (s && (e = u.domain) && e.exit(); t;) {
          i = t.fn, t = t.next;try {
            i();
          } catch (e) {
            throw t ? r() : n = void 0, e;
          }
        }n = void 0, e && e.enter();
      };if (s) r = function r() {
        u.nextTick(f);
      };else if (!o || e.navigator && e.navigator.standalone) {
        if (c && c.resolve) {
          var a = c.resolve();r = function r() {
            a.then(f);
          };
        } else r = function r() {
          i.call(e, f);
        };
      } else {
        var l = !0,
            h = document.createTextNode("");new o(f).observe(h, { characterData: !0 }), r = function r() {
          h.data = l = !l;
        };
      }return function (e) {
        var i = { fn: e, next: void 0 };n && (n.next = i), t || (t = i, r()), n = i;
      };
    };
  }, function (t, n, r) {
    "use strict";
    var e,
        i,
        o,
        u = r(20),
        c = r(117),
        s = r(85),
        f = r(89),
        a = r(2),
        l = a.process,
        h = a.setImmediate,
        v = a.clearImmediate,
        p = a.MessageChannel,
        y = a.Dispatch,
        d = 0,
        g = {},
        b = function b() {
      var t = +this;if (g.hasOwnProperty(t)) {
        var n = g[t];delete g[t], n();
      }
    },
        m = function m(t) {
      b.call(t.data);
    };h && v || (h = function h(t) {
      for (var n = [], r = 1; arguments.length > r;) {
        n.push(arguments[r++]);
      }return g[++d] = function () {
        c("function" == typeof t ? t : Function(t), n);
      }, e(d), d;
    }, v = function v(t) {
      delete g[t];
    }, "process" == r(19)(l) ? e = function e(t) {
      l.nextTick(u(b, t, 1));
    } : y && y.now ? e = function e(t) {
      y.now(u(b, t, 1));
    } : p ? (o = (i = new p()).port2, i.port1.onmessage = m, e = u(o.postMessage, o, 1)) : a.addEventListener && "function" == typeof postMessage && !a.importScripts ? (e = function e(t) {
      a.postMessage(t + "", "*");
    }, a.addEventListener("message", m, !1)) : e = "onreadystatechange" in f("script") ? function (t) {
      s.appendChild(f("script")).onreadystatechange = function () {
        s.removeChild(this), b.call(t);
      };
    } : function (t) {
      setTimeout(u(b, t, 1), 0);
    }), t.exports = { set: h, clear: v };
  }, function (t, n, r) {
    "use strict";
    var e = r(29),
        i = r(107),
        o = r(43),
        u = r(16);t.exports = r(77)(Array, "Array", function (t, n) {
      this._t = u(t), this._i = 0, this._k = n;
    }, function () {
      var t = this._t,
          n = this._k,
          r = this._i++;return !t || r >= t.length ? (this._t = void 0, i(1)) : i(0, "keys" == n ? r : "values" == n ? t[r] : [r, t[r]]);
    }, "values"), o.Arguments = o.Array, e("keys"), e("values"), e("entries");
  }, function (t, n, r) {
    "use strict";
    var e = r(9),
        i = r(37),
        o = r(6);t.exports = function (t) {
      for (var n = e(this), r = o(n.length), u = arguments.length, c = i(u > 1 ? arguments[1] : void 0, r), s = u > 2 ? arguments[2] : void 0, f = void 0 === s ? r : i(s, r); f > c;) {
        n[c++] = t;
      }return n;
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(235);t.exports = function (t, n) {
      return new (e(t))(n);
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(46),
        i = r(5)("iterator"),
        o = r(43);t.exports = r(26).getIteratorMethod = function (t) {
      if (void 0 != t) return t[i] || t["@@iterator"] || o[e(t)];
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(7),
        i = r(41);t.exports = function (t, n, r) {
      n in t ? e.f(t, n, i(0, r)) : t[n] = r;
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(43),
        i = r(5)("iterator"),
        o = Array.prototype;t.exports = function (t) {
      return void 0 !== t && (e.Array === t || o[i] === t);
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(5)("match");t.exports = function (t) {
      var n = /./;try {
        "/./"[t](n);
      } catch (r) {
        try {
          return n[e] = !1, !"/./"[t](n);
        } catch (t) {}
      }return !0;
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(58),
        i = r(24);t.exports = function (t, n, r) {
      if (e(n)) throw TypeError("String#" + r + " doesn't accept regex!");return String(i(t));
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(36),
        i = r(41),
        o = r(45),
        u = {};r(13)(u, r(5)("iterator"), function () {
      return this;
    }), t.exports = function (t, n, r) {
      t.prototype = e(u, { next: i(1, r) }), o(t, n + " Iterator");
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(39),
        i = r(0),
        o = r(12),
        u = r(13),
        c = r(43),
        s = r(76),
        f = r(45),
        a = r(14),
        l = r(5)("iterator"),
        h = !([].keys && "next" in [].keys()),
        v = function v() {
      return this;
    };t.exports = function (t, n, r, p, y, d, g) {
      s(r, n, p);var b,
          m,
          S,
          w = function w(t) {
        if (!h && t in O) return O[t];switch (t) {case "keys":case "values":
            return function () {
              return new r(this, t);
            };}return function () {
          return new r(this, t);
        };
      },
          x = n + " Iterator",
          _ = "values" == y,
          E = !1,
          O = t.prototype,
          M = O[l] || O["@@iterator"] || y && O[y],
          P = M || w(y),
          F = y ? _ ? w("entries") : P : void 0,
          j = "Array" == n && O.entries || M;if (j && (S = a(j.call(new t()))) !== Object.prototype && S.next && (f(S, x, !0), e || "function" == typeof S[l] || u(S, l, v)), _ && M && "values" !== M.name && (E = !0, P = function P() {
        return M.call(this);
      }), e && !g || !h && !E && O[l] || u(O, l, P), c[n] = P, c[x] = v, y) if (b = { values: _ ? P : w("values"), keys: d ? P : w("keys"), entries: F }, g) for (m in b) {
        m in O || o(O, m, b[m]);
      } else i(i.P + i.F * (h || E), n, b);return b;
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(23),
        i = r(24);t.exports = function (t) {
      return function (n, r) {
        var o,
            u,
            c = String(i(n)),
            s = e(r),
            f = c.length;return s < 0 || s >= f ? t ? "" : void 0 : (o = c.charCodeAt(s)) < 55296 || o > 56319 || s + 1 === f || (u = c.charCodeAt(s + 1)) < 56320 || u > 57343 ? t ? c.charAt(s) : o : t ? c.slice(s, s + 2) : u - 56320 + (o - 55296 << 10) + 65536;
      };
    };
  }, function (t, n, r) {
    "use strict";
    var e = Math.expm1;t.exports = !e || e(10) > 22025.465794806718 || e(10) < 22025.465794806718 || -2e-17 != e(-2e-17) ? function (t) {
      return 0 == (t = +t) ? t : t > -1e-6 && t < 1e-6 ? t + t * t / 2 : Math.exp(t) - 1;
    } : e;
  }, function (t, n, r) {
    "use strict";
    t.exports = Math.sign || function (t) {
      return 0 == (t = +t) || t != t ? t : t < 0 ? -1 : 1;
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(23),
        i = r(24);t.exports = function (t) {
      var n = String(i(this)),
          r = "",
          o = e(t);if (o < 0 || o == 1 / 0) throw RangeError("Count can't be negative");for (; o > 0; (o >>>= 1) && (n += n)) {
        1 & o && (r += n);
      }return r;
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(4),
        i = r(84).set;t.exports = function (t, n, r) {
      var o,
          u = n.constructor;return u !== r && "function" == typeof u && (o = u.prototype) !== r.prototype && e(o) && i && i(t, o), t;
    };
  }, function (t, n, r) {
    "use strict";
    t.exports = "\t\n\x0B\f\r \xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";
  }, function (t, n, r) {
    "use strict";
    var e = r(4),
        i = r(1),
        o = function o(t, n) {
      if (i(t), !e(n) && null !== n) throw TypeError(n + ": can't set as prototype!");
    };t.exports = { set: Object.setPrototypeOf || ("__proto__" in {} ? function (t, n, e) {
        try {
          (e = r(20)(Function.call, r(15).f(Object.prototype, "__proto__").set, 2))(t, []), n = !(t instanceof Array);
        } catch (t) {
          n = !0;
        }return function (t, r) {
          return o(t, r), n ? t.__proto__ = r : e(t, r), t;
        };
      }({}, !1) : void 0), check: o };
  }, function (t, n, r) {
    "use strict";
    var e = r(2).document;t.exports = e && e.documentElement;
  }, function (t, n, r) {
    "use strict";
    t.exports = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");
  }, function (t, n, r) {
    "use strict";
    var e = r(62)("keys"),
        i = r(40);t.exports = function (t) {
      return e[t] || (e[t] = i(t));
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(2),
        i = r(26),
        o = r(39),
        u = r(123),
        c = r(7).f;t.exports = function (t) {
      var n = i.Symbol || (i.Symbol = o ? {} : e.Symbol || {});"_" == t.charAt(0) || t in n || c(n, t, { value: u.f(t) });
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(4),
        i = r(2).document,
        o = e(i) && e(i.createElement);t.exports = function (t) {
      return o ? i.createElement(t) : {};
    };
  }, function (t, n, r) {
    "use strict";
    var e,
        i = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (t) {
      return typeof t === "undefined" ? "undefined" : _typeof(t);
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : _typeof(t);
    };e = function () {
      return this;
    }();try {
      e = e || Function("return this")() || (0, eval)("this");
    } catch (t) {
      "object" === ("undefined" == typeof window ? "undefined" : i(window)) && (e = window);
    }t.exports = e;
  }, function (t, n, r) {
    "use strict";
    t.exports = Math.scale || function (t, n, r, e, i) {
      return 0 === arguments.length || t != t || n != n || r != r || e != e || i != i ? NaN : t === 1 / 0 || t === -1 / 0 ? t : (t - n) * (i - e) / (r - n) + e;
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(32);t.exports = function (t, n) {
      var r = [];return e(t, !1, r.push, r, n), r;
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(46),
        i = r(92);t.exports = function (t) {
      return function () {
        if (e(this) != t) throw TypeError(t + "#toJSON isn't generic");return i(this);
      };
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(38),
        i = r(16),
        o = r(47).f;t.exports = function (t) {
      return function (n) {
        for (var r, u = i(n), c = e(u), s = c.length, f = 0, a = []; s > f;) {
          o.call(u, r = c[f++]) && a.push(t ? [r, u[r]] : u[r]);
        }return a;
      };
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(6),
        i = r(81),
        o = r(24);t.exports = function (t, n, r, u) {
      var c = String(o(t)),
          s = c.length,
          f = void 0 === r ? " " : String(r),
          a = e(n);if (a <= s || "" == f) return c;var l = a - s,
          h = i.call(f, Math.ceil(l / f.length));return h.length > l && (h = h.slice(0, l)), u ? h + c : c + h;
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(59),
        i = r(4),
        o = r(6),
        u = r(20),
        c = r(5)("isConcatSpreadable");t.exports = function t(n, r, s, f, a, l, h, v) {
      for (var p, y, d = a, g = 0, b = !!h && u(h, v, 3); g < f;) {
        if (g in s) {
          if (p = b ? b(s[g], g, r) : s[g], y = !1, i(p) && (y = void 0 !== (y = p[c]) ? !!y : e(p)), y && l > 0) d = t(n, r, p, o(p.length), d, l - 1) - 1;else {
            if (d >= 9007199254740991) throw TypeError();n[d] = p;
          }d++;
        }g++;
      }return d;
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(35),
        i = r(60),
        o = r(1),
        u = r(2).Reflect;t.exports = u && u.ownKeys || function (t) {
      var n = e.f(o(t)),
          r = i.f;return r ? n.concat(r(t)) : n;
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(23),
        i = r(6);t.exports = function (t) {
      if (void 0 === t) return 0;var n = e(t),
          r = i(n);if (n !== r) throw RangeError("Wrong length!");return r;
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(31),
        i = r(30).getWeak,
        o = r(1),
        u = r(4),
        c = r(33),
        s = r(32),
        f = r(21),
        a = r(17),
        l = r(42),
        h = f(5),
        v = f(6),
        p = 0,
        y = function y(t) {
      return t._l || (t._l = new d());
    },
        d = function d() {
      this.a = [];
    },
        g = function g(t, n) {
      return h(t.a, function (t) {
        return t[0] === n;
      });
    };d.prototype = { get: function get(t) {
        var n = g(this, t);if (n) return n[1];
      }, has: function has(t) {
        return !!g(this, t);
      }, set: function set(t, n) {
        var r = g(this, t);r ? r[1] = n : this.a.push([t, n]);
      }, delete: function _delete(t) {
        var n = v(this.a, function (n) {
          return n[0] === t;
        });return ~n && this.a.splice(n, 1), !!~n;
      } }, t.exports = { getConstructor: function getConstructor(t, n, r, o) {
        var f = t(function (t, e) {
          c(t, f, n, "_i"), t._t = n, t._i = p++, t._l = void 0, void 0 != e && s(e, r, t[o], t);
        });return e(f.prototype, { delete: function _delete(t) {
            if (!u(t)) return !1;var r = i(t);return !0 === r ? y(l(this, n)).delete(t) : r && a(r, this._i) && delete r[this._i];
          }, has: function has(t) {
            if (!u(t)) return !1;var r = i(t);return !0 === r ? y(l(this, n)).has(t) : r && a(r, this._i);
          } }), f;
      }, def: function def(t, n, r) {
        var e = i(o(n), !0);return !0 === e ? y(t).set(n, r) : e[t._i] = r, t;
      }, ufstore: y };
  }, function (t, n, r) {
    "use strict";
    var e,
        i = r(21)(0),
        o = r(12),
        u = r(30),
        c = r(119),
        s = r(99),
        f = r(4),
        a = r(3),
        l = r(42),
        h = u.getWeak,
        v = Object.isExtensible,
        p = s.ufstore,
        y = {},
        d = function d(t) {
      return function () {
        return t(this, arguments.length > 0 ? arguments[0] : void 0);
      };
    },
        g = { get: function get(t) {
        if (f(t)) {
          var n = h(t);return !0 === n ? p(l(this, "WeakMap")).get(t) : n ? n[this._i] : void 0;
        }
      }, set: function set(t, n) {
        return s.def(l(this, "WeakMap"), t, n);
      } },
        b = t.exports = r(53)("WeakMap", d, g, s, !0, !0);a(function () {
      return 7 != new b().set((Object.freeze || Object)(y), 7).get(y);
    }) && (c((e = s.getConstructor(d, "WeakMap")).prototype, g), u.NEED = !0, i(["delete", "has", "get", "set"], function (t) {
      var n = b.prototype,
          r = n[t];o(n, t, function (n, i) {
        if (f(n) && !v(n)) {
          this._f || (this._f = new e());var o = this._f[t](n, i);return "set" == t ? this : o;
        }return r.call(this, n, i);
      });
    }));
  }, function (t, n, r) {
    "use strict";
    var e = r(102),
        i = r(42);t.exports = r(53)("Set", function (t) {
      return function () {
        return t(this, arguments.length > 0 ? arguments[0] : void 0);
      };
    }, { add: function add(t) {
        return e.def(i(this, "Set"), t = 0 === t ? 0 : t, t);
      } }, e);
  }, function (t, n, r) {
    "use strict";
    var e = r(7).f,
        i = r(36),
        o = r(31),
        u = r(20),
        c = r(33),
        s = r(32),
        f = r(77),
        a = r(107),
        l = r(34),
        h = r(8),
        v = r(30).fastKey,
        p = r(42),
        y = h ? "_s" : "size",
        d = function d(t, n) {
      var r,
          e = v(n);if ("F" !== e) return t._i[e];for (r = t._f; r; r = r.n) {
        if (r.k == n) return r;
      }
    };t.exports = { getConstructor: function getConstructor(t, n, r, f) {
        var a = t(function (t, e) {
          c(t, a, n, "_i"), t._t = n, t._i = i(null), t._f = void 0, t._l = void 0, t[y] = 0, void 0 != e && s(e, r, t[f], t);
        });return o(a.prototype, { clear: function clear() {
            for (var t = p(this, n), r = t._i, e = t._f; e; e = e.n) {
              e.r = !0, e.p && (e.p = e.p.n = void 0), delete r[e.i];
            }t._f = t._l = void 0, t[y] = 0;
          }, delete: function _delete(t) {
            var r = p(this, n),
                e = d(r, t);if (e) {
              var i = e.n,
                  o = e.p;delete r._i[e.i], e.r = !0, o && (o.n = i), i && (i.p = o), r._f == e && (r._f = i), r._l == e && (r._l = o), r[y]--;
            }return !!e;
          }, forEach: function forEach(t) {
            p(this, n);for (var r, e = u(t, arguments.length > 1 ? arguments[1] : void 0, 3); r = r ? r.n : this._f;) {
              for (e(r.v, r.k, this); r && r.r;) {
                r = r.p;
              }
            }
          }, has: function has(t) {
            return !!d(p(this, n), t);
          } }), h && e(a.prototype, "size", { get: function get() {
            return p(this, n)[y];
          } }), a;
      }, def: function def(t, n, r) {
        var e,
            i,
            o = d(t, n);return o ? o.v = r : (t._l = o = { i: i = v(n, !0), k: n, v: r, p: e = t._l, n: void 0, r: !1 }, t._f || (t._f = o), e && (e.n = o), t[y]++, "F" !== i && (t._i[i] = o)), t;
      }, getEntry: d, setStrong: function setStrong(t, n, r) {
        f(t, n, function (t, r) {
          this._t = p(t, n), this._k = r, this._l = void 0;
        }, function () {
          for (var t = this._k, n = this._l; n && n.r;) {
            n = n.p;
          }return this._t && (this._l = n = n ? n.n : this._t._f) ? a(0, "keys" == t ? n.k : "values" == t ? n.v : [n.k, n.v]) : (this._t = void 0, a(1));
        }, r ? "entries" : "values", !r, !0), l(n);
      } };
  }, function (t, n, r) {
    "use strict";
    var e = r(102),
        i = r(42);t.exports = r(53)("Map", function (t) {
      return function () {
        return t(this, arguments.length > 0 ? arguments[0] : void 0);
      };
    }, { get: function get(t) {
        var n = e.getEntry(i(this, "Map"), t);return n && n.v;
      }, set: function set(t, n) {
        return e.def(i(this, "Map"), 0 === t ? 0 : t, n);
      } }, e, !0);
  }, function (t, n, r) {
    "use strict";
    var e = r(1),
        i = r(4),
        o = r(65);t.exports = function (t, n) {
      if (e(t), i(n) && n.constructor === t) return n;var r = o.f(t);return (0, r.resolve)(n), r.promise;
    };
  }, function (t, n, r) {
    "use strict";
    t.exports = function (t) {
      try {
        return { e: !1, v: t() };
      } catch (t) {
        return { e: !0, v: t };
      }
    };
  }, function (t, n, r) {
    "use strict";
    r(8) && "g" != /./g.flags && r(7).f(RegExp.prototype, "flags", { configurable: !0, get: r(56) });
  }, function (t, n, r) {
    "use strict";
    t.exports = function (t, n) {
      return { value: n, done: !!t };
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(9),
        i = r(37),
        o = r(6);t.exports = [].copyWithin || function (t, n) {
      var r = e(this),
          u = o(r.length),
          c = i(t, u),
          s = i(n, u),
          f = arguments.length > 2 ? arguments[2] : void 0,
          a = Math.min((void 0 === f ? u : i(f, u)) - s, u - c),
          l = 1;for (s < c && c < s + a && (l = -1, s += a - 1, c += a - 1); a-- > 0;) {
        s in r ? r[c] = r[s] : delete r[c], c += l, s += l;
      }return r;
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(10),
        i = r(9),
        o = r(48),
        u = r(6);t.exports = function (t, n, r, c, s) {
      e(n);var f = i(t),
          a = o(f),
          l = u(f.length),
          h = s ? l - 1 : 0,
          v = s ? -1 : 1;if (r < 2) for (;;) {
        if (h in a) {
          c = a[h], h += v;break;
        }if (h += v, s ? h < 0 : l <= h) throw TypeError("Reduce of empty array with no initial value");
      }for (; s ? h >= 0 : l > h; h += v) {
        h in a && (c = n(c, a[h], h, f));
      }return c;
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(1);t.exports = function (t, n, r, i) {
      try {
        return i ? n(e(r)[0], r[1]) : n(r);
      } catch (n) {
        var o = t.return;throw void 0 !== o && e(o.call(t)), n;
      }
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(80),
        i = Math.pow,
        o = i(2, -52),
        u = i(2, -23),
        c = i(2, 127) * (2 - u),
        s = i(2, -126);t.exports = Math.fround || function (t) {
      var n,
          r,
          i = Math.abs(t),
          f = e(t);return i < s ? f * (i / s / u + 1 / o - 1 / o) * s * u : (r = (n = (1 + u / o) * i) - (n - i)) > c || r != r ? f * (1 / 0) : f * r;
    };
  }, function (t, n, r) {
    "use strict";
    t.exports = Math.log1p || function (t) {
      return (t = +t) > -1e-8 && t < 1e-8 ? t - t * t / 2 : Math.log(1 + t);
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(4),
        i = Math.floor;t.exports = function (t) {
      return !e(t) && isFinite(t) && i(t) === t;
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(19);t.exports = function (t, n) {
      if ("number" != typeof t && "Number" != e(t)) throw TypeError(n);return +t;
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(2).parseFloat,
        i = r(44).trim;t.exports = 1 / e(r(83) + "-0") != -1 / 0 ? function (t) {
      var n = i(String(t), 3),
          r = e(n);return 0 === r && "-" == n.charAt(0) ? -0 : r;
    } : e;
  }, function (t, n, r) {
    "use strict";
    var e = r(2).parseInt,
        i = r(44).trim,
        o = r(83),
        u = /^[-+]?0[xX]/;t.exports = 8 !== e(o + "08") || 22 !== e(o + "0x16") ? function (t, n) {
      var r = i(String(t), 3);return e(r, n >>> 0 || (u.test(r) ? 16 : 10));
    } : e;
  }, function (t, n, r) {
    "use strict";
    t.exports = function (t, n, r) {
      var e = void 0 === r;switch (n.length) {case 0:
          return e ? t() : t.call(r);case 1:
          return e ? t(n[0]) : t.call(r, n[0]);case 2:
          return e ? t(n[0], n[1]) : t.call(r, n[0], n[1]);case 3:
          return e ? t(n[0], n[1], n[2]) : t.call(r, n[0], n[1], n[2]);case 4:
          return e ? t(n[0], n[1], n[2], n[3]) : t.call(r, n[0], n[1], n[2], n[3]);}return t.apply(r, n);
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(10),
        i = r(4),
        o = r(117),
        u = [].slice,
        c = {};t.exports = Function.bind || function (t) {
      var n = e(this),
          r = u.call(arguments, 1),
          s = function e() {
        var i = r.concat(u.call(arguments));return this instanceof e ? function (t, n, r) {
          if (!(n in c)) {
            for (var e = [], i = 0; i < n; i++) {
              e[i] = "a[" + i + "]";
            }c[n] = Function("F,a", "return new F(" + e.join(",") + ")");
          }return c[n](t, r);
        }(n, i.length, i) : o(n, i, t);
      };return i(n.prototype) && (s.prototype = n.prototype), s;
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(38),
        i = r(60),
        o = r(47),
        u = r(9),
        c = r(48),
        s = Object.assign;t.exports = !s || r(3)(function () {
      var t = {},
          n = {},
          r = Symbol(),
          e = "abcdefghijklmnopqrst";return t[r] = 7, e.split("").forEach(function (t) {
        n[t] = t;
      }), 7 != s({}, t)[r] || Object.keys(s({}, n)).join("") != e;
    }) ? function (t, n) {
      for (var r = u(t), s = arguments.length, f = 1, a = i.f, l = o.f; s > f;) {
        for (var h, v = c(arguments[f++]), p = a ? e(v).concat(a(v)) : e(v), y = p.length, d = 0; y > d;) {
          l.call(v, h = p[d++]) && (r[h] = v[h]);
        }
      }return r;
    } : s;
  }, function (t, n, r) {
    "use strict";
    var e = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (t) {
      return typeof t === "undefined" ? "undefined" : _typeof(t);
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : _typeof(t);
    },
        i = r(16),
        o = r(35).f,
        u = {}.toString,
        c = "object" == ("undefined" == typeof window ? "undefined" : e(window)) && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];t.exports.f = function (t) {
      return c && "[object Window]" == u.call(t) ? function (t) {
        try {
          return o(t);
        } catch (t) {
          return c.slice();
        }
      }(t) : o(i(t));
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(7),
        i = r(1),
        o = r(38);t.exports = r(8) ? Object.defineProperties : function (t, n) {
      i(t);for (var r, u = o(n), c = u.length, s = 0; c > s;) {
        e.f(t, r = u[s++], n[r]);
      }return t;
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(17),
        i = r(16),
        o = r(61)(!1),
        u = r(87)("IE_PROTO");t.exports = function (t, n) {
      var r,
          c = i(t),
          s = 0,
          f = [];for (r in c) {
        r != u && e(c, r) && f.push(r);
      }for (; n.length > s;) {
        e(c, r = n[s++]) && (~o(f, r) || f.push(r));
      }return f;
    };
  }, function (t, n, r) {
    "use strict";
    n.f = r(5);
  }, function (t, n, r) {
    "use strict";
    t.exports = !r(8) && !r(3)(function () {
      return 7 != Object.defineProperty(r(89)("div"), "a", { get: function get() {
          return 7;
        } }).a;
    });
  }, function (t, n, r) {
    "use strict";
    t.exports = function (t, n) {
      var r = n === Object(n) ? function (t) {
        return n[t];
      } : n;return function (n) {
        return String(n).replace(t, r);
      };
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(125)(/[\\^$*+?.()|[\]{}]/g, "\\$&");e(e.S, "RegExp", { escape: function escape(t) {
        return i(t);
      } });
  }, function (t, n, r) {
    "use strict";
    r(126), t.exports = r(26).RegExp.escape;
  }, function (t, n, r) {
    "use strict";
    t.exports = function (t) {
      return t.webpackPolyfill || (t.deprecate = function () {}, t.paths = [], t.children || (t.children = []), Object.defineProperty(t, "loaded", { enumerable: !0, get: function get() {
          return t.l;
        } }), Object.defineProperty(t, "id", { enumerable: !0, get: function get() {
          return t.i;
        } }), t.webpackPolyfill = 1), t;
    };
  }, function (t, n, r) {
    "use strict";
    (function (t, n) {
      var r = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (t) {
        return typeof t === "undefined" ? "undefined" : _typeof(t);
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : _typeof(t);
      };!function (t) {
        var e,
            i = Object.prototype,
            o = i.hasOwnProperty,
            u = "function" == typeof Symbol ? Symbol : {},
            c = u.iterator || "@@iterator",
            s = u.asyncIterator || "@@asyncIterator",
            f = u.toStringTag || "@@toStringTag",
            a = "object" === r(n),
            l = t.regeneratorRuntime;if (l) a && (n.exports = l);else {
          (l = t.regeneratorRuntime = a ? n.exports : {}).wrap = w;var h = "suspendedStart",
              v = "suspendedYield",
              p = "executing",
              y = "completed",
              d = {},
              g = {};g[c] = function () {
            return this;
          };var b = Object.getPrototypeOf,
              m = b && b(b(I([])));m && m !== i && o.call(m, c) && (g = m);var S = O.prototype = _.prototype = Object.create(g);E.prototype = S.constructor = O, O.constructor = E, O[f] = E.displayName = "GeneratorFunction", l.isGeneratorFunction = function (t) {
            var n = "function" == typeof t && t.constructor;return !!n && (n === E || "GeneratorFunction" === (n.displayName || n.name));
          }, l.mark = function (t) {
            return Object.setPrototypeOf ? Object.setPrototypeOf(t, O) : (t.__proto__ = O, f in t || (t[f] = "GeneratorFunction")), t.prototype = Object.create(S), t;
          }, l.awrap = function (t) {
            return { __await: t };
          }, M(P.prototype), P.prototype[s] = function () {
            return this;
          }, l.AsyncIterator = P, l.async = function (t, n, r, e) {
            var i = new P(w(t, n, r, e));return l.isGeneratorFunction(n) ? i : i.next().then(function (t) {
              return t.done ? t.value : i.next();
            });
          }, M(S), S[f] = "Generator", S[c] = function () {
            return this;
          }, S.toString = function () {
            return "[object Generator]";
          }, l.keys = function (t) {
            var n = [];for (var r in t) {
              n.push(r);
            }return n.reverse(), function r() {
              for (; n.length;) {
                var e = n.pop();if (e in t) return r.value = e, r.done = !1, r;
              }return r.done = !0, r;
            };
          }, l.values = I, N.prototype = { constructor: N, reset: function reset(t) {
              if (this.prev = 0, this.next = 0, this.sent = this._sent = e, this.done = !1, this.delegate = null, this.method = "next", this.arg = e, this.tryEntries.forEach(A), !t) for (var n in this) {
                "t" === n.charAt(0) && o.call(this, n) && !isNaN(+n.slice(1)) && (this[n] = e);
              }
            }, stop: function stop() {
              this.done = !0;var t = this.tryEntries[0].completion;if ("throw" === t.type) throw t.arg;return this.rval;
            }, dispatchException: function dispatchException(t) {
              if (this.done) throw t;var n = this;function r(r, i) {
                return c.type = "throw", c.arg = t, n.next = r, i && (n.method = "next", n.arg = e), !!i;
              }for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                var u = this.tryEntries[i],
                    c = u.completion;if ("root" === u.tryLoc) return r("end");if (u.tryLoc <= this.prev) {
                  var s = o.call(u, "catchLoc"),
                      f = o.call(u, "finallyLoc");if (s && f) {
                    if (this.prev < u.catchLoc) return r(u.catchLoc, !0);if (this.prev < u.finallyLoc) return r(u.finallyLoc);
                  } else if (s) {
                    if (this.prev < u.catchLoc) return r(u.catchLoc, !0);
                  } else {
                    if (!f) throw new Error("try statement without catch or finally");if (this.prev < u.finallyLoc) return r(u.finallyLoc);
                  }
                }
              }
            }, abrupt: function abrupt(t, n) {
              for (var r = this.tryEntries.length - 1; r >= 0; --r) {
                var e = this.tryEntries[r];if (e.tryLoc <= this.prev && o.call(e, "finallyLoc") && this.prev < e.finallyLoc) {
                  var i = e;break;
                }
              }i && ("break" === t || "continue" === t) && i.tryLoc <= n && n <= i.finallyLoc && (i = null);var u = i ? i.completion : {};return u.type = t, u.arg = n, i ? (this.method = "next", this.next = i.finallyLoc, d) : this.complete(u);
            }, complete: function complete(t, n) {
              if ("throw" === t.type) throw t.arg;return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && n && (this.next = n), d;
            }, finish: function finish(t) {
              for (var n = this.tryEntries.length - 1; n >= 0; --n) {
                var r = this.tryEntries[n];if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), A(r), d;
              }
            }, catch: function _catch(t) {
              for (var n = this.tryEntries.length - 1; n >= 0; --n) {
                var r = this.tryEntries[n];if (r.tryLoc === t) {
                  var e = r.completion;if ("throw" === e.type) {
                    var i = e.arg;A(r);
                  }return i;
                }
              }throw new Error("illegal catch attempt");
            }, delegateYield: function delegateYield(t, n, r) {
              return this.delegate = { iterator: I(t), resultName: n, nextLoc: r }, "next" === this.method && (this.arg = e), d;
            } };
        }function w(t, n, r, e) {
          var i = n && n.prototype instanceof _ ? n : _,
              o = Object.create(i.prototype),
              u = new N(e || []);return o._invoke = function (t, n, r) {
            var e = h;return function (i, o) {
              if (e === p) throw new Error("Generator is already running");if (e === y) {
                if ("throw" === i) throw o;return T();
              }for (r.method = i, r.arg = o;;) {
                var u = r.delegate;if (u) {
                  var c = F(u, r);if (c) {
                    if (c === d) continue;return c;
                  }
                }if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
                  if (e === h) throw e = y, r.arg;r.dispatchException(r.arg);
                } else "return" === r.method && r.abrupt("return", r.arg);e = p;var s = x(t, n, r);if ("normal" === s.type) {
                  if (e = r.done ? y : v, s.arg === d) continue;return { value: s.arg, done: r.done };
                }"throw" === s.type && (e = y, r.method = "throw", r.arg = s.arg);
              }
            };
          }(t, r, u), o;
        }function x(t, n, r) {
          try {
            return { type: "normal", arg: t.call(n, r) };
          } catch (t) {
            return { type: "throw", arg: t };
          }
        }function _() {}function E() {}function O() {}function M(t) {
          ["next", "throw", "return"].forEach(function (n) {
            t[n] = function (t) {
              return this._invoke(n, t);
            };
          });
        }function P(n) {
          function e(t, i, u, c) {
            var s = x(n[t], n, i);if ("throw" !== s.type) {
              var f = s.arg,
                  a = f.value;return a && "object" === (void 0 === a ? "undefined" : r(a)) && o.call(a, "__await") ? Promise.resolve(a.__await).then(function (t) {
                e("next", t, u, c);
              }, function (t) {
                e("throw", t, u, c);
              }) : Promise.resolve(a).then(function (t) {
                f.value = t, u(f);
              }, c);
            }c(s.arg);
          }var i;"object" === r(t.process) && t.process.domain && (e = t.process.domain.bind(e)), this._invoke = function (t, n) {
            function r() {
              return new Promise(function (r, i) {
                e(t, n, r, i);
              });
            }return i = i ? i.then(r, r) : r();
          };
        }function F(t, n) {
          var r = t.iterator[n.method];if (r === e) {
            if (n.delegate = null, "throw" === n.method) {
              if (t.iterator.return && (n.method = "return", n.arg = e, F(t, n), "throw" === n.method)) return d;n.method = "throw", n.arg = new TypeError("The iterator does not provide a 'throw' method");
            }return d;
          }var i = x(r, t.iterator, n.arg);if ("throw" === i.type) return n.method = "throw", n.arg = i.arg, n.delegate = null, d;var o = i.arg;return o ? o.done ? (n[t.resultName] = o.value, n.next = t.nextLoc, "return" !== n.method && (n.method = "next", n.arg = e), n.delegate = null, d) : o : (n.method = "throw", n.arg = new TypeError("iterator result is not an object"), n.delegate = null, d);
        }function j(t) {
          var n = { tryLoc: t[0] };1 in t && (n.catchLoc = t[1]), 2 in t && (n.finallyLoc = t[2], n.afterLoc = t[3]), this.tryEntries.push(n);
        }function A(t) {
          var n = t.completion || {};n.type = "normal", delete n.arg, t.completion = n;
        }function N(t) {
          this.tryEntries = [{ tryLoc: "root" }], t.forEach(j, this), this.reset(!0);
        }function I(t) {
          if (t) {
            var n = t[c];if (n) return n.call(t);if ("function" == typeof t.next) return t;if (!isNaN(t.length)) {
              var r = -1,
                  i = function n() {
                for (; ++r < t.length;) {
                  if (o.call(t, r)) return n.value = t[r], n.done = !1, n;
                }return n.value = e, n.done = !0, n;
              };return i.next = i;
            }
          }return { next: T };
        }function T() {
          return { value: e, done: !0 };
        }
      }("object" === (void 0 === t ? "undefined" : r(t)) ? t : "object" === ("undefined" == typeof window ? "undefined" : r(window)) ? window : "object" === ("undefined" == typeof self ? "undefined" : r(self)) ? self : void 0);
    }).call(this, r(90), r(128)(t));
  }, function (t, n, r) {
    "use strict";
    for (var e = r(68), i = r(38), o = r(12), u = r(2), c = r(13), s = r(43), f = r(5), a = f("iterator"), l = f("toStringTag"), h = s.Array, v = { CSSRuleList: !0, CSSStyleDeclaration: !1, CSSValueList: !1, ClientRectList: !1, DOMRectList: !1, DOMStringList: !1, DOMTokenList: !0, DataTransferItemList: !1, FileList: !1, HTMLAllCollection: !1, HTMLCollection: !1, HTMLFormElement: !1, HTMLSelectElement: !1, MediaList: !0, MimeTypeArray: !1, NamedNodeMap: !1, NodeList: !0, PaintRequestList: !1, Plugin: !1, PluginArray: !1, SVGLengthList: !1, SVGNumberList: !1, SVGPathSegList: !1, SVGPointList: !1, SVGStringList: !1, SVGTransformList: !1, SourceBufferList: !1, StyleSheetList: !0, TextTrackCueList: !1, TextTrackList: !1, TouchList: !1 }, p = i(v), y = 0; y < p.length; y++) {
      var d,
          g = p[y],
          b = v[g],
          m = u[g],
          S = m && m.prototype;if (S && (S[a] || c(S, a, h), S[l] || c(S, l, g), s[g] = h, b)) for (d in e) {
        S[d] || o(S, d, e[d], !0);
      }
    }
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(67);e(e.G + e.B, { setImmediate: i.set, clearImmediate: i.clear });
  }, function (t, n, r) {
    "use strict";
    var e = r(2),
        i = r(0),
        o = r(63),
        u = [].slice,
        c = /MSIE .\./.test(o),
        s = function s(t) {
      return function (n, r) {
        var e = arguments.length > 2,
            i = !!e && u.call(arguments, 2);return t(e ? function () {
          ("function" == typeof n ? n : Function(n)).apply(this, i);
        } : n, r);
      };
    };i(i.G + i.B + i.F * c, { setTimeout: s(e.setTimeout), setInterval: s(e.setInterval) });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(2),
        o = r(26),
        u = r(66)(),
        c = r(5)("observable"),
        s = r(10),
        f = r(1),
        a = r(33),
        l = r(31),
        h = r(13),
        v = r(32),
        p = v.RETURN,
        y = function y(t) {
      return null == t ? void 0 : s(t);
    },
        d = function d(t) {
      var n = t._c;n && (t._c = void 0, n());
    },
        g = function g(t) {
      return void 0 === t._o;
    },
        b = function b(t) {
      g(t) || (t._o = void 0, d(t));
    },
        m = function m(t, n) {
      f(t), this._c = void 0, this._o = t, t = new S(this);try {
        var r = n(t),
            e = r;null != r && ("function" == typeof r.unsubscribe ? r = function r() {
          e.unsubscribe();
        } : s(r), this._c = r);
      } catch (n) {
        return void t.error(n);
      }g(this) && d(this);
    };m.prototype = l({}, { unsubscribe: function unsubscribe() {
        b(this);
      } });var S = function S(t) {
      this._s = t;
    };S.prototype = l({}, { next: function next(t) {
        var n = this._s;if (!g(n)) {
          var r = n._o;try {
            var e = y(r.next);if (e) return e.call(r, t);
          } catch (t) {
            try {
              b(n);
            } finally {
              throw t;
            }
          }
        }
      }, error: function error(t) {
        var n = this._s;if (g(n)) throw t;var r = n._o;n._o = void 0;try {
          var e = y(r.error);if (!e) throw t;t = e.call(r, t);
        } catch (t) {
          try {
            d(n);
          } finally {
            throw t;
          }
        }return d(n), t;
      }, complete: function complete(t) {
        var n = this._s;if (!g(n)) {
          var r = n._o;n._o = void 0;try {
            var e = y(r.complete);t = e ? e.call(r, t) : void 0;
          } catch (t) {
            try {
              d(n);
            } finally {
              throw t;
            }
          }return d(n), t;
        }
      } });var w = function w(t) {
      a(this, w, "Observable", "_f")._f = s(t);
    };l(w.prototype, { subscribe: function subscribe(t) {
        return new m(t, this._f);
      }, forEach: function forEach(t) {
        var n = this;return new (o.Promise || i.Promise)(function (r, e) {
          s(t);var i = n.subscribe({ next: function next(n) {
              try {
                return t(n);
              } catch (t) {
                e(t), i.unsubscribe();
              }
            }, error: e, complete: r });
        });
      } }), l(w, { from: function from(t) {
        var n = "function" == typeof this ? this : w,
            r = y(f(t)[c]);if (r) {
          var e = f(r.call(t));return e.constructor === n ? e : new n(function (t) {
            return e.subscribe(t);
          });
        }return new n(function (n) {
          var r = !1;return u(function () {
            if (!r) {
              try {
                if (v(t, !1, function (t) {
                  if (n.next(t), r) return p;
                }) === p) return;
              } catch (t) {
                if (r) throw t;return void n.error(t);
              }n.complete();
            }
          }), function () {
            r = !0;
          };
        });
      }, of: function of() {
        for (var t = 0, n = arguments.length, r = new Array(n); t < n;) {
          r[t] = arguments[t++];
        }return new ("function" == typeof this ? this : w)(function (t) {
          var n = !1;return u(function () {
            if (!n) {
              for (var e = 0; e < r.length; ++e) {
                if (t.next(r[e]), n) return;
              }t.complete();
            }
          }), function () {
            n = !0;
          };
        });
      } }), h(w.prototype, c, function () {
      return this;
    }), e(e.G, { Observable: w }), r(34)("Observable");
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(66)(),
        o = r(2).process,
        u = "process" == r(19)(o);e(e.G, { asap: function asap(t) {
        var n = u && o.domain;i(n ? n.bind(t) : t);
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(27),
        i = r(1),
        o = r(10),
        u = e.key,
        c = e.set;e.exp({ metadata: function metadata(t, n) {
        return function (r, e) {
          c(t, n, (void 0 !== e ? i : o)(r), u(e));
        };
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(27),
        i = r(1),
        o = e.has,
        u = e.key;e.exp({ hasOwnMetadata: function hasOwnMetadata(t, n) {
        return o(t, i(n), arguments.length < 3 ? void 0 : u(arguments[2]));
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(27),
        i = r(1),
        o = r(14),
        u = e.has,
        c = e.key;e.exp({ hasMetadata: function hasMetadata(t, n) {
        return function t(n, r, e) {
          if (u(n, r, e)) return !0;var i = o(r);return null !== i && t(n, i, e);
        }(t, i(n), arguments.length < 3 ? void 0 : c(arguments[2]));
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(27),
        i = r(1),
        o = e.keys,
        u = e.key;e.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(t) {
        return o(i(t), arguments.length < 2 ? void 0 : u(arguments[1]));
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(27),
        i = r(1),
        o = e.get,
        u = e.key;e.exp({ getOwnMetadata: function getOwnMetadata(t, n) {
        return o(t, i(n), arguments.length < 3 ? void 0 : u(arguments[2]));
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(101),
        i = r(92),
        o = r(27),
        u = r(1),
        c = r(14),
        s = o.keys,
        f = o.key;o.exp({ getMetadataKeys: function getMetadataKeys(t) {
        return function t(n, r) {
          var o = s(n, r),
              u = c(n);if (null === u) return o;var f = t(u, r);return f.length ? o.length ? i(new e(o.concat(f))) : f : o;
        }(u(t), arguments.length < 2 ? void 0 : f(arguments[1]));
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(27),
        i = r(1),
        o = r(14),
        u = e.has,
        c = e.get,
        s = e.key;e.exp({ getMetadata: function getMetadata(t, n) {
        return function t(n, r, e) {
          if (u(n, r, e)) return c(n, r, e);var i = o(r);return null !== i ? t(n, i, e) : void 0;
        }(t, i(n), arguments.length < 3 ? void 0 : s(arguments[2]));
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(27),
        i = r(1),
        o = e.key,
        u = e.map,
        c = e.store;e.exp({ deleteMetadata: function deleteMetadata(t, n) {
        var r = arguments.length < 3 ? void 0 : o(arguments[2]),
            e = u(i(n), r, !1);if (void 0 === e || !e.delete(t)) return !1;if (e.size) return !0;var s = c.get(n);return s.delete(r), !!s.size || c.delete(n);
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(27),
        i = r(1),
        o = e.key,
        u = e.set;e.exp({ defineMetadata: function defineMetadata(t, n, r, e) {
        u(t, n, i(r), o(e));
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(65),
        o = r(105);e(e.S, "Promise", { try: function _try(t) {
        var n = i.f(this),
            r = o(t);return (r.e ? n.reject : n.resolve)(r.v), n.promise;
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(26),
        o = r(2),
        u = r(54),
        c = r(104);e(e.P + e.R, "Promise", { finally: function _finally(t) {
        var n = u(this, i.Promise || o.Promise),
            r = "function" == typeof t;return this.then(r ? function (r) {
          return c(n, t()).then(function () {
            return r;
          });
        } : t, r ? function (r) {
          return c(n, t()).then(function () {
            throw r;
          });
        } : t);
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0);e(e.S, "Math", { signbit: function signbit(t) {
        return (t = +t) != t ? t : 0 == t ? 1 / t == 1 / 0 : t > 0;
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0);e(e.S, "Math", { umulh: function umulh(t, n) {
        var r = +t,
            e = +n,
            i = 65535 & r,
            o = 65535 & e,
            u = r >>> 16,
            c = e >>> 16,
            s = (u * o >>> 0) + (i * o >>> 16);return u * c + (s >>> 16) + ((i * c >>> 0) + (65535 & s) >>> 16);
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0);e(e.S, "Math", { scale: r(91) });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = Math.PI / 180;e(e.S, "Math", { radians: function radians(t) {
        return t * i;
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0);e(e.S, "Math", { RAD_PER_DEG: 180 / Math.PI });
  }, function (t, n, r) {
    "use strict";
    var e = r(0);e(e.S, "Math", { imulh: function imulh(t, n) {
        var r = +t,
            e = +n,
            i = 65535 & r,
            o = 65535 & e,
            u = r >> 16,
            c = e >> 16,
            s = (u * o >>> 0) + (i * o >>> 16);return u * c + (s >> 16) + ((i * c >>> 0) + (65535 & s) >> 16);
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0);e(e.S, "Math", { isubh: function isubh(t, n, r, e) {
        var i = t >>> 0,
            o = r >>> 0;return (n >>> 0) - (e >>> 0) - ((~i & o | ~(i ^ o) & i - o >>> 0) >>> 31) | 0;
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0);e(e.S, "Math", { iaddh: function iaddh(t, n, r, e) {
        var i = t >>> 0,
            o = r >>> 0;return (n >>> 0) + (e >>> 0) + ((i & o | (i | o) & ~(i + o >>> 0)) >>> 31) | 0;
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(91),
        o = r(111);e(e.S, "Math", { fscale: function fscale(t, n, r, e, u) {
        return o(i(t, n, r, e, u));
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = 180 / Math.PI;e(e.S, "Math", { degrees: function degrees(t) {
        return t * i;
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0);e(e.S, "Math", { DEG_PER_RAD: Math.PI / 180 });
  }, function (t, n, r) {
    "use strict";
    var e = r(0);e(e.S, "Math", { clamp: function clamp(t, n, r) {
        return Math.min(r, Math.max(n, t));
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(19);e(e.S, "Error", { isError: function isError(t) {
        return "Error" === i(t);
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0);e(e.S, "System", { global: r(2) });
  }, function (t, n, r) {
    "use strict";
    var e = r(0);e(e.G, { global: r(2) });
  }, function (t, n, r) {
    "use strict";
    r(49)("WeakSet");
  }, function (t, n, r) {
    "use strict";
    r(49)("WeakMap");
  }, function (t, n, r) {
    "use strict";
    r(49)("Set");
  }, function (t, n, r) {
    "use strict";
    r(49)("Map");
  }, function (t, n, r) {
    "use strict";
    r(50)("WeakSet");
  }, function (t, n, r) {
    "use strict";
    r(50)("WeakMap");
  }, function (t, n, r) {
    "use strict";
    r(50)("Set");
  }, function (t, n, r) {
    "use strict";
    r(50)("Map");
  }, function (t, n, r) {
    "use strict";
    var e = r(0);e(e.P + e.R, "Set", { toJSON: r(93)("Set") });
  }, function (t, n, r) {
    "use strict";
    var e = r(0);e(e.P + e.R, "Map", { toJSON: r(93)("Map") });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(9),
        o = r(25),
        u = r(14),
        c = r(15).f;r(8) && e(e.P + r(51), "Object", { __lookupSetter__: function __lookupSetter__(t) {
        var n,
            r = i(this),
            e = o(t, !0);do {
          if (n = c(r, e)) return n.set;
        } while (r = u(r));
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(9),
        o = r(25),
        u = r(14),
        c = r(15).f;r(8) && e(e.P + r(51), "Object", { __lookupGetter__: function __lookupGetter__(t) {
        var n,
            r = i(this),
            e = o(t, !0);do {
          if (n = c(r, e)) return n.get;
        } while (r = u(r));
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(9),
        o = r(10),
        u = r(7);r(8) && e(e.P + r(51), "Object", { __defineSetter__: function __defineSetter__(t, n) {
        u.f(i(this), t, { set: o(n), enumerable: !0, configurable: !0 });
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(9),
        o = r(10),
        u = r(7);r(8) && e(e.P + r(51), "Object", { __defineGetter__: function __defineGetter__(t, n) {
        u.f(i(this), t, { get: o(n), enumerable: !0, configurable: !0 });
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(94)(!0);e(e.S, "Object", { entries: function entries(t) {
        return i(t);
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(94)(!1);e(e.S, "Object", { values: function values(t) {
        return i(t);
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(97),
        o = r(16),
        u = r(15),
        c = r(72);e(e.S, "Object", { getOwnPropertyDescriptors: function getOwnPropertyDescriptors(t) {
        for (var n, r, e = o(t), s = u.f, f = i(e), a = {}, l = 0; f.length > l;) {
          void 0 !== (r = s(e, n = f[l++])) && c(a, n, r);
        }return a;
      } });
  }, function (t, n, r) {
    "use strict";
    r(88)("observable");
  }, function (t, n, r) {
    "use strict";
    r(88)("asyncIterator");
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(24),
        o = r(6),
        u = r(58),
        c = r(56),
        s = RegExp.prototype,
        f = function f(t, n) {
      this._r = t, this._s = n;
    };r(76)(f, "RegExp String", function () {
      var t = this._r.exec(this._s);return { value: t, done: null === t };
    }), e(e.P, "String", { matchAll: function matchAll(t) {
        if (i(this), !u(t)) throw TypeError(t + " is not a regexp!");var n = String(this),
            r = "flags" in s ? String(t.flags) : c.call(t),
            e = new RegExp(t.source, ~r.indexOf("g") ? r : "g" + r);return e.lastIndex = o(t.lastIndex), new f(e, n);
      } });
  }, function (t, n, r) {
    "use strict";
    r(44)("trimRight", function (t) {
      return function () {
        return t(this, 2);
      };
    }, "trimEnd");
  }, function (t, n, r) {
    "use strict";
    r(44)("trimLeft", function (t) {
      return function () {
        return t(this, 1);
      };
    }, "trimStart");
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(95),
        o = r(63);e(e.P + e.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(o), "String", { padEnd: function padEnd(t) {
        return i(this, t, arguments.length > 1 ? arguments[1] : void 0, !1);
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(95),
        o = r(63);e(e.P + e.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(o), "String", { padStart: function padStart(t) {
        return i(this, t, arguments.length > 1 ? arguments[1] : void 0, !0);
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(78)(!0);e(e.P, "String", { at: function at(t) {
        return i(this, t);
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(96),
        o = r(9),
        u = r(6),
        c = r(23),
        s = r(70);e(e.P, "Array", { flatten: function flatten() {
        var t = arguments[0],
            n = o(this),
            r = u(n.length),
            e = s(n, 0);return i(e, n, n, r, 0, void 0 === t ? 1 : c(t)), e;
      } }), r(29)("flatten");
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(96),
        o = r(9),
        u = r(6),
        c = r(10),
        s = r(70);e(e.P, "Array", { flatMap: function flatMap(t) {
        var n,
            r,
            e = o(this);return c(t), n = u(e.length), r = s(e, 0), i(r, e, e, n, 0, 1, t, arguments[1]), r;
      } }), r(29)("flatMap");
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(61)(!0);e(e.P, "Array", { includes: function includes(t) {
        return i(this, t, arguments.length > 1 ? arguments[1] : void 0);
      } }), r(29)("includes");
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(84);i && e(e.S, "Reflect", { setPrototypeOf: function setPrototypeOf(t, n) {
        i.check(t, n);try {
          return i.set(t, n), !0;
        } catch (t) {
          return !1;
        }
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(7),
        i = r(15),
        o = r(14),
        u = r(17),
        c = r(0),
        s = r(41),
        f = r(1),
        a = r(4);c(c.S, "Reflect", { set: function t(n, r, c) {
        var l,
            h,
            v = arguments.length < 4 ? n : arguments[3],
            p = i.f(f(n), r);if (!p) {
          if (a(h = o(n))) return t(h, r, c, v);p = s(0);
        }return u(p, "value") ? !(!1 === p.writable || !a(v) || ((l = i.f(v, r) || s(0)).value = c, e.f(v, r, l), 0)) : void 0 !== p.set && (p.set.call(v, c), !0);
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(1),
        o = Object.preventExtensions;e(e.S, "Reflect", { preventExtensions: function preventExtensions(t) {
        i(t);try {
          return o && o(t), !0;
        } catch (t) {
          return !1;
        }
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0);e(e.S, "Reflect", { ownKeys: r(97) });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(1),
        o = Object.isExtensible;e(e.S, "Reflect", { isExtensible: function isExtensible(t) {
        return i(t), !o || o(t);
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0);e(e.S, "Reflect", { has: function has(t, n) {
        return n in t;
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(14),
        o = r(1);e(e.S, "Reflect", { getPrototypeOf: function getPrototypeOf(t) {
        return i(o(t));
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(15),
        i = r(0),
        o = r(1);i(i.S, "Reflect", { getOwnPropertyDescriptor: function getOwnPropertyDescriptor(t, n) {
        return e.f(o(t), n);
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(15),
        i = r(14),
        o = r(17),
        u = r(0),
        c = r(4),
        s = r(1);u(u.S, "Reflect", { get: function t(n, r) {
        var u,
            f,
            a = arguments.length < 3 ? n : arguments[2];return s(n) === a ? n[r] : (u = e.f(n, r)) ? o(u, "value") ? u.value : void 0 !== u.get ? u.get.call(a) : void 0 : c(f = i(n)) ? t(f, r, a) : void 0;
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(1),
        o = function o(t) {
      this._t = i(t), this._i = 0;var n,
          r = this._k = [];for (n in t) {
        r.push(n);
      }
    };r(76)(o, "Object", function () {
      var t,
          n = this._k;do {
        if (this._i >= n.length) return { value: void 0, done: !0 };
      } while (!((t = n[this._i++]) in this._t));return { value: t, done: !1 };
    }), e(e.S, "Reflect", { enumerate: function enumerate(t) {
        return new o(t);
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(15).f,
        o = r(1);e(e.S, "Reflect", { deleteProperty: function deleteProperty(t, n) {
        var r = i(o(t), n);return !(r && !r.configurable) && delete t[n];
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(7),
        i = r(0),
        o = r(1),
        u = r(25);i(i.S + i.F * r(3)(function () {
      Reflect.defineProperty(e.f({}, 1, { value: 1 }), 1, { value: 2 });
    }), "Reflect", { defineProperty: function defineProperty(t, n, r) {
        o(t), n = u(n, !0), o(r);try {
          return e.f(t, n, r), !0;
        } catch (t) {
          return !1;
        }
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(36),
        o = r(10),
        u = r(1),
        c = r(4),
        s = r(3),
        f = r(118),
        a = (r(2).Reflect || {}).construct,
        l = s(function () {
      function t() {}return !(a(function () {}, [], t) instanceof t);
    }),
        h = !s(function () {
      a(function () {});
    });e(e.S + e.F * (l || h), "Reflect", { construct: function construct(t, n) {
        o(t), u(n);var r = arguments.length < 3 ? t : o(arguments[2]);if (h && !l) return a(t, n, r);if (t == r) {
          switch (n.length) {case 0:
              return new t();case 1:
              return new t(n[0]);case 2:
              return new t(n[0], n[1]);case 3:
              return new t(n[0], n[1], n[2]);case 4:
              return new t(n[0], n[1], n[2], n[3]);}var e = [null];return e.push.apply(e, n), new (f.apply(t, e))();
        }var s = r.prototype,
            v = i(c(s) ? s : Object.prototype),
            p = Function.apply.call(t, v, n);return c(p) ? p : v;
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(10),
        o = r(1),
        u = (r(2).Reflect || {}).apply,
        c = Function.apply;e(e.S + e.F * !r(3)(function () {
      u(function () {});
    }), "Reflect", { apply: function apply(t, n, r) {
        var e = i(t),
            s = o(r);return u ? u(e, n, s) : c.call(e, n, s);
      } });
  }, function (t, n, r) {
    "use strict";
    r(28)("Float64", 8, function (t) {
      return function (n, r, e) {
        return t(this, n, r, e);
      };
    });
  }, function (t, n, r) {
    "use strict";
    r(28)("Float32", 4, function (t) {
      return function (n, r, e) {
        return t(this, n, r, e);
      };
    });
  }, function (t, n, r) {
    "use strict";
    r(28)("Uint32", 4, function (t) {
      return function (n, r, e) {
        return t(this, n, r, e);
      };
    });
  }, function (t, n, r) {
    "use strict";
    r(28)("Int32", 4, function (t) {
      return function (n, r, e) {
        return t(this, n, r, e);
      };
    });
  }, function (t, n, r) {
    "use strict";
    r(28)("Uint16", 2, function (t) {
      return function (n, r, e) {
        return t(this, n, r, e);
      };
    });
  }, function (t, n, r) {
    "use strict";
    r(28)("Int16", 2, function (t) {
      return function (n, r, e) {
        return t(this, n, r, e);
      };
    });
  }, function (t, n, r) {
    "use strict";
    r(28)("Uint8", 1, function (t) {
      return function (n, r, e) {
        return t(this, n, r, e);
      };
    }, !0);
  }, function (t, n, r) {
    "use strict";
    r(28)("Uint8", 1, function (t) {
      return function (n, r, e) {
        return t(this, n, r, e);
      };
    });
  }, function (t, n, r) {
    "use strict";
    r(28)("Int8", 1, function (t) {
      return function (n, r, e) {
        return t(this, n, r, e);
      };
    });
  }, function (t, n, r) {
    "use strict";
    var e = r(0);e(e.G + e.W + e.F * !r(52).ABV, { DataView: r(64).DataView });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(52),
        o = r(64),
        u = r(1),
        c = r(37),
        s = r(6),
        f = r(4),
        a = r(2).ArrayBuffer,
        l = r(54),
        h = o.ArrayBuffer,
        v = o.DataView,
        p = i.ABV && a.isView,
        y = h.prototype.slice,
        d = i.VIEW;e(e.G + e.W + e.F * (a !== h), { ArrayBuffer: h }), e(e.S + e.F * !i.CONSTR, "ArrayBuffer", { isView: function isView(t) {
        return p && p(t) || f(t) && d in t;
      } }), e(e.P + e.U + e.F * r(3)(function () {
      return !new h(2).slice(1, void 0).byteLength;
    }), "ArrayBuffer", { slice: function slice(t, n) {
        if (void 0 !== y && void 0 === n) return y.call(u(this), t);for (var r = u(this).byteLength, e = c(t, r), i = c(void 0 === n ? r : n, r), o = new (l(this, h))(s(i - e)), f = new v(this), a = new v(o), p = 0; e < i;) {
          a.setUint8(p++, f.getUint8(e++));
        }return o;
      } }), r(34)("ArrayBuffer");
  }, function (t, n, r) {
    "use strict";
    var e = r(99),
        i = r(42);r(53)("WeakSet", function (t) {
      return function () {
        return t(this, arguments.length > 0 ? arguments[0] : void 0);
      };
    }, { add: function add(t) {
        return e.def(i(this, "WeakSet"), t, !0);
      } }, e, !1, !0);
  }, function (t, n, r) {
    "use strict";
    var e,
        i,
        o,
        u,
        c = r(39),
        s = r(2),
        f = r(20),
        a = r(46),
        l = r(0),
        h = r(4),
        v = r(10),
        p = r(33),
        y = r(32),
        d = r(54),
        g = r(67).set,
        b = r(66)(),
        m = r(65),
        S = r(105),
        w = r(104),
        x = s.TypeError,
        _ = s.process,
        _E = s.Promise,
        O = "process" == a(_),
        M = function M() {},
        P = i = m.f,
        F = !!function () {
      try {
        var t = _E.resolve(1),
            n = (t.constructor = {})[r(5)("species")] = function (t) {
          t(M, M);
        };return (O || "function" == typeof PromiseRejectionEvent) && t.then(M) instanceof n;
      } catch (t) {}
    }(),
        j = function j(t) {
      var n;return !(!h(t) || "function" != typeof (n = t.then)) && n;
    },
        A = function A(t, n) {
      if (!t._n) {
        t._n = !0;var r = t._c;b(function () {
          for (var e = t._v, i = 1 == t._s, o = 0, u = function u(n) {
            var r,
                o,
                u,
                c = i ? n.ok : n.fail,
                s = n.resolve,
                f = n.reject,
                a = n.domain;try {
              c ? (i || (2 == t._h && T(t), t._h = 1), !0 === c ? r = e : (a && a.enter(), r = c(e), a && (a.exit(), u = !0)), r === n.promise ? f(x("Promise-chain cycle")) : (o = j(r)) ? o.call(r, s, f) : s(r)) : f(e);
            } catch (t) {
              a && !u && a.exit(), f(t);
            }
          }; r.length > o;) {
            u(r[o++]);
          }t._c = [], t._n = !1, n && !t._h && N(t);
        });
      }
    },
        N = function N(t) {
      g.call(s, function () {
        var n,
            r,
            e,
            i = t._v,
            o = I(t);if (o && (n = S(function () {
          O ? _.emit("unhandledRejection", i, t) : (r = s.onunhandledrejection) ? r({ promise: t, reason: i }) : (e = s.console) && e.error && e.error("Unhandled promise rejection", i);
        }), t._h = O || I(t) ? 2 : 1), t._a = void 0, o && n.e) throw n.v;
      });
    },
        I = function I(t) {
      return 1 !== t._h && 0 === (t._a || t._c).length;
    },
        T = function T(t) {
      g.call(s, function () {
        var n;O ? _.emit("rejectionHandled", t) : (n = s.onrejectionhandled) && n({ promise: t, reason: t._v });
      });
    },
        k = function k(t) {
      var n = this;n._d || (n._d = !0, (n = n._w || n)._v = t, n._s = 2, n._a || (n._a = n._c.slice()), A(n, !0));
    },
        L = function t(n) {
      var r,
          e = this;if (!e._d) {
        e._d = !0, e = e._w || e;try {
          if (e === n) throw x("Promise can't be resolved itself");(r = j(n)) ? b(function () {
            var i = { _w: e, _d: !1 };try {
              r.call(n, f(t, i, 1), f(k, i, 1));
            } catch (t) {
              k.call(i, t);
            }
          }) : (e._v = n, e._s = 1, A(e, !1));
        } catch (t) {
          k.call({ _w: e, _d: !1 }, t);
        }
      }
    };F || (_E = function E(t) {
      p(this, _E, "Promise", "_h"), v(t), e.call(this);try {
        t(f(L, this, 1), f(k, this, 1));
      } catch (t) {
        k.call(this, t);
      }
    }, (e = function e(t) {
      this._c = [], this._a = void 0, this._s = 0, this._d = !1, this._v = void 0, this._h = 0, this._n = !1;
    }).prototype = r(31)(_E.prototype, { then: function then(t, n) {
        var r = P(d(this, _E));return r.ok = "function" != typeof t || t, r.fail = "function" == typeof n && n, r.domain = O ? _.domain : void 0, this._c.push(r), this._a && this._a.push(r), this._s && A(this, !1), r.promise;
      }, catch: function _catch(t) {
        return this.then(void 0, t);
      } }), o = function o() {
      var t = new e();this.promise = t, this.resolve = f(L, t, 1), this.reject = f(k, t, 1);
    }, m.f = P = function P(t) {
      return t === _E || t === u ? new o(t) : i(t);
    }), l(l.G + l.W + l.F * !F, { Promise: _E }), r(45)(_E, "Promise"), r(34)("Promise"), u = r(26).Promise, l(l.S + l.F * !F, "Promise", { reject: function reject(t) {
        var n = P(this);return (0, n.reject)(t), n.promise;
      } }), l(l.S + l.F * (c || !F), "Promise", { resolve: function resolve(t) {
        return w(c && this === u ? _E : this, t);
      } }), l(l.S + l.F * !(F && r(57)(function (t) {
      _E.all(t).catch(M);
    })), "Promise", { all: function all(t) {
        var n = this,
            r = P(n),
            e = r.resolve,
            i = r.reject,
            o = S(function () {
          var r = [],
              o = 0,
              u = 1;y(t, !1, function (t) {
            var c = o++,
                s = !1;r.push(void 0), u++, n.resolve(t).then(function (t) {
              s || (s = !0, r[c] = t, --u || e(r));
            }, i);
          }), --u || e(r);
        });return o.e && i(o.v), r.promise;
      }, race: function race(t) {
        var n = this,
            r = P(n),
            e = r.reject,
            i = S(function () {
          y(t, !1, function (t) {
            n.resolve(t).then(r.resolve, e);
          });
        });return i.e && e(i.v), r.promise;
      } });
  }, function (t, n, r) {
    "use strict";
    r(55)("split", 2, function (t, n, e) {
      var i = r(58),
          o = e,
          u = [].push;if ("c" == "abbc".split(/(b)*/)[1] || 4 != "test".split(/(?:)/, -1).length || 2 != "ab".split(/(?:ab)*/).length || 4 != ".".split(/(.?)(.?)/).length || ".".split(/()()/).length > 1 || "".split(/.?/).length) {
        var c = void 0 === /()??/.exec("")[1];e = function e(t, n) {
          var r = String(this);if (void 0 === t && 0 === n) return [];if (!i(t)) return o.call(r, t, n);var e,
              s,
              f,
              a,
              l,
              h = [],
              v = (t.ignoreCase ? "i" : "") + (t.multiline ? "m" : "") + (t.unicode ? "u" : "") + (t.sticky ? "y" : ""),
              p = 0,
              y = void 0 === n ? 4294967295 : n >>> 0,
              d = new RegExp(t.source, v + "g");for (c || (e = new RegExp("^" + d.source + "$(?!\\s)", v)); (s = d.exec(r)) && !((f = s.index + s[0].length) > p && (h.push(r.slice(p, s.index)), !c && s.length > 1 && s[0].replace(e, function () {
            for (l = 1; l < arguments.length - 2; l++) {
              void 0 === arguments[l] && (s[l] = void 0);
            }
          }), s.length > 1 && s.index < r.length && u.apply(h, s.slice(1)), a = s[0].length, p = f, h.length >= y));) {
            d.lastIndex === s.index && d.lastIndex++;
          }return p === r.length ? !a && d.test("") || h.push("") : h.push(r.slice(p)), h.length > y ? h.slice(0, y) : h;
        };
      } else "0".split(void 0, 0).length && (e = function e(t, n) {
        return void 0 === t && 0 === n ? [] : o.call(this, t, n);
      });return [function (r, i) {
        var o = t(this),
            u = void 0 == r ? void 0 : r[n];return void 0 !== u ? u.call(r, o, i) : e.call(String(o), r, i);
      }, e];
    });
  }, function (t, n, r) {
    "use strict";
    r(55)("search", 1, function (t, n, r) {
      return [function (r) {
        var e = t(this),
            i = void 0 == r ? void 0 : r[n];return void 0 !== i ? i.call(r, e) : new RegExp(r)[n](String(e));
      }, r];
    });
  }, function (t, n, r) {
    "use strict";
    r(55)("replace", 2, function (t, n, r) {
      return [function (e, i) {
        var o = t(this),
            u = void 0 == e ? void 0 : e[n];return void 0 !== u ? u.call(e, o, i) : r.call(String(o), e, i);
      }, r];
    });
  }, function (t, n, r) {
    "use strict";
    r(55)("match", 1, function (t, n, r) {
      return [function (r) {
        var e = t(this),
            i = void 0 == r ? void 0 : r[n];return void 0 !== i ? i.call(r, e) : new RegExp(r)[n](String(e));
      }, r];
    });
  }, function (t, n, r) {
    "use strict";
    r(106);var e = r(1),
        i = r(56),
        o = r(8),
        u = /./.toString,
        c = function c(t) {
      r(12)(RegExp.prototype, "toString", t, !0);
    };r(3)(function () {
      return "/a/b" != u.call({ source: "a", flags: "b" });
    }) ? c(function () {
      var t = e(this);return "/".concat(t.source, "/", "flags" in t ? t.flags : !o && t instanceof RegExp ? i.call(t) : void 0);
    }) : "toString" != u.name && c(function () {
      return u.call(this);
    });
  }, function (t, n, r) {
    "use strict";
    var e = r(2),
        i = r(82),
        o = r(7).f,
        u = r(35).f,
        c = r(58),
        s = r(56),
        _f = e.RegExp,
        a = _f,
        l = _f.prototype,
        h = /a/g,
        v = /a/g,
        p = new _f(h) !== h;if (r(8) && (!p || r(3)(function () {
      return v[r(5)("match")] = !1, _f(h) != h || _f(v) == v || "/a/i" != _f(h, "i");
    }))) {
      _f = function f(t, n) {
        var r = this instanceof _f,
            e = c(t),
            o = void 0 === n;return !r && e && t.constructor === _f && o ? t : i(p ? new a(e && !o ? t.source : t, n) : a((e = t instanceof _f) ? t.source : t, e && o ? s.call(t) : n), r ? this : l, _f);
      };for (var y = function y(t) {
        (t in _f) || o(_f, t, { configurable: !0, get: function get() {
            return a[t];
          }, set: function set(n) {
            a[t] = n;
          } });
      }, d = u(a), g = 0; d.length > g;) {
        y(d[g++]);
      }l.constructor = _f, _f.prototype = l, r(12)(e, "RegExp", _f);
    }r(34)("RegExp");
  }, function (t, n, r) {
    "use strict";
    r(34)("Array");
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(21)(6),
        o = "findIndex",
        u = !0;o in [] && Array(1)[o](function () {
      u = !1;
    }), e(e.P + e.F * u, "Array", { findIndex: function findIndex(t) {
        return i(this, t, arguments.length > 1 ? arguments[1] : void 0);
      } }), r(29)(o);
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(21)(5),
        o = !0;"find" in [] && Array(1).find(function () {
      o = !1;
    }), e(e.P + e.F * o, "Array", { find: function find(t) {
        return i(this, t, arguments.length > 1 ? arguments[1] : void 0);
      } }), r(29)("find");
  }, function (t, n, r) {
    "use strict";
    var e = r(0);e(e.P, "Array", { fill: r(69) }), r(29)("fill");
  }, function (t, n, r) {
    "use strict";
    var e = r(0);e(e.P, "Array", { copyWithin: r(108) }), r(29)("copyWithin");
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(16),
        o = r(23),
        u = r(6),
        c = [].lastIndexOf,
        s = !!c && 1 / [1].lastIndexOf(1, -0) < 0;e(e.P + e.F * (s || !r(18)(c)), "Array", { lastIndexOf: function lastIndexOf(t) {
        if (s) return c.apply(this, arguments) || 0;var n = i(this),
            r = u(n.length),
            e = r - 1;for (arguments.length > 1 && (e = Math.min(e, o(arguments[1]))), e < 0 && (e = r + e); e >= 0; e--) {
          if (e in n && n[e] === t) return e || 0;
        }return -1;
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(61)(!1),
        o = [].indexOf,
        u = !!o && 1 / [1].indexOf(1, -0) < 0;e(e.P + e.F * (u || !r(18)(o)), "Array", { indexOf: function indexOf(t) {
        return u ? o.apply(this, arguments) || 0 : i(this, t, arguments[1]);
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(109);e(e.P + e.F * !r(18)([].reduceRight, !0), "Array", { reduceRight: function reduceRight(t) {
        return i(this, t, arguments.length, arguments[1], !0);
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(109);e(e.P + e.F * !r(18)([].reduce, !0), "Array", { reduce: function reduce(t) {
        return i(this, t, arguments.length, arguments[1], !1);
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(21)(4);e(e.P + e.F * !r(18)([].every, !0), "Array", { every: function every(t) {
        return i(this, t, arguments[1]);
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(21)(3);e(e.P + e.F * !r(18)([].some, !0), "Array", { some: function some(t) {
        return i(this, t, arguments[1]);
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(21)(2);e(e.P + e.F * !r(18)([].filter, !0), "Array", { filter: function filter(t) {
        return i(this, t, arguments[1]);
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(21)(1);e(e.P + e.F * !r(18)([].map, !0), "Array", { map: function map(t) {
        return i(this, t, arguments[1]);
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(4),
        i = r(59),
        o = r(5)("species");t.exports = function (t) {
      var n;return i(t) && ("function" != typeof (n = t.constructor) || n !== Array && !i(n.prototype) || (n = void 0), e(n) && null === (n = n[o]) && (n = void 0)), void 0 === n ? Array : n;
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(21)(0),
        o = r(18)([].forEach, !0);e(e.P + e.F * !o, "Array", { forEach: function forEach(t) {
        return i(this, t, arguments[1]);
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(10),
        o = r(9),
        u = r(3),
        c = [].sort,
        s = [1, 2, 3];e(e.P + e.F * (u(function () {
      s.sort(void 0);
    }) || !u(function () {
      s.sort(null);
    }) || !r(18)(c)), "Array", { sort: function sort(t) {
        return void 0 === t ? c.call(o(this)) : c.call(o(this), i(t));
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(85),
        o = r(19),
        u = r(37),
        c = r(6),
        s = [].slice;e(e.P + e.F * r(3)(function () {
      i && s.call(i);
    }), "Array", { slice: function slice(t, n) {
        var r = c(this.length),
            e = o(this);if (n = void 0 === n ? r : n, "Array" == e) return s.call(this, t, n);for (var i = u(t, r), f = u(n, r), a = c(f - i), l = new Array(a), h = 0; h < a; h++) {
          l[h] = "String" == e ? this.charAt(i + h) : this[i + h];
        }return l;
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(16),
        o = [].join;e(e.P + e.F * (r(48) != Object || !r(18)(o)), "Array", { join: function join(t) {
        return o.call(i(this), void 0 === t ? "," : t);
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(72);e(e.S + e.F * r(3)(function () {
      function t() {}return !(Array.of.call(t) instanceof t);
    }), "Array", { of: function of() {
        for (var t = 0, n = arguments.length, r = new ("function" == typeof this ? this : Array)(n); n > t;) {
          i(r, t, arguments[t++]);
        }return r.length = n, r;
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(20),
        i = r(0),
        o = r(9),
        u = r(110),
        c = r(73),
        s = r(6),
        f = r(72),
        a = r(71);i(i.S + i.F * !r(57)(function (t) {
      Array.from(t);
    }), "Array", { from: function from(t) {
        var n,
            r,
            i,
            l,
            h = o(t),
            v = "function" == typeof this ? this : Array,
            p = arguments.length,
            y = p > 1 ? arguments[1] : void 0,
            d = void 0 !== y,
            g = 0,
            b = a(h);if (d && (y = e(y, p > 2 ? arguments[2] : void 0, 2)), void 0 == b || v == Array && c(b)) for (r = new v(n = s(h.length)); n > g; g++) {
          f(r, g, d ? y(h[g], g) : h[g]);
        } else for (l = b.call(h), r = new v(); !(i = l.next()).done; g++) {
          f(r, g, d ? u(l, y, [i.value, g], !0) : i.value);
        }return r.length = g, r;
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0);e(e.S, "Array", { isArray: r(59) });
  }, function (t, n, r) {
    "use strict";
    var e = r(1),
        i = r(25);t.exports = function (t) {
      if ("string" !== t && "number" !== t && "default" !== t) throw TypeError("Incorrect hint");return i(e(this), "number" != t);
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(5)("toPrimitive"),
        i = Date.prototype;e in i || r(13)(i, e, r(243));
  }, function (t, n, r) {
    "use strict";
    var e = Date.prototype,
        i = e.toString,
        o = e.getTime;new Date(NaN) + "" != "Invalid Date" && r(12)(e, "toString", function () {
      var t = o.call(this);return t == t ? i.call(this) : "Invalid Date";
    });
  }, function (t, n, r) {
    "use strict";
    var e = r(3),
        i = Date.prototype.getTime,
        o = Date.prototype.toISOString,
        u = function u(t) {
      return t > 9 ? t : "0" + t;
    };t.exports = e(function () {
      return "0385-07-25T07:06:39.999Z" != o.call(new Date(-5e13 - 1));
    }) || !e(function () {
      o.call(new Date(NaN));
    }) ? function () {
      if (!isFinite(i.call(this))) throw RangeError("Invalid time value");var t = this,
          n = t.getUTCFullYear(),
          r = t.getUTCMilliseconds(),
          e = n < 0 ? "-" : n > 9999 ? "+" : "";return e + ("00000" + Math.abs(n)).slice(e ? -6 : -4) + "-" + u(t.getUTCMonth() + 1) + "-" + u(t.getUTCDate()) + "T" + u(t.getUTCHours()) + ":" + u(t.getUTCMinutes()) + ":" + u(t.getUTCSeconds()) + "." + (r > 99 ? r : "0" + u(r)) + "Z";
    } : o;
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(246);e(e.P + e.F * (Date.prototype.toISOString !== i), "Date", { toISOString: i });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(9),
        o = r(25);e(e.P + e.F * r(3)(function () {
      return null !== new Date(NaN).toJSON() || 1 !== Date.prototype.toJSON.call({ toISOString: function toISOString() {
          return 1;
        } });
    }), "Date", { toJSON: function toJSON(t) {
        var n = i(this),
            r = o(n);return "number" != typeof r || isFinite(r) ? n.toISOString() : null;
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0);e(e.S, "Date", { now: function now() {
        return new Date().getTime();
      } });
  }, function (t, n, r) {
    "use strict";
    r(11)("sup", function (t) {
      return function () {
        return t(this, "sup", "", "");
      };
    });
  }, function (t, n, r) {
    "use strict";
    r(11)("sub", function (t) {
      return function () {
        return t(this, "sub", "", "");
      };
    });
  }, function (t, n, r) {
    "use strict";
    r(11)("strike", function (t) {
      return function () {
        return t(this, "strike", "", "");
      };
    });
  }, function (t, n, r) {
    "use strict";
    r(11)("small", function (t) {
      return function () {
        return t(this, "small", "", "");
      };
    });
  }, function (t, n, r) {
    "use strict";
    r(11)("link", function (t) {
      return function (n) {
        return t(this, "a", "href", n);
      };
    });
  }, function (t, n, r) {
    "use strict";
    r(11)("italics", function (t) {
      return function () {
        return t(this, "i", "", "");
      };
    });
  }, function (t, n, r) {
    "use strict";
    r(11)("fontsize", function (t) {
      return function (n) {
        return t(this, "font", "size", n);
      };
    });
  }, function (t, n, r) {
    "use strict";
    r(11)("fontcolor", function (t) {
      return function (n) {
        return t(this, "font", "color", n);
      };
    });
  }, function (t, n, r) {
    "use strict";
    r(11)("fixed", function (t) {
      return function () {
        return t(this, "tt", "", "");
      };
    });
  }, function (t, n, r) {
    "use strict";
    r(11)("bold", function (t) {
      return function () {
        return t(this, "b", "", "");
      };
    });
  }, function (t, n, r) {
    "use strict";
    r(11)("blink", function (t) {
      return function () {
        return t(this, "blink", "", "");
      };
    });
  }, function (t, n, r) {
    "use strict";
    r(11)("big", function (t) {
      return function () {
        return t(this, "big", "", "");
      };
    });
  }, function (t, n, r) {
    "use strict";
    r(11)("anchor", function (t) {
      return function (n) {
        return t(this, "a", "name", n);
      };
    });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(6),
        o = r(75),
        u = "".startsWith;e(e.P + e.F * r(74)("startsWith"), "String", { startsWith: function startsWith(t) {
        var n = o(this, t, "startsWith"),
            r = i(Math.min(arguments.length > 1 ? arguments[1] : void 0, n.length)),
            e = String(t);return u ? u.call(n, e, r) : n.slice(r, r + e.length) === e;
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0);e(e.P, "String", { repeat: r(81) });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(75);e(e.P + e.F * r(74)("includes"), "String", { includes: function includes(t) {
        return !!~i(this, t, "includes").indexOf(t, arguments.length > 1 ? arguments[1] : void 0);
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(6),
        o = r(75),
        u = "".endsWith;e(e.P + e.F * r(74)("endsWith"), "String", { endsWith: function endsWith(t) {
        var n = o(this, t, "endsWith"),
            r = arguments.length > 1 ? arguments[1] : void 0,
            e = i(n.length),
            c = void 0 === r ? e : Math.min(i(r), e),
            s = String(t);return u ? u.call(n, s, c) : n.slice(c - s.length, c) === s;
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(78)(!1);e(e.P, "String", { codePointAt: function codePointAt(t) {
        return i(this, t);
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(78)(!0);r(77)(String, "String", function (t) {
      this._t = String(t), this._i = 0;
    }, function () {
      var t,
          n = this._t,
          r = this._i;return r >= n.length ? { value: void 0, done: !0 } : (t = e(n, r), this._i += t.length, { value: t, done: !1 });
    });
  }, function (t, n, r) {
    "use strict";
    r(44)("trim", function (t) {
      return function () {
        return t(this, 3);
      };
    });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(16),
        o = r(6);e(e.S, "String", { raw: function raw(t) {
        for (var n = i(t.raw), r = o(n.length), e = arguments.length, u = [], c = 0; r > c;) {
          u.push(String(n[c++])), c < e && u.push(String(arguments[c]));
        }return u.join("");
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(37),
        o = String.fromCharCode,
        u = String.fromCodePoint;e(e.S + e.F * (!!u && 1 != u.length), "String", { fromCodePoint: function fromCodePoint(t) {
        for (var n, r = [], e = arguments.length, u = 0; e > u;) {
          if (n = +arguments[u++], i(n, 1114111) !== n) throw RangeError(n + " is not a valid code point");r.push(n < 65536 ? o(n) : o(55296 + ((n -= 65536) >> 10), n % 1024 + 56320));
        }return r.join("");
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0);e(e.S, "Math", { trunc: function trunc(t) {
        return (t > 0 ? Math.floor : Math.ceil)(t);
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(79),
        o = Math.exp;e(e.S, "Math", { tanh: function tanh(t) {
        var n = i(t = +t),
            r = i(-t);return n == 1 / 0 ? 1 : r == 1 / 0 ? -1 : (n - r) / (o(t) + o(-t));
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(79),
        o = Math.exp;e(e.S + e.F * r(3)(function () {
      return -2e-17 != !Math.sinh(-2e-17);
    }), "Math", { sinh: function sinh(t) {
        return Math.abs(t = +t) < 1 ? (i(t) - i(-t)) / 2 : (o(t - 1) - o(-t - 1)) * (Math.E / 2);
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0);e(e.S, "Math", { sign: r(80) });
  }, function (t, n, r) {
    "use strict";
    var e = r(0);e(e.S, "Math", { log2: function log2(t) {
        return Math.log(t) / Math.LN2;
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0);e(e.S, "Math", { log1p: r(112) });
  }, function (t, n, r) {
    "use strict";
    var e = r(0);e(e.S, "Math", { log10: function log10(t) {
        return Math.log(t) * Math.LOG10E;
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = Math.imul;e(e.S + e.F * r(3)(function () {
      return -5 != i(4294967295, 5) || 2 != i.length;
    }), "Math", { imul: function imul(t, n) {
        var r = +t,
            e = +n,
            i = 65535 & r,
            o = 65535 & e;return 0 | i * o + ((65535 & r >>> 16) * o + i * (65535 & e >>> 16) << 16 >>> 0);
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = Math.abs;e(e.S, "Math", { hypot: function hypot(t, n) {
        for (var r, e, o = 0, u = 0, c = arguments.length, s = 0; u < c;) {
          s < (r = i(arguments[u++])) ? (o = o * (e = s / r) * e + 1, s = r) : o += r > 0 ? (e = r / s) * e : r;
        }return s === 1 / 0 ? 1 / 0 : s * Math.sqrt(o);
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0);e(e.S, "Math", { fround: r(111) });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(79);e(e.S + e.F * (i != Math.expm1), "Math", { expm1: i });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = Math.exp;e(e.S, "Math", { cosh: function cosh(t) {
        return (i(t = +t) + i(-t)) / 2;
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0);e(e.S, "Math", { clz32: function clz32(t) {
        return (t >>>= 0) ? 31 - Math.floor(Math.log(t + .5) * Math.LOG2E) : 32;
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(80);e(e.S, "Math", { cbrt: function cbrt(t) {
        return i(t = +t) * Math.pow(Math.abs(t), 1 / 3);
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = Math.atanh;e(e.S + e.F * !(i && 1 / i(-0) < 0), "Math", { atanh: function atanh(t) {
        return 0 == (t = +t) ? t : Math.log((1 + t) / (1 - t)) / 2;
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = Math.asinh;e(e.S + e.F * !(i && 1 / i(0) > 0), "Math", { asinh: function t(n) {
        return isFinite(n = +n) && 0 != n ? n < 0 ? -t(-n) : Math.log(n + Math.sqrt(n * n + 1)) : n;
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(112),
        o = Math.sqrt,
        u = Math.acosh;e(e.S + e.F * !(u && 710 == Math.floor(u(Number.MAX_VALUE)) && u(1 / 0) == 1 / 0), "Math", { acosh: function acosh(t) {
        return (t = +t) < 1 ? NaN : t > 94906265.62425156 ? Math.log(t) + Math.LN2 : i(t - 1 + o(t - 1) * o(t + 1));
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(116);e(e.S + e.F * (Number.parseInt != i), "Number", { parseInt: i });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(115);e(e.S + e.F * (Number.parseFloat != i), "Number", { parseFloat: i });
  }, function (t, n, r) {
    "use strict";
    var e = r(0);e(e.S, "Number", { MIN_SAFE_INTEGER: -9007199254740991 });
  }, function (t, n, r) {
    "use strict";
    var e = r(0);e(e.S, "Number", { MAX_SAFE_INTEGER: 9007199254740991 });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(113),
        o = Math.abs;e(e.S, "Number", { isSafeInteger: function isSafeInteger(t) {
        return i(t) && o(t) <= 9007199254740991;
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0);e(e.S, "Number", { isNaN: function isNaN(t) {
        return t != t;
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0);e(e.S, "Number", { isInteger: r(113) });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(2).isFinite;e(e.S, "Number", { isFinite: function isFinite(t) {
        return "number" == typeof t && i(t);
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0);e(e.S, "Number", { EPSILON: Math.pow(2, -52) });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(3),
        o = r(114),
        u = 1..toPrecision;e(e.P + e.F * (i(function () {
      return "1" !== u.call(1, void 0);
    }) || !i(function () {
      u.call({});
    })), "Number", { toPrecision: function toPrecision(t) {
        var n = o(this, "Number#toPrecision: incorrect invocation!");return void 0 === t ? u.call(n) : u.call(n, t);
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(23),
        o = r(114),
        u = r(81),
        c = 1..toFixed,
        s = Math.floor,
        f = [0, 0, 0, 0, 0, 0],
        a = "Number.toFixed: incorrect invocation!",
        l = function l(t, n) {
      for (var r = -1, e = n; ++r < 6;) {
        e += t * f[r], f[r] = e % 1e7, e = s(e / 1e7);
      }
    },
        h = function h(t) {
      for (var n = 6, r = 0; --n >= 0;) {
        r += f[n], f[n] = s(r / t), r = r % t * 1e7;
      }
    },
        v = function v() {
      for (var t = 6, n = ""; --t >= 0;) {
        if ("" !== n || 0 === t || 0 !== f[t]) {
          var r = String(f[t]);n = "" === n ? r : n + u.call("0", 7 - r.length) + r;
        }
      }return n;
    },
        p = function t(n, r, e) {
      return 0 === r ? e : r % 2 == 1 ? t(n, r - 1, e * n) : t(n * n, r / 2, e);
    };e(e.P + e.F * (!!c && ("0.000" !== 8e-5.toFixed(3) || "1" !== .9.toFixed(0) || "1.25" !== 1.255.toFixed(2) || "1000000000000000128" !== 0xde0b6b3a7640080.toFixed(0)) || !r(3)(function () {
      c.call({});
    })), "Number", { toFixed: function toFixed(t) {
        var n,
            r,
            e,
            c,
            s = o(this, a),
            f = i(t),
            y = "",
            d = "0";if (f < 0 || f > 20) throw RangeError(a);if (s != s) return "NaN";if (s <= -1e21 || s >= 1e21) return String(s);if (s < 0 && (y = "-", s = -s), s > 1e-21) if (r = (n = function (t) {
          for (var n = 0, r = s * p(2, 69, 1); r >= 4096;) {
            n += 12, r /= 4096;
          }for (; r >= 2;) {
            n += 1, r /= 2;
          }return n;
        }() - 69) < 0 ? s * p(2, -n, 1) : s / p(2, n, 1), r *= 4503599627370496, (n = 52 - n) > 0) {
          for (l(0, r), e = f; e >= 7;) {
            l(1e7, 0), e -= 7;
          }for (l(p(10, e, 1), 0), e = n - 1; e >= 23;) {
            h(1 << 23), e -= 23;
          }h(1 << e), l(1, 1), h(2), d = v();
        } else l(0, r), l(1 << -n, 0), d = v() + u.call("0", f);return f > 0 ? y + ((c = d.length) <= f ? "0." + u.call("0", f - c) + d : d.slice(0, c - f) + "." + d.slice(c - f)) : y + d;
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(2),
        i = r(17),
        o = r(19),
        u = r(82),
        c = r(25),
        s = r(3),
        f = r(35).f,
        a = r(15).f,
        l = r(7).f,
        h = r(44).trim,
        _v = e.Number,
        p = _v,
        y = _v.prototype,
        d = "Number" == o(r(36)(y)),
        g = "trim" in String.prototype,
        b = function b(t) {
      var n = c(t, !1);if ("string" == typeof n && n.length > 2) {
        var r,
            e,
            i,
            o = (n = g ? n.trim() : h(n, 3)).charCodeAt(0);if (43 === o || 45 === o) {
          if (88 === (r = n.charCodeAt(2)) || 120 === r) return NaN;
        } else if (48 === o) {
          switch (n.charCodeAt(1)) {case 66:case 98:
              e = 2, i = 49;break;case 79:case 111:
              e = 8, i = 55;break;default:
              return +n;}for (var u, s = n.slice(2), f = 0, a = s.length; f < a; f++) {
            if ((u = s.charCodeAt(f)) < 48 || u > i) return NaN;
          }return parseInt(s, e);
        }
      }return +n;
    };if (!_v(" 0o1") || !_v("0b1") || _v("+0x1")) {
      _v = function v(t) {
        var n = arguments.length < 1 ? 0 : t,
            r = this;return r instanceof _v && (d ? s(function () {
          y.valueOf.call(r);
        }) : "Number" != o(r)) ? u(new p(b(n)), r, _v) : b(n);
      };for (var m, S = r(8) ? f(p) : "MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger".split(","), w = 0; S.length > w; w++) {
        i(p, m = S[w]) && !i(_v, m) && l(_v, m, a(p, m));
      }_v.prototype = y, y.constructor = _v, r(12)(e, "Number", _v);
    }
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(115);e(e.G + e.F * (parseFloat != i), { parseFloat: i });
  }, function (t, n, r) {
    "use strict";
    var e = r(0),
        i = r(116);e(e.G + e.F * (parseInt != i), { parseInt: i });
  }, function (t, n, r) {
    "use strict";
    var e = r(4),
        i = r(14),
        o = r(5)("hasInstance"),
        u = Function.prototype;o in u || r(7).f(u, o, { value: function value(t) {
        if ("function" != typeof this || !e(t)) return !1;if (!e(this.prototype)) return t instanceof this;for (; t = i(t);) {
          if (this.prototype === t) return !0;
        }return !1;
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(7).f,
        i = Function.prototype,
        o = /^\s*function ([^ (]*)/;"name" in i || r(8) && e(i, "name", { configurable: !0, get: function get() {
        try {
          return ("" + this).match(o)[1];
        } catch (t) {
          return "";
        }
      } });
  }, function (t, n, r) {
    "use strict";
    var e = r(0);e(e.P, "Function", { bind: r(118) });
  }, function (t, n, r) {
    "use strict";
    var e = r(46),
        i = {};i[r(5)("toStringTag")] = "z", i + "" != "[object z]" && r(12)(Object.prototype, "toString", function () {
      return "[object " + e(this) + "]";
    }, !0);
  }, function (t, n, r) {
    "use strict";
    var e = r(0);e(e.S, "Object", { setPrototypeOf: r(84).set });
  }, function (t, n, r) {
    "use strict";
    t.exports = Object.is || function (t, n) {
      return t === n ? 0 !== t || 1 / t == 1 / n : t != t && n != n;
    };
  }, function (t, n, r) {
    "use strict";
    var e = r(0);e(e.S, "Object", { is: r(308) });
  }, function (t, n, r) {
    "use strict";
    var e = r(0);e(e.S + e.F, "Object", { assign: r(119) });
  }, function (t, n, r) {
    "use strict";
    var e = r(4);r(22)("isExtensible", function (t) {
      return function (n) {
        return !!e(n) && (!t || t(n));
      };
    });
  }, function (t, n, r) {
    "use strict";
    var e = r(4);r(22)("isSealed", function (t) {
      return function (n) {
        return !e(n) || !!t && t(n);
      };
    });
  }, function (t, n, r) {
    "use strict";
    var e = r(4);r(22)("isFrozen", function (t) {
      return function (n) {
        return !e(n) || !!t && t(n);
      };
    });
  }, function (t, n, r) {
    "use strict";
    var e = r(4),
        i = r(30).onFreeze;r(22)("preventExtensions", function (t) {
      return function (n) {
        return t && e(n) ? t(i(n)) : n;
      };
    });
  }, function (t, n, r) {
    "use strict";
    var e = r(4),
        i = r(30).onFreeze;r(22)("seal", function (t) {
      return function (n) {
        return t && e(n) ? t(i(n)) : n;
      };
    });
  }, function (t, n, r) {
    "use strict";
    var e = r(4),
        i = r(30).onFreeze;r(22)("freeze", function (t) {
      return function (n) {
        return t && e(n) ? t(i(n)) : n;
      };
    });
  }, function (t, n, r) {
    "use strict";
    r(22)("getOwnPropertyNames", function () {
      return r(120).f;
    });
  }, function (t, n, r) {
    "use strict";
    var e = r(9),
        i = r(38);r(22)("keys", function () {
      return function (t) {
        return i(e(t));
      };
    });
  }, function (t, n, r) {
    "use strict";
    var e = r(9),
        i = r(14);r(22)("getPrototypeOf", function () {
      return function (t) {
        return i(e(t));
      };
    });
  }, function (t, n, r) {
    "use strict";
    var e = r(16),
        i = r(15).f;r(22)("getOwnPropertyDescriptor", function () {
      return function (t, n) {
        return i(e(t), n);
      };
    });
  }, function (t, n, r) {
    "use strict";
    var e = r(0);e(e.S + e.F * !r(8), "Object", { defineProperties: r(121) });
  }, function (t, n, r) {
    "use strict";
    var e = r(0);e(e.S + e.F * !r(8), "Object", { defineProperty: r(7).f });
  }, function (t, n, r) {
    "use strict";
    var e = r(0);e(e.S, "Object", { create: r(36) });
  }, function (t, n, r) {
    "use strict";
    var e = r(38),
        i = r(60),
        o = r(47);t.exports = function (t) {
      var n = e(t),
          r = i.f;if (r) for (var u, c = r(t), s = o.f, f = 0; c.length > f;) {
        s.call(t, u = c[f++]) && n.push(u);
      }return n;
    };
  }, function (t, n, r) {
    "use strict";
    var e = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (t) {
      return typeof t === "undefined" ? "undefined" : _typeof(t);
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : _typeof(t);
    },
        i = r(2),
        o = r(17),
        u = r(8),
        c = r(0),
        s = r(12),
        f = r(30).KEY,
        a = r(3),
        l = r(62),
        h = r(45),
        v = r(40),
        p = r(5),
        y = r(123),
        d = r(88),
        g = r(324),
        b = r(59),
        m = r(1),
        S = r(4),
        w = r(16),
        x = r(25),
        _ = r(41),
        E = r(36),
        O = r(120),
        M = r(15),
        P = r(7),
        F = r(38),
        j = M.f,
        A = P.f,
        N = O.f,
        _I = i.Symbol,
        T = i.JSON,
        k = T && T.stringify,
        L = p("_hidden"),
        R = p("toPrimitive"),
        D = {}.propertyIsEnumerable,
        W = l("symbol-registry"),
        C = l("symbols"),
        G = l("op-symbols"),
        U = Object.prototype,
        B = "function" == typeof _I,
        V = i.QObject,
        z = !V || !V.prototype || !V.prototype.findChild,
        Y = u && a(function () {
      return 7 != E(A({}, "a", { get: function get() {
          return A(this, "a", { value: 7 }).a;
        } })).a;
    }) ? function (t, n, r) {
      var e = j(U, n);e && delete U[n], A(t, n, r), e && t !== U && A(U, n, e);
    } : A,
        J = function J(t) {
      var n = C[t] = E(_I.prototype);return n._k = t, n;
    },
        K = B && "symbol" == e(_I.iterator) ? function (t) {
      return "symbol" == (void 0 === t ? "undefined" : e(t));
    } : function (t) {
      return t instanceof _I;
    },
        q = function q(t, n, r) {
      return t === U && q(G, n, r), m(t), n = x(n, !0), m(r), o(C, n) ? (r.enumerable ? (o(t, L) && t[L][n] && (t[L][n] = !1), r = E(r, { enumerable: _(0, !1) })) : (o(t, L) || A(t, L, _(1, {})), t[L][n] = !0), Y(t, n, r)) : A(t, n, r);
    },
        H = function H(t, n) {
      m(t);for (var r, e = g(n = w(n)), i = 0, o = e.length; o > i;) {
        q(t, r = e[i++], n[r]);
      }return t;
    },
        X = function X(t) {
      var n = D.call(this, t = x(t, !0));return !(this === U && o(C, t) && !o(G, t)) && (!(n || !o(this, t) || !o(C, t) || o(this, L) && this[L][t]) || n);
    },
        $ = function $(t, n) {
      if (t = w(t), n = x(n, !0), t !== U || !o(C, n) || o(G, n)) {
        var r = j(t, n);return !r || !o(C, n) || o(t, L) && t[L][n] || (r.enumerable = !0), r;
      }
    },
        Z = function Z(t) {
      for (var n, r = N(w(t)), e = [], i = 0; r.length > i;) {
        o(C, n = r[i++]) || n == L || n == f || e.push(n);
      }return e;
    },
        Q = function Q(t) {
      for (var n, r = t === U, e = N(r ? G : w(t)), i = [], u = 0; e.length > u;) {
        !o(C, n = e[u++]) || r && !o(U, n) || i.push(C[n]);
      }return i;
    };B || (s((_I = function I() {
      if (this instanceof _I) throw TypeError("Symbol is not a constructor!");var t = v(arguments.length > 0 ? arguments[0] : void 0);return u && z && Y(U, t, { configurable: !0, set: function n(r) {
          this === U && n.call(G, r), o(this, L) && o(this[L], t) && (this[L][t] = !1), Y(this, t, _(1, r));
        } }), J(t);
    }).prototype, "toString", function () {
      return this._k;
    }), M.f = $, P.f = q, r(35).f = O.f = Z, r(47).f = X, r(60).f = Q, u && !r(39) && s(U, "propertyIsEnumerable", X, !0), y.f = function (t) {
      return J(p(t));
    }), c(c.G + c.W + c.F * !B, { Symbol: _I });for (var tt = "hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","), nt = 0; tt.length > nt;) {
      p(tt[nt++]);
    }for (var rt = F(p.store), et = 0; rt.length > et;) {
      d(rt[et++]);
    }c(c.S + c.F * !B, "Symbol", { for: function _for(t) {
        return o(W, t += "") ? W[t] : W[t] = _I(t);
      }, keyFor: function keyFor(t) {
        if (!K(t)) throw TypeError(t + " is not a symbol!");for (var n in W) {
          if (W[n] === t) return n;
        }
      }, useSetter: function useSetter() {
        z = !0;
      }, useSimple: function useSimple() {
        z = !1;
      } }), c(c.S + c.F * !B, "Object", { create: function create(t, n) {
        return void 0 === n ? E(t) : H(E(t), n);
      }, defineProperty: q, defineProperties: H, getOwnPropertyDescriptor: $, getOwnPropertyNames: Z, getOwnPropertySymbols: Q }), T && c(c.S + c.F * (!B || a(function () {
      var t = _I();return "[null]" != k([t]) || "{}" != k({ a: t }) || "{}" != k(Object(t));
    })), "JSON", { stringify: function stringify(t) {
        for (var n, r, e = [t], i = 1; arguments.length > i;) {
          e.push(arguments[i++]);
        }if (r = n = e[1], (S(n) || void 0 !== t) && !K(t)) return b(n) || (n = function n(t, _n) {
          if ("function" == typeof r && (_n = r.call(this, t, _n)), !K(_n)) return _n;
        }), e[1] = n, k.apply(T, e);
      } }), _I.prototype[R] || r(13)(_I.prototype, R, _I.prototype.valueOf), h(_I, "Symbol"), h(Math, "Math", !0), h(i.JSON, "JSON", !0);
  }, function (t, n, r) {
    "use strict";
    r(325), r(323), r(322), r(321), r(320), r(319), r(318), r(317), r(316), r(315), r(314), r(313), r(312), r(311), r(310), r(309), r(307), r(306), r(305), r(304), r(303), r(302), r(301), r(300), r(299), r(298), r(297), r(296), r(295), r(294), r(293), r(292), r(291), r(290), r(289), r(288), r(287), r(286), r(285), r(284), r(283), r(282), r(281), r(280), r(279), r(278), r(277), r(276), r(275), r(274), r(273), r(272), r(271), r(270), r(269), r(268), r(267), r(266), r(265), r(264), r(263), r(262), r(261), r(260), r(259), r(258), r(257), r(256), r(255), r(254), r(253), r(252), r(251), r(250), r(249), r(248), r(247), r(245), r(244), r(242), r(241), r(240), r(239), r(238), r(237), r(236), r(234), r(233), r(232), r(231), r(230), r(229), r(228), r(227), r(226), r(225), r(224), r(223), r(222), r(68), r(221), r(220), r(106), r(219), r(218), r(217), r(216), r(215), r(103), r(101), r(100), r(214), r(213), r(212), r(211), r(210), r(209), r(208), r(207), r(206), r(205), r(204), r(203), r(202), r(201), r(200), r(199), r(198), r(197), r(196), r(195), r(194), r(193), r(192), r(191), r(190), r(189), r(188), r(187), r(186), r(185), r(184), r(183), r(182), r(181), r(180), r(179), r(178), r(177), r(176), r(175), r(174), r(173), r(172), r(171), r(170), r(169), r(168), r(167), r(166), r(165), r(164), r(163), r(162), r(161), r(160), r(159), r(158), r(157), r(156), r(155), r(154), r(153), r(152), r(151), r(150), r(149), r(148), r(147), r(146), r(145), r(144), r(143), r(142), r(141), r(140), r(139), r(138), r(137), r(136), r(135), r(134), r(133), r(132), r(131), r(130), t.exports = r(26);
  }, function (t, n, r) {
    "use strict";
    (function (t) {
      if (r(326), r(129), r(127), t._babelPolyfill) throw new Error("only one instance of babel-polyfill is allowed");t._babelPolyfill = !0;var n = "defineProperty";function e(t, r, e) {
        t[r] || Object[n](t, r, { writable: !0, configurable: !0, value: e });
      }e(String.prototype, "padLeft", "".padStart), e(String.prototype, "padRight", "".padEnd), "pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (t) {
        [][t] && e(Array, t, Function.call.bind([][t]));
      });
    }).call(this, r(90));
  }, function (t, n, r) {
    "use strict";
    (function (t) {
      Object.defineProperty(n, "__esModule", { value: !0 });var e,
          i = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (t) {
        return typeof t === "undefined" ? "undefined" : _typeof(t);
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : _typeof(t);
      };n.default = void ((e = "object" === (void 0 === t ? "undefined" : i(t)) ? t : "object" === ("undefined" == typeof window ? "undefined" : i(window)) ? window : "object" === ("undefined" == typeof self ? "undefined" : i(self)) ? self : void 0) && !e._babelPolyfill ? r(327) : console.warn("OB: Babel polyfill detected, Onbrand will not apply its own."));
    }).call(this, r(90));
  }]);
});
//# sourceMappingURL=conditional-babel-polyfill.bundle.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)(module)))

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!function (e, n) {
  "object" == ( false ? "undefined" : _typeof(exports)) && "object" == ( false ? "undefined" : _typeof(module)) ? module.exports = n() :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (n),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.onbrandUtilityFunctions = n() : e.onbrandUtilityFunctions = n();
}(window, function () {
  return function (e) {
    var n = {};function t(o) {
      if (n[o]) return n[o].exports;var i = n[o] = { i: o, l: !1, exports: {} };return e[o].call(i.exports, i, i.exports, t), i.l = !0, i.exports;
    }return t.m = e, t.c = n, t.d = function (e, n, o) {
      t.o(e, n) || Object.defineProperty(e, n, { configurable: !1, enumerable: !0, get: o });
    }, t.r = function (e) {
      Object.defineProperty(e, "__esModule", { value: !0 });
    }, t.n = function (e) {
      var n = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };return t.d(n, "a", n), n;
    }, t.o = function (e, n) {
      return Object.prototype.hasOwnProperty.call(e, n);
    }, t.p = "", t(t.s = 1);
  }([function (e, n, t) {
    "use strict";
    e.exports = function e(n) {
      !function (e, n) {
        if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
      }(this, e), this.options = Object.assign({}, { forPage: "hub-page", forPages: !1, imageUrl: "#" }, n), console.log("This is a work in progress, currently it cannot be used.");
    };
  }, function (e, n, t) {
    "use strict";
    n.Banner = t(0);var o = function o() {
      var e = "http://localhost:3000/";return "localhost" === window.self.location.hostname && (e = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ":" + window.location.port : "")), e;
    };function i(e) {
      var n,
          t,
          o = $("#injected-header"),
          i = $(".top-nav");return n = "fixed" === o.css("position") ? o.outerHeight(!0) : 0 === o.height() ? $("#injected-header>*").outerHeight(!0) : 0, t = "fixed" === i.css("position") ? i.outerHeight(!0) : 0, e || n + t;
    }n.doIfTag = function (e) {
      var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : function () {},
          t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : function () {},
          o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "";if (!$("body").hasClass("include_fe_item_tags")) return console.error("-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-"), console.error("  Onbrander: You called doIfTag, but front end tags are NOT enabled !"), console.error("-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-"), !1;$(".tile").not(o).each(function (i, r) {
        var a = r.dataset.tags,
            s = !1;return a && a.split(",").forEach(function (n) {
          n.toLowerCase() === e.toLowerCase() && (s = !0);
        }), s ? (n.call(this), $(this).addClass(o), !0) : (t.call(this), $(this).addClass(o), !0);
      });
    }, n.fixShareWidgetImproved = function () {
      var e = document.querySelectorAll("#share-main-hub li a").length,
          n = void 0,
          t = void 0,
          o = void 0;e >= 3 ? (o = 125 * (5 - e), n = -550, t = -465) : (o = 290, n = -510, t = -520), $("head").append('\n  <style id="shareWidgetFix">\n  .relativeDiv {\n      position: relative;\n      float: right;\n  }\n\n  .relativeDiv.relativeDiv--search {\n      float: left;\n  }\n\n  .relativeDiv--share:hover .share-hub {\n    display: block;\n  }\n\n  .share-hub,\n  .share-item {\n    margin: auto;\n  }\n\n  .search-drop-down {\n    position: absolute;\n  }\n\n  @media all and (min-width: 860px) {\n    .share-hub,\n    .share-item {\n      right: auto;\n      position: absolute;\n      left: ' + (-450 + o) + "% !important;\n      top: 51px !important;\n    }\n    .share-hub,\n    .share-container .share-item  {\n      width: " + 55 * e + "px !important; \n    } \n    .search-drop-down {\n      right: 0;\n      position: absolute;\n      left: -4% !important;\n      top: 55px !important;\n    }\n  }\n\n  @media all and (max-width: 860px) {\n    .share-hub,\n    .share-item {\n      right: auto;\n      position: absolute;\n      left: " + (n + o) + "% !important;\n      top: 45px !important;\n    }\n    .share-hub,\n    .share-container .share-item  {\n      width: " + 55 * e + "px !important; \n    } \n  }\n\n  @media all and (max-width: 720px) {\n    .share-hub,\n    .share-item {\n      right: auto;\n      position: absolute;\n      left: " + (t + o) + "% !important;\n      top: 45px !important;\n    }\n    .share-hub,\n    .share-container .share-item {\n      width: " + 45 * e + "px !important; \n    } \n  }\n</style>"), $(".right-side-btns").prepend('<div class="relativeDiv relativeDiv--share"><div class="insertFlag--share"></div></div>'), $("#share-main-hub").clone().insertAfter(".insertFlag--share"), $(".share-toggle").insertAfter(".insertFlag--share"), $(".right-side-btns").prepend('<div class="relativeDiv relativeDiv--search"><div class="insertFlag--search"></div></div>'), $(".search-drop-down").insertAfter(".insertFlag--search"), $(".search-container").insertAfter(".insertFlag--search");var i = $("#share-main-hub");i.style;var r = !1,
          a = function a() {
        r = !0, $(".meta-inner .share-container").length ? ($(".right-side-btns .share-hub").remove(), $(".right-side-btns .share-container").remove(), $(".meta-inner .share-container").insertAfter(".insertFlag--share").find("a.hooked").off().removeClass("hooked"), Hubs.appInstance.overrideLinks()) : $(".share-item.type-collection").length && !$("body").hasClass("hub-page") ? ($(".right-side-btns .share-hub").remove(), $(".right-side-btns .share-container").remove(), $("#hubs-container .page-aligner>.share-container").insertAfter(".insertFlag--share").find("a.hooked").off().removeClass("hooked"), Hubs.appInstance.overrideLinks()) : ($(".right-side-btns .share-hub").remove(), $(".right-side-btns .share-container").remove(), $("#share-main-hub").length ? ($("#share-main-hub").clone().insertAfter(".insertFlag--share").find("a.hooked").removeClass("hooked"), Hubs.appInstance.overrideLinks()) : (i.clone().insertAfter(".insertFlag--share").find("a.hooked").removeClass("hooked"), Hubs.appInstance.overrideLinks()));
      };return Hubs.Events.on("load", function () {
        r || a();
      }), Hubs.Events.on("pageChange", a), a;
    }, n.blockCtaFix = function () {
      var e = $(".block-cta:not(.embed-cta)");if (e.length && !$(".level-three .block-cta").length) {
        var n = $(".main"),
            t = e.height() / 2,
            o = n.offset().top,
            i = n.offset().top + n.height(),
            r = $(window).scrollTop() + $(window).height() / 2,
            a = r + t;r - t < o ? e.css({ position: "absolute", top: o, bottom: "", transform: "translate(-50%, -50%)", margin: 0 }) : a > i ? e.css({ position: "absolute", top: i - e.height() - t, transform: "translate(-50%, -50%)", margin: 0 }) : e.css({ position: "fixed", top: "50vh", bottom: "", transform: "translate(-50%, -50%)", margin: 0 });
      }
    }, n.fadeOutItem = function () {
      if ($("body").hasClass("single-page")) {
        var e = $("footer").height(),
            n = document.body.scrollHeight - $(window).height() - (e + $(window).height());$(window).scrollTop() > n ? $(".item-next-prev").fadeOut("fast") : $(".item-next-prev").fadeIn("fast");
      }
    }, n.descriptionSlideUp = function () {
      $("head").append('<style id="descriptionsSlideUp">\n  /*-- Tile Description Pop-up Hover --*/\n  #collection-items .tile .description {\n    -webkit-transition: all 0.4s ease-out;\n    transition: all 0.4s ease-out;\n  }\n  #collection-items .tile .description .long-h3 {\n    display: block !important;\n  }\n  \n  #collection-items .tile:hover .description {\n    height: 100%;\n    -webkit-transition: all 0.3s ease-out;\n    transition: all 0.3s ease-out;\n  }\n  \n  #collection-items .tile .share-single {\n    display: none;\n  }\n  </style>');
    }, n.devMode = function (e) {
      console.log(" "), console.log(" "), console.warn("-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-="), console.warn("   Hey Onbrander, Just letting you know that we're in dev mode!"), console.warn("   You have access to the following functions:", n), console.warn("   More info available here: http://cihost.uberflip.com/docs/"), console.warn("-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-="), console.log(" "), console.log(" ");var t = function t(e) {
        e.preventDefault(), Hubs.changePage(e.target.href);
      },
          i = function i(e) {
        var n = new RegExp("^((http[s]?|ftp):/)?/?([^:/s]+)?(" + e + ")", "gi");$("a").not(".onBrand--LocalDevLink").each(function () {
          var e = $(this).attr("href");if (n.test(e) || e && "/" === e.charAt(0)) {
            var o = e.replace(n, "");"/" !== o[0] ? o = "/" + o + "?onbrand" : o += "?onbrand", $(this).attr("href", o), $(this).attr("target", ""), $(this).on("click", t), $(this).addClass("onBrand--LocalDevLink");
          }
        });
      };if (false) {
        var r = o();i(e.shortHubUrl), Hubs.Config.hubBaseUrl = r, Hubs.Events.on("load", function () {
          i(e.shortHubUrl), Hubs.Config.hubBaseUrl = r;
        }), Hubs.Events.on("pageChange", function () {
          i(e.shortHubUrl), Hubs.Config.hubBaseUrl = r;
        }), Hubs.Events.on("itemsLoaded", function () {
          i(e.shortHubUrl);
        }), $(window).on("search", function () {
          setTimeout(function () {
            i(e.shortHubUrl);
          }, 500);
        });
      }
    }, n.removeClasses = function e(n, t) {
      $(t).attr("class", "").children().each(e);
    }, n.doIfTagRegex = function (e) {
      var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : function () {},
          t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : function () {},
          o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "";return e instanceof RegExp ? $("body").hasClass("include_fe_item_tags") ? void $(".tile").not(o).each(function (i, r) {
        var a = r.dataset.tags,
            s = !1,
            l = void 0;return a && a.split(",").forEach(function (n) {
          e.test(n) && (s = !0, l = n);
        }), s ? (n.call(this, l), $(this).addClass(o), !0) : (t.call(this), $(this).addClass(o), !0);
      }) : (console.error("-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-"), console.error("  Onbrander: You called doIfTag, but front end tags are NOT enabled !"), console.error("-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-"), !1) : (console.error(e + " is not a valid regular expression! Please use new RegExp() to generate one!"), !1);
    }, n.noQueryStringSafeguard = function () {
      var e = o();!new RegExp(e, "gi").test(window.location.host) || /\?onbrand/gi.test(window.location.href) || /&onbrand/gi.test(window.location.href) || console.error("It looks like you are in dev mode, but you're missing the onbrand query string.");
    }, n.helpfulClasses = function () {
      var e = ["sales-stream", "marketing-stream"];function n() {
        e.forEach(function (e) {
          return $("body").removeClass(e);
        });var n = $("#page-type-identifier").attr("data-item-type"),
            t = $("#hubs-container > div:eq(0)").attr("data-collection-type");n && ($("body").addClass(n), e.includes(n) || e.push(n)), $("body").hasClass("webpackBuild") || $("body").addClass("webpackBuild"), "targeted" === t ? $("body").addClass("sales-stream") : "custom" === t && $("body").addClass("marketing-stream");
      }Hubs.Events.on("load", n).on("pageChange", n);
    }, n.recoEnginePositioning = function (e) {
      var n = function (e) {
        try {
          var n = $(".reco-panel"),
              t = $(e).offset().top + $(e).height() - $(window).scrollTop(),
              o = t > 0 ? t : 0;n.css("top", o);
        } catch (n) {
          console.warn("recoEnginePositioning() has failed - the error thrown was:"), console.error(n), console.warn("The target used was:" + e);
        }
      }.bind($(".reco-panel"), e);Hubs.Events.on("scroll", n), Hubs.Events.on("load", n), Hubs.Events.on("pageChange", n), Hubs.Events.on("resize", n);
    }, n.sideCtaFix = function (e) {
      var n = i(e);if ($(window).width() > 1351 && $(".entry-wrapper").length) {
        var t = $(window).scrollTop(),
            o = $(".cta-item-container .cta");if (o.length > 0) {
          var r = o.height(),
              a = $(".level-three").eq(0).offset().top,
              s = $(".level-three").eq(0).offset().top + $(".level-three").height();o.css("top", a - t), t + n > a && o.css("top", n), t + n + r > s && o.css("top", s - r - t);
        }
      }
    }, n.addThisFix = function (e) {
      var n = i(e);if ($(window).width() > 980) {
        var t = $(window).scrollTop(),
            o = $(".addthis_toolbox");if (o.length > 0) {
          var r = o.height(),
              a = $(".level-three").eq(0).offset().top,
              s = $(".level-three").eq(0).offset().top + $(".level-three").height();o.css("top", a - t), t + n > a && o.css("top", n), t + n + r > s && o.css("top", s - r - t);
        }
      }
    }, n.removeTouchForLaptops = function () {
      /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) || $("html").removeClass("touch");
    }, n.overrideHubFuctions = function () {
      Hubs.Search.prototype.updateOverlaySize = function () {};
    }, n.legacyEvents = function () {
      var e = Hubs.Config.serverUrl;jQuery.each(e, function (n, t) {
        -1 === t.indexOf("/hubsFront/") && delete e[n];
      }), window.ufEvents || (window.ufEvents = [], jQuery.each(e, function (e, n) {
        var t = n,
            o = t.replace("/hubsFront/ajax_", "").replace("hubsFront/", "").replace("/", "");jQuery(document).on("ajaxSuccess", function (e, n, i) {
          if (i.url.indexOf(t) >= 0) {
            var r = new Event(o);$(this).trigger(r), console.log("%c Event Dispatched: ", "background: #0058ce; color: #FFF;padding:5px;", o);
          }
        }), window.ufEvents.push(o);
      }), jQuery(document).on("ajaxSuccess", function (e, n, t) {
        if ("GET" === t.type && -1 === t.url.indexOf("/hubsFront/") && t.url.indexOf(((i = Hubs.Config.hubBaseUrl).indexOf("://") > -1 ? i.split("/")[2] : i.split("/")[0]).split(":")[0]) > -1) {
          var o = new Event("pageChange");jQuery(this).trigger(o), console.log("%c Event Dispatched: ", "background: #0058ce; color: #FFF;padding:5px;", "pageChange:", window.location.href);
        }var i;
      }), window.ufEvents.push("pageChange"), console.log("%cUF Events Available:", "background: #ce0058; color: #FFF;padding:5px;line-height:3;font-weight:bold;", window.ufEvents.toString()));
    }, n.legacyEmbedTileFix = function () {
      !function () {
        if (-1 !== window.location.href.indexOf("?embedtile") || -1 !== window.location.href.indexOf("embed_cta")) throw $(".tile.single").css({ position: "fixed", top: 0, left: 0, zIndex: 2147483647, opacity: 1, transform: "none", "animation-name": "initial", visibility: "visible", "animation-duration": 0 }), new Error("Embed Tile Fix triggered");
      }();
    };
  }]);
});
//# sourceMappingURL=onbrandUtilityFunctions.bundle.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)(module)))

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// multi object includes the entry point and urls of each hub that uses this template
var multi = {
    en: 'resources.ecovadis.com/',
    fr: 'resources.ecovadis.com/fr',
    ce: 'customerhub.ufcontent.com/',
    de: 'resources.ecovadis.com/de',
    es: 'resources.ecovadis.com/es',
    it: 'resources.ecovadis.com/it',
    cs: 'hub.ecovadis.com/',
    enStaging: 'ecovadis-staging.ufcontent.com/',
    jp: 'resources.ecovadis.com/ja'
};

var devOptions = {
    shortHubUrl: multi.en, //change me to the base url of your hub (no http(s) or www)
    // STAGING HUB IS HTTP
    fullHubUrl: 'https://' + multi.en + '?ufcc_onbrand_local', //exact url to access hub, leave onbrand query string
    cihostFolder: 'ecovadis-multi-v1', //change me to the cihost folder name
    remindMeToGit: true,
    notifyOnBuildSuccess: true //Gives a (slightly annoying?) message whenever a build completes successfully
};

module.exports = devOptions;

/***/ }),
/* 11 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 12 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * Change blog to CTA
 * Updates privacyPolicy for Form CTAs
 * @returns {cta} adds a class to the blog tile to change it into a CTA for sales streams.
 */

var loopTiles = function loopTiles() {
    var liTags = document.querySelectorAll('.tile');
    if (liTags) {
        liTags.forEach(function (tags) {
            var dataTags = tags.dataset.tags;
            if (tags.dataset.tags !== undefined) {
                if (dataTags.indexOf('tagged-cta') !== -1) {
                    tags.classList.add('tagged-cta');
                    tags.setAttribute('id', tags.getAttribute('data-id'));
                    if (tags.querySelector('.item-link.view')) {
                        var buttonText = tags.querySelector('.description h4');
                        if (buttonText) {
                            tags.querySelector('.item-link.view').innerHTML = buttonText.innerHTML;
                        } else {
                            tags.querySelector('.item-link.view').classList.add('hide');
                        }
                    }
                }
                if (dataTags.indexOf('no-text-cta') !== -1) {
                    if (tags.querySelector('.item-link.view')) {
                        tags.querySelector('.item-link.view').classList.add('hide');
                    }
                    if (tags.querySelector('.description .h3like')) {
                        tags.querySelector('.description .h3like').classList.add('hide');
                    }
                }
            }
            var img = tags.querySelector('img');
            if (img) {
                if (/mediaproxy/.test(img.src)) {
                    var newImg = decodeURIComponent(img.src.split('url=')[1]);
                    img = newImg.split('&')[0].split('?')[0];
                    tags.querySelector('.img>img').setAttribute('src', img);
                    tags.querySelector('.img>img').classList.add('ob-raw-image');
                }
            }
        });
    }
};

exports.loopTiles = loopTiles;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var addHyperLinkToFormCtas = function addHyperLinkToFormCtas(ctaID, privacyPolicyData) {
    if (privacyPolicyData && privacyPolicyData.link && privacyPolicyData.color && privacyPolicyData.text) {
        var privacyPolicy = '\n          <div class="cta-privacy-policy">\n            <a href="' + privacyPolicyData.link + '" style="color:' + privacyPolicyData.color + '">\n            ' + privacyPolicyData.text + '\n            </a>\n          </div>\n          ';
        if (ctaID) {
            document.querySelector('.cta-form[data-cta-id="' + ctaID + '"]').querySelector('.form-fields .cta-button-container').insertAdjacentHTML('beforebegin', privacyPolicy);
        }
        /* Uberflip GWL OB-9125 start here */
        if (privacyPolicy) {
            var mobileTarget = document.querySelector('.full-screen-cta .form-fields .cta-button-container');
            if (mobileTarget) {
                mobileTarget.insertAdjacentHTML('beforebegin', privacyPolicy);
            }
        }
        /* Uberflip GWL OB-9125 end here */
    }
};

exports.addHyperLinkToFormCtas = addHyperLinkToFormCtas;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var stickyHeader = function stickyHeader() {
    var currentLang = window.currentLang;
    var windowTop = window.scrollY;
    var header = document.querySelectorAll('.injected-header .header');
    var hubnav = document.querySelector('.top-nav');
    if (header) {
        header.forEach(function (head) {
            var headerHeight = head.offsetHeight;

            var largeHeader = document.querySelector('.large-header');
            if (largeHeader) {
                var largeHeaderHeight = largeHeader ? largeHeader.offsetHeight : 0;

                if (windowTop > headerHeight) {
                    head.classList.add('fixed-header');
                    if (hubnav && $('.large-header').is(':visible')) {
                        hubnav.style.setProperty('top', '70px', 'important');
                    }
                    if (($('#stream-banner-root').is(':visible') || $('.large-header').is(':visible')) && !document.body.classList.contains('hub-page')) {
                        hubnav.style.setProperty('top', '0px', 'important');
                    } else {
                        hubnav.style.setProperty('top', '70px', 'important');
                    }
                } else {
                    head.classList.remove('fixed-header');
                }
            }
        });
    }
};

module.exports = { stickyHeader: stickyHeader };

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _require = __webpack_require__(0),
    createElem = _require.createElem;

// new method of stream sectioning, which doesn't rely on the use of blog tiles


var buildSectionHeaderTiles = function buildSectionHeaderTiles(sectionHeaderConfig) {
    // take the config item passed in, which will be an array of objects, and iterate over them
    sectionHeaderConfig.forEach(function (item, index) {
        // build an <li> element for each object
        var sectionHeaderTile = createElem('li', { class: 'tile section-header-tile', id: 'id-' + index });
        // build the text element for each object, getting the text variable from the object (which can be edited from the back of the hub)
        var sectionHeaderText = createElem('h3', { class: 'section-header-text' }, '' + item.text);
        // append the section header text to the tile element
        sectionHeaderTile.appendChild(sectionHeaderText);

        // select the tile with the ID designated in the config code block at the back of the hub
        var target = document.querySelector('#collection-items .clearfix li.tile[data-id=\'' + item.target + '\']');

        //check if element exist after clicking load more to prevent duplication
        if (!target || document.querySelector('#id-' + index)) {
            return;
        }
        // insert the section header directly before that selected tile
        target.insertAdjacentElement('beforebegin', sectionHeaderTile);
    });
};

var initSectionHeaderTiles = function initSectionHeaderTiles() {
    // return early if the correct obData doesn't exist, or if we're not on a stream level page
    if (!window.obData || !window.obData.sectionHeaderTiles || !document.body.classList.contains('listing-page')) {
        return;
    }

    // assign the stream section config object on the window to a variable
    var sectionHeaderConfig = window.obData.sectionHeaderTiles;
    // get the current stream ID
    var streamId = document.querySelector('#page-type-identifier').dataset.collectionId;
    // create an array of keys from the sectionHeaderConfig object, which represent the IDs of streams that will be sectioned
    var sectionHeaderStreams = Object.keys(sectionHeaderConfig);

    // check if the array of stream IDs includes the ID of the current stream, and if so, run the code
    if (sectionHeaderStreams.includes(streamId)) {
        // call the function to build the section headers, passing in the config object for the current stream
        buildSectionHeaderTiles(sectionHeaderConfig[streamId]);
    }
};

exports.initSectionHeaderTiles = initSectionHeaderTiles;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var moveFlipbookButtons = function moveFlipbookButtons() {
    var body = document.body;

    if (body.classList.contains('uberflip')) {
        var controls = body.querySelector('.fullscreen-controls.underneath');
        var embedWrapper = body.querySelector('.single-uberflip');
        if (controls && embedWrapper) {
            embedWrapper.insertAdjacentElement('afterbegin', controls);
        }
    }
};

var flipbook = function flipbook() {
    moveFlipbookButtons();
};

module.exports = flipbook;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(0),
    createElem = _require.createElem;

var getTiles = __webpack_require__(4);

var Sidebar = function () {
    function Sidebar(filterData) {
        _classCallCheck(this, Sidebar);

        this.filterData = filterData;
    }

    _createClass(Sidebar, [{
        key: 'getFilterItemHtml',
        value: function getFilterItemHtml(filterTitle, filterOpt) {

            var checkboxValue = filterOpt.value;
            var checkboxLabel = filterOpt.title;

            var item = createElem('li', { class: 'boxclass' });
            var input = createElem('input', { type: 'checkbox', id: checkboxLabel, name: filterTitle, value: checkboxValue });
            var label = createElem('label', { for: checkboxLabel }, checkboxLabel);

            item.appendChild(input);
            item.appendChild(label);

            return item;
        }
    }, {
        key: 'getCategoryHtml',
        value: function getCategoryHtml(filterTitle, filterOptions) {
            console.log(filterTitle, 'kkk');

            var updatedilterTitle = filterTitle.replace(':', ' ');
            var dropdownLabel = filterTitle.replace("Browse by ", "").replace(":", "");
            var fieldset = createElem('fieldset', { class: 'filter-category', id: 'onBrand__filter--' + updatedilterTitle });
            var legend = createElem('legend', { class: 'onbrand__filter--title' }, updatedilterTitle);
            var categoryLabel = createElem('div', { id: 'onbrand__filter--select', class: 'onbrand__filter--select' });
            var spanTitle = createElem('span', { id: 'filter-title' }, 'Select: ' + dropdownLabel);
            var spanClose = createElem('span', { class: 'close_dropdown' });
            var svgDropdown = '<svg class=\'filter_dropdownSvg\' xmlns="http://www.w3.org/2000/svg" width="10" height="6" viewBox="0 0 10 6"><path fill="#4A4A49" fill-rule="evenodd" d="M1.052.175L4.994 4.34 8.96.175c.523-.562 1.416.36.871.923l-4.465 4.75c-.196.203-.523.203-.697 0l-4.51-4.75c-.522-.562.37-1.485.894-.923z"></path></svg>';
            var svgClose = '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10"><path fill="none" stroke="#4A4A49" stroke-linecap="round" stroke-width="2" d="M8.495 1.077L1.077 8.495m0-7.418l7.418 7.418"></path></svg>';

            var filterList = createElem('ul', { class: 'onBrand__filter--dropdown', role: 'menu', 'aria-label': updatedilterTitle });
            spanClose.insertAdjacentHTML('beforeend', svgClose);
            categoryLabel.appendChild(spanTitle);
            // categoryLabel.appendChild(svgDropdown);
            categoryLabel.appendChild(spanClose);
            categoryLabel.insertAdjacentHTML('beforeend', svgDropdown);

            fieldset.appendChild(legend);
            fieldset.appendChild(categoryLabel);
            fieldset.appendChild(filterList);

            for (var i = 0; i < filterOptions.length; i++) {
                var filterItem = this.getFilterItemHtml(filterTitle, filterOptions[i]);
                filterList.appendChild(filterItem);
            }

            return fieldset;
        }
    }, {
        key: 'getFormHtml',
        value: function getFormHtml() {
            var divWrapper = createElem('div', { id: 'onBrand__filter-wrapper' });
            var divelem = createElem('div', { class: 'filter-box' });
            var form = createElem('form', { id: 'onBrand__filter--form' });
            var resetDiv = createElem('div', { class: 'reset-button' });
            var resetBtn = createElem('button', { class: 'reset', type: 'button' }, 'Reset');

            resetDiv.appendChild(resetBtn);

            for (var filter in this.filterData) {
                var filterCategory = this.getCategoryHtml(filter, this.filterData[filter]);
                form.appendChild(filterCategory);
            }
            console.log(this.filterData, document.querySelectorAll('.collection-items-container li').length, 'filyger');

            form.appendChild(resetDiv);
            divelem.appendChild(form);
            divWrapper.appendChild(divelem);
            form.style.display = 'none';
            return divWrapper;
        }
    }, {
        key: 'attatchEvents',
        value: function attatchEvents(handleCheckboxChange) {
            var checkboxInputs = [].concat(_toConsumableArray(document.querySelectorAll('#onBrand__filter--form input[type=checkbox]')));
            for (var i = 0; i < checkboxInputs.length; i++) {
                checkboxInputs[i].addEventListener('change', handleCheckboxChange);
            }

            return this;
        }
    }, {
        key: 'init',
        value: function init() {
            var target = document.querySelector('.page-aligner .description-block');
            if (!target) {
                throw new ReferenceError('Could not attach sidebar!');
            }

            document.querySelector('body').classList.add('onBrand__filter');
            target.insertAdjacentElement('afterend', this.getFormHtml());

            var checkboxInputs = [].concat(_toConsumableArray(document.querySelectorAll('#onBrand__filter--form input[type=checkbox]')));

            var divelem = document.querySelector('div .filter-box');
            var checkboxValue = Math.round(checkboxInputs.length / 4);
            if (checkboxInputs.length > 4) {
                //changes GWL OB-6891
                // divelem.style.height = "680px";
                if (checkboxValue > 2) {
                    // eslint-disable-next-line no-mixed-operators
                    // divelem.style.height = checkboxValue * 330 - 250 + 'px';
                }
            } else {
                    // divelem.style.height = "330px";
                }
            if (checkboxInputs.length > 18) {
                divelem.style.overflowY = 'visible';
            }
            getTiles();

            return this;
        }
    }]);

    return Sidebar;
}();

module.exports = Sidebar;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/* Uberflip GWL OB-6702 start here */
function filterTileAnim() {
    var liTags = document.querySelectorAll('#collection-items .tile');
    if (liTags) {
        liTags.forEach(function (item) {
            item.classList.add('animated');
        });
    }
    var filterBox = document.querySelectorAll('#collection-items .filter-box');
    if (filterBox) {
        filterBox.forEach(function (box) {
            box.classList.add('animated');
        });
    }
}
exports.filterTileAnim = filterTileAnim;
/* Uberflip GWL OB-6702 end here */

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/* Uberflip GWL OB-7505 start here */
function languageSelector() {
    var selector = document.querySelector('#top-header .locale-selector ');
    var navBar = document.querySelector('#top-header .left-nav');

    if (selector && navBar) {
        navBar.insertAdjacentElement('afterend', selector);
    }
}
exports.languageSelector = languageSelector;
/* Uberflip GWL OB-7505 end here */

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
function languageLabelUpdates() {
    var localSelectors = document.querySelectorAll('.locale-selector a');
    if (localSelectors) {
        localSelectors.forEach(function (selector) {
            var oldVal = selector.innerHTML;
            var newVal = void 0;
            if (oldVal.includes('English (US)')) {
                newVal = oldVal.replace("English (US)", "EN");
                selector.innerHTML = newVal;
            } else if (oldVal.includes('Français')) {
                newVal = oldVal.replace("Français", "FR");
                selector.innerHTML = newVal;
            } else if (oldVal.includes('Italiano')) {
                newVal = oldVal.replace("Italiano", "IT");
                selector.innerHTML = newVal;
            } else if (oldVal.includes('Deutsch (Deutschland)')) {
                newVal = oldVal.replace("Deutsch (Deutschland)", "DE");
                selector.innerHTML = newVal;
            } else if (oldVal.includes('Español (España)')) {
                newVal = oldVal.replace("Español (España)", "ES");
                selector.innerHTML = newVal;
            } else if (oldVal.includes('Spanish')) {
                newVal = oldVal.replace("Spanish", "ES");
                selector.innerHTML = newVal;
            } else if (oldVal.includes('German')) {
                newVal = oldVal.replace("German", "DE");
                selector.innerHTML = newVal;
            } else if (oldVal.includes('Italian')) {
                newVal = oldVal.replace("Italian", "IT");
                selector.innerHTML = newVal;
            }
        });
    }
}

exports.languageLabelUpdates = languageLabelUpdates;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function handlehubnav() {
  var header = document.querySelector('.injected-header .fixed-header');
  var hubnav = document.querySelector('.top-nav');
  if (hubnav && hubnav.classList.contains('top-nav-fixed')) {
    if (header) {
      hubnav.style.setProperty('top', '70px', 'important');
    } else {
      hubnav.style.setProperty('top', '100px', 'important');
    }
  } else if (hubnav && !hubnav.classList.contains('top-nav-fixed')) {
    hubnav.style.setProperty('top', '0px', 'important');
  }
}

function localselector() {
  if (document.querySelector('.current-locale')) {
    document.querySelector('.current-locale').addEventListener('click', function (e) {
      document.querySelector('.current-locale').parentNode.classList.toggle('hover');
    });
  }
}

function hubnavClose() {
  var close = document.querySelector('.exit');
  var hubnav = document.querySelector('.top-nav');
  if (close && hubnav) {
    close.addEventListener('click', function () {
      hubnav.style.setProperty('top', '0px', 'important');
    });
  }
}

function hideNav() {
  if (!window.obData || !window.obData.hideStreamNav) {
    return;
  }
  var streampage = document.querySelector('.listing-page');
  var itempage = document.querySelector('.single-page');
  if (streampage || itempage) {
    var streamPageID = document.getElementById('page-type-identifier').dataset.collectionId;
    if (streamPageID) {
      var config = window.obData.hideStreamNav;
      var hubnav = document.querySelector('.top-nav');
      if (config.includes(streamPageID) && hubnav) {
        document.body.classList.add('no-hubnav');
        hubnav.style.display = 'none';
      }
    }
  }
}

exports.handlehubnav = handlehubnav;
exports.localselector = localselector;
exports.hubnavClose = hubnavClose;
exports.hideNav = hideNav;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _require = __webpack_require__(0),
    createElem = _require.createElem;

var hideHeaderMenu = exports.hideHeaderMenu = function hideHeaderMenu(translations) {
  if (!window.obData || !window.obData.noHeaderMenuStreams) {
    return;
  }

  var streamIDs = window.obData.noHeaderMenuStreams;
  var currentStream = document.querySelector('body').classList[1];

  if (streamIDs.includes(currentStream)) {
    // add class to apply specific CSS (_languageSelector.scss)
    document.querySelector('body').classList.add('header-menu-hidden');

    // header items
    var headerMenu = document.querySelector('#injected-header .main-menu');
    // header local selector, buttons
    var headerRight = document.querySelector('#injected-header .header-right');

    if (headerMenu && headerRight) {
      headerMenu.style.display = 'none';
      headerRight.style.display = 'none';
    }

    var headerLogo = document.querySelector('.site-logo');

    // create homelink

    var newHref = window.location.href;
    var hubID = Hubs.appInstance.ufaCaller.hubId;

    // english hub (no subdirectory vs subdirectory)
    if (hubID === '86270') {
      newHref = newHref.substring(0, 30);
    } else if (hubID === '132028') {
      newHref = window.location.origin;
    } else {
      newHref = newHref.substring(0, 33);
    }

    var homeLILocaleContainer = createElem('div', {
      class: 'home-li-container'
    });

    var homeLI = createElem('li', {
      class: 'home-link-li'
    });

    var homeLink = createElem('a', {
      class: 'home-link',
      href: newHref
    }, translations.home);

    homeLI.append(homeLink);

    homeLILocaleContainer.append(homeLI);

    if (headerLogo) {
      headerLogo.insertAdjacentElement('afterend', homeLILocaleContainer);
    }

    // move hub nav local selector
    var hubNavLocaleSelector = document.querySelector('.locale-selector');

    if (hubNavLocaleSelector) {
      homeLI.insertAdjacentElement('afterend', hubNavLocaleSelector);
    }
  }
};

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/* Uberflip GWL OB-9717 start here */
function changeText() {
    var twitterLink = document.querySelector('.author-bio-link.uf-author-twitter');
    if (twitterLink) {
        var currentText = twitterLink.innerText;
        var newText = currentText.replace("Twitter", "X");
        twitterLink.innerText = newText;
    }
}
exports.changeText = changeText;
/* Uberflip GWL OB-9717 end here */

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
// Uberflip GWL OB-9893 start here
function changeDateTime() {
    var month = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    var dateTime = document.querySelector('.single-page .meta-inner .date');
    if (dateTime) {
        var dateValue = dateTime.innerText;
        if (dateValue) {
            var mydate = new Date(dateValue);
            var dateFormat = month[mydate.getMonth()] + ' ' + mydate.getFullYear();
            dateTime.innerHTML = dateFormat;
        }
    }
}
exports.changeDateTime = changeDateTime;
// Uberflip GWL OB-9893 end here

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.handleFilterChange = undefined;

var _getTiles = __webpack_require__(4);

var _getTiles2 = _interopRequireDefault(_getTiles);

var _handleFiltering = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Uberflip Outsource OB-10258 start here
var handleFilterChange = function handleFilterChange() {
    var ulContainer = document.querySelector('#onBrand__filter--form .onBrand__filter--dropdown');
    if (ulContainer) {
        ulContainer.addEventListener('click', function (e) {
            return e.stopPropagation();
        });
    }

    var handleDropdownChange = function handleDropdownChange(e) {
        var target = e.target;

        // If the clicked target is the filter-remove button, exit the event listener

        if (target.classList.contains('filter-remove')) {
            return;
        }

        // Determine the parent of the target
        var targetParent = target.parentElement.classList.contains('filter-category') ? target.parentElement : target.parentElement.parentElement;

        var targetDropdown = targetParent.querySelector('.onBrand__filter--dropdown');
        var activeDropdowns = document.querySelector('.filter-category.active');

        // If an active dropdown exists and the target parent is the same, toggle it
        if (activeDropdowns !== null && targetParent === activeDropdowns) {
            targetParent.classList.toggle('active');
            $(targetDropdown).slideToggle(300);
        } else if (activeDropdowns !== null) {
            // Close the currently active dropdown, then open the clicked one
            var toBeToggled = activeDropdowns.querySelector('.onBrand__filter--dropdown');
            if (toBeToggled) {
                activeDropdowns.classList.remove('active');
                $(toBeToggled).slideToggle(300);
                setTimeout(function () {
                    targetParent.classList.toggle('active');
                    $(targetDropdown).slideToggle(300);
                }, 300);
            }
        } else {
            // No active dropdown, just open the clicked one
            targetParent.classList.toggle('active');
            $(targetDropdown).slideToggle(300);
        }
    };
    var dropdown = document.querySelectorAll('#onBrand__filter-wrapper #onBrand__filter--form #filter-title');
    dropdown.forEach(function (filter) {
        filter.parentElement.addEventListener('click', function (e) {
            return handleDropdownChange(e);
        });
    });

    // Close the dropdown if the user clicks outside of any active filter category
    document.addEventListener('click', function (event) {
        var activeDropdown = document.querySelector('.filter-category.active');

        // If the click is outside the active dropdown, close it
        if (activeDropdown && !activeDropdown.contains(event.target)) {
            activeDropdown.classList.remove('active');
            var dropdownToClose = activeDropdown.querySelector('.onBrand__filter--dropdown');
            if (dropdownToClose) {
                $(dropdownToClose).slideUp(300); // Close the dropdown with a slide-up animation
            }
        }
    });

    var closeDropdown = document.querySelectorAll('span.close_dropdown');
    if (closeDropdown) {
        closeDropdown.forEach(function (closeIcon) {
            closeIcon.addEventListener('click', function (e) {
                e.preventDefault();
                var selected = closeIcon.parentElement.parentElement.querySelectorAll('input[type="checkbox"]:checked');
                if (selected) {
                    selected.forEach(function (input) {
                        input.checked = false;
                    });
                    (0, _handleFiltering.handleCheckboxChange)();
                }
                var activeDropdown = document.querySelector('.filter-category.active');

                // If the click is outside the active dropdown, close it
                if (activeDropdown) {
                    activeDropdown.classList.remove('active');
                    var dropdownToClose = activeDropdown.querySelector('.onBrand__filter--dropdown');
                    if (dropdownToClose) {
                        $(dropdownToClose).slideUp(300); // Close the dropdown with a slide-up animation
                    }
                }
            });
        });
    }
    var resetButton = document.querySelector('.reset-button');
    if (resetButton) {
        resetButton.onclick = function (event) {
            event.preventDefault();
            $('#onBrand__filter--form input[type="checkbox"]').each(function () {
                $(this).prop('checked', false);
            });
            (0, _handleFiltering.handleCheckboxChange)();
            (0, _getTiles2.default)(this.translations);
        };
    }
};

exports.handleFilterChange = handleFilterChange;

// Uberflip Outsource OB-10258 end here

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
// Uberflip Outsource OB-10330 start here
var handleDescriptionPositioning = function handleDescriptionPositioning() {
    setTimeout(function () {
        if (!window.obData || !window.obData.bLDescriptionStreams) {
            return;
        }

        if (window.obData.bLDescriptionStreams) {

            var body = document.querySelector('body').classList;
            var streamPageID = document.getElementById('page-type-identifier').dataset.collectionId;

            if (body.contains('uf-stream-template-banner') && window.obData.bLDescriptionStreams.includes(streamPageID)) {

                var descriptionBlock = document.querySelector('.page-aligner .description-block p');
                var heading = document.querySelector('.stream-banner-heading');
                var bannerContent = document.querySelector('#top-header .stream-banner-content');

                if (heading && descriptionBlock && bannerContent) {
                    var headingColor = window.getComputedStyle(heading).color;
                    descriptionBlock.style.color = headingColor;
                    bannerContent.appendChild(descriptionBlock);
                    descriptionBlock.classList.add('stream-banner-description');
                }
            }
        }
    }, 2);
};

exports.handleDescriptionPositioning = handleDescriptionPositioning;
// Uberflip Outsource OB-10330 end here

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// eslint-disable
var _require = __webpack_require__(29),
    handleHeader = _require.handleHeader;

// Find the two letter lang code for the selected lang

var normalizeLang = function normalizeLang(lang) {
    var langClass = void 0;

    switch (lang) {
        case 'English – US':
            langClass = 'us';
            break;
        case 'Deutsch':
            langClass = 'de';
            break;
        case 'Portuguese':
            langClass = 'pt';
            break;
        case '简体中文':
            langClass = 'cn';
            break;
        case 'Français':
            langClass = 'fr';
            break;
        case 'Italiano':
            langClass = 'it';
            break;
        case 'Русский':
            langClass = 'ru';
            break;
        case 'Nederlands':
            langClass = 'nl';
            break;
        case '日本語':
            langClass = 'jp';
            break;
        case 'Español':
            langClass = 'es';
            break;
        default:
            langClass = 'en';
            break;
    }

    return langClass;
};
var bindLangToggleSetDefault = function bindLangToggleSetDefault(defaultLang) {
    document.querySelector('body').classList.add('ob-lang-' + normalizeLang(defaultLang));
    window.currentLang = normalizeLang(defaultLang);
    if (document.querySelector('meta[name="uberflip:hub_id"]')) {
        var hubId = document.querySelector('meta[name="uberflip:hub_id"]').content;
        /* Uberflip GWL OB-9206 start here */
        if (hubId !== '130690') {
            handleHeader(window.currentLang);
        }
        /* Uberflip GWL OB-9206 end here */
    }
};

module.exports = { bindLangToggleSetDefault: bindLangToggleSetDefault };

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var handleHeader = function handleHeader(defaultLang) {
    /* Uberflip GWL OB-8079 start here */

    // if (!document.querySelector('.wglanguage-name')) {
    //     return;
    // }
    /* Uberflip GWL OB-8079 end here */
    // const langTest = document.querySelector('.wglanguage-name').innerHTML;
    var lang = defaultLang;

    setTimeout(function () {

        if (document.body.classList.contains('jpheader')) {
            lang = 'jp';
        }

        if (document.body.classList.contains('ptheader')) {
            lang = 'pt';
        }

        if (document.body.classList.contains('ruheader')) {
            lang = 'ru';
        }

        var countrySelector = document.querySelector('.injected-header.' + lang.toLowerCase() + ' .country-selector');
        var countrySelectorBtn = countrySelector.querySelector('.wgcurrent');
        var countrySelectorDropdown = countrySelector.querySelector('.languages-dropdown');

        // mobile
        var mobileButtonToggle = document.querySelector('.injected-header .header-right .menu-toggle');
        var mobileMenuOverlay = document.querySelector('.injected-header .menu-wrapper');

        function closeLangMenu() {
            if (countrySelector) {
                countrySelector.classList.remove('open');
            }
            if (countrySelectorDropdown) {
                countrySelectorDropdown.classList.remove('open');
            }
        }

        function closeMobileMenu() {
            if (mobileButtonToggle) {
                mobileButtonToggle.classList.remove('open');
            }
            if (mobileMenuOverlay) {
                mobileMenuOverlay.classList.remove('open');
            }
        }

        // *******************
        // ** mobile corp nav
        // *******************

        // overlay toggle on mobile
        function mobileToggle() {
            var body = document.querySelector('body');
            if (mobileButtonToggle) {
                mobileButtonToggle.addEventListener('click', function () {
                    if (!mobileButtonToggle.classList.contains('open')) {
                        mobileButtonToggle.classList.add('open');
                        if (mobileMenuOverlay) {

                            mobileMenuOverlay.classList.add('open');
                        }
                        body.classList.add('overflow-hidden');
                        closeLangMenu(); // close language options if open
                    } else {
                        mobileButtonToggle.classList.remove('open');
                        if (mobileMenuOverlay) {
                            mobileMenuOverlay.classList.remove('open');
                        }
                        body.classList.remove('overflow-hidden');
                    }
                });
            }
        }

        // language
        function langToggle() {
            var body = document.querySelector('body');
            if (countrySelectorBtn) {
                countrySelectorBtn.addEventListener('click', function (e) {
                    e.preventDefault();
                    if (countrySelector) {
                        if (!countrySelector.classList.contains('open')) {
                            countrySelector.classList.add('open');
                            if (window.outerWidth <= 1091) {
                                body.classList.add('overflow-hidden');
                            }
                            if (countrySelectorDropdown) {
                                countrySelectorDropdown.classList.add('open');
                            }
                            closeMobileMenu(); // close mobile overlay if open
                        } else {
                            countrySelector.classList.remove('open');
                            if (window.outerWidth <= 1091) {
                                body.classList.remove('overflow-hidden');
                            }
                            if (countrySelectorDropdown) {
                                countrySelectorDropdown.classList.remove('open');
                            }
                        }
                    }
                });
            }
        }

        // *******************
        // ** desktop corp nav
        // *******************
        var submenuDropdowns = [].concat(_toConsumableArray(document.querySelectorAll('.injected-header .header .main-menu > li > ul')));
        var thirdlevelDropdowns = [].concat(_toConsumableArray(document.querySelectorAll('.injected-header .header .main-menu > li > ul ul.dropdown-menu')));
        /* Uberflip GWL OB-9117 start here */
        function closeAllSubmenu() {
            if (submenuDropdowns) {
                for (var i = 0; i < submenuDropdowns.length; i++) {
                    var parentElem = submenuDropdowns[i].parentElement;
                    submenuDropdowns[i].classList.remove('open');
                    if (parentElem) {
                        parentElem.classList.remove('open');
                    }
                }
            }
            if (thirdlevelDropdowns) {
                for (var _i = 0; _i < thirdlevelDropdowns.length; _i++) {
                    var _parentElem = thirdlevelDropdowns[_i].parentElement;
                    thirdlevelDropdowns[_i].classList.remove('open');
                    if (_parentElem) {
                        _parentElem.classList.remove('open');
                    }
                }
            }
        }
        /* Uberflip GWL OB-9117 end here */

        /* Uberflip GWL OB-9871 start here */
        function toggleSubmenu() {
            if (submenuDropdowns) {
                submenuDropdowns.forEach(function (submenuDropdown) {
                    var parentMenuItem = submenuDropdown.parentElement;

                    parentMenuItem.addEventListener('click', function (e) {
                        e.stopPropagation();
                        var clickedItem = this;
                        var clickedItemSubmenu = this.querySelector('.dropdown-menu');

                        if (clickedItem) {
                            if (!clickedItem.classList.contains('open') && e.target.parentElement === clickedItem) {
                                closeAllSubmenu();
                                clickedItem.classList.add('open');
                                if (clickedItemSubmenu) {
                                    clickedItemSubmenu.classList.add('open');
                                }
                            } else if (clickedItem.classList.contains('open') && e.target.parentElement === clickedItem) {
                                clickedItem.classList.remove('open');
                                if (clickedItemSubmenu) {
                                    clickedItemSubmenu.classList.remove('open');
                                }
                            }
                        }
                    });

                    // toggle SubSubmenu
                    var currentlyOpenItem = null;

                    var handleClickEvent = function handleClickEvent(e) {
                        var clickedItem = this;
                        var clickedItemSubmenu = this.querySelector('.dropdown-menu');

                        if (currentlyOpenItem && currentlyOpenItem !== clickedItem) {
                            currentlyOpenItem.classList.remove('open');
                            var prevSubmenu = currentlyOpenItem.querySelector('.dropdown-menu');
                            if (prevSubmenu) {
                                prevSubmenu.classList.remove('open');
                            }
                        }

                        if (clickedItem) {
                            if (!clickedItem.classList.contains('open')) {
                                clickedItem.classList.add('open');
                                if (clickedItemSubmenu) {
                                    clickedItemSubmenu.classList.add('open');
                                }
                            } else {
                                clickedItem.classList.remove('open');
                                if (clickedItemSubmenu) {
                                    clickedItemSubmenu.classList.remove('open');
                                }
                            }
                        }

                        currentlyOpenItem = clickedItem;
                    };

                    var subSubmenuLi = [].concat(_toConsumableArray(submenuDropdown.querySelectorAll('.menu-item-has-children')));

                    if (subSubmenuLi && subSubmenuLi.length > 0) {
                        subSubmenuLi.forEach(function (subSubmenuItem) {
                            subSubmenuItem.addEventListener('click', handleClickEvent);
                        });
                    }
                });
            }
        }
        /* Uberflip GWL OB-9871 end here */

        // close submenu on when clicked anywhere but menu-items
        function closeSubmenuBodyClick() {
            var body = document.querySelector('body');
            body.addEventListener('click', function (e) {
                if (!this.classList.contains('menu-item')) {
                    closeAllSubmenu();
                }
            });
        }

        function init() {
            langToggle();
            toggleSubmenu();
            closeSubmenuBodyClick();
            mobileToggle();
        }

        init();
    }, 200);
};

module.exports = { handleHeader: handleHeader };

/***/ }),
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(51);
var hubSpecificJS = __webpack_require__(52);
var onbrandScripts = __webpack_require__(7);

//only use if there are descrepencies between different language sites.
var generateLinks = function generateLinks(arr) {
  return arr.map(function (link) {
    return '<a href="' + link.href + '" id="' + link.id + '">' + link.label + '</a>';
  }).join('');
};

var translations = {
  header: {},
  footer: {},
  home: "Home"
};

hubSpecificJS();
onbrandScripts.initOnbrand(translations, true);

/***/ }),
/* 51 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(28),
    bindLangToggleSetDefault = _require.bindLangToggleSetDefault;
// const htmlHeader = require('../../includes/header.html');


module.exports = function italianPartial() {
    // custom Hub functions

    var italianLoaded = false;
    // document.querySelector('body').insertAdjacentHTML('afterbegin', htmlHeader());
    Hubs.Events.on('load', function () {
        if (!italianLoaded) {

            // Call all on load functions here
            bindLangToggleSetDefault('Italiano');
            italianLoaded = true;
        }
    }).on('itemsLoaded', function (itemIds, selectors) {
        // Call all itemsLoaded events here

    }).on('resize', function () {
        // Call all resize events here
        // bindLangToggleSetDefault('Italiano');
    }).on('scroll', function () {
        // Call all scroll events here
    }).on('ctaActivate', function (ctaId) {
        // Call all ctaActivate events here
    }).on('ctaFormSubmitSuccess', function (ctaId, mappedData, ctaName) {
        // Call all ctaFormSubmitSuccess events here
    });
};

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// it/it.bundle.js